
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("97CWy", function(module, exports) {

var $fT7Fj = parcelRequire("fT7Fj");


var $zBSTr = parcelRequire("zBSTr");


var $2jzwX = parcelRequire("2jzwX");


var $aPdNQ = parcelRequire("aPdNQ");

function $c5a7138b7add57b2$export$a9d25ff08f358d72(schema, map) {
    return Object.keys(map).reduce((newMap, key)=>{
        const value = map[key];
        const block = value.block || value.node;
        const mark = value.mark;
        if (block && schema.nodes[block] || mark && schema.marks[mark]) newMap[key] = value;
        return newMap;
    }, {});
}
const $c5a7138b7add57b2$export$b535e2638dcce02 = {
    nodes: {
        blockquote: 'blockquote',
        paragraph: 'paragraph',
        rule: 'hr',
        // lheading (---, ===)
        heading: [
            'heading',
            'lheading'
        ],
        codeBlock: [
            'code',
            'fence'
        ],
        listItem: 'list',
        image: 'image'
    },
    marks: {
        em: 'emphasis',
        strong: 'text',
        link: [
            'link',
            'autolink',
            'reference',
            'linkify'
        ],
        strike: 'strikethrough',
        code: 'backticks'
    }
};
const $c5a7138b7add57b2$export$8f853a1c35ed8bbe = (extendMarkdownSupport)=>({
        blockquote: {
            block: 'blockquote'
        },
        paragraph: {
            block: 'paragraph'
        },
        em: {
            mark: 'em'
        },
        strong: {
            mark: 'strong'
        },
        link: {
            mark: 'link',
            attrs: (tok)=>{
                // @ts-expect-error
                if (tok.pmAttrs) // @ts-expect-error
                return tok.pmAttrs;
                else return {
                    href: tok.attrGet('href'),
                    title: tok.attrGet('title') || null
                };
            }
        },
        hr: {
            node: 'rule'
        },
        heading: {
            block: 'heading',
            attrs: (tok)=>({
                    level: +tok.tag.slice(1)
                })
        },
        softbreak: {
            node: 'hardBreak'
        },
        hardbreak: {
            node: 'hardBreak'
        },
        code_block: {
            block: 'codeBlock'
        },
        list_item: {
            block: 'listItem'
        },
        bullet_list: {
            block: 'bulletList'
        },
        ordered_list: {
            block: 'orderedList',
            attrs: (tok)=>({
                    order: typeof tok.attrGet('start') === 'number' ? tok.attrGet('start') : 1
                })
        },
        code_inline: {
            mark: 'code'
        },
        code: {
            mark: 'code'
        },
        fence: {
            block: 'codeBlock',
            // we trim any whitespaces around language definition
            attrs: (tok)=>({
                    language: tok.info && tok.info.trim() || null
                })
        },
        mediaInline: {
            node: 'mediaInline',
            attrs: (token)=>{
                if (extendMarkdownSupport) // @ts-expect-error
                return token.pmAttrs;
                return {};
            }
        },
        media_single: {
            block: 'mediaSingle',
            attrs: (token)=>{
                if (extendMarkdownSupport) // @ts-expect-error
                return token.pmAttrs;
                return {};
            }
        },
        media: {
            node: 'media',
            attrs: (token)=>{
                // When token.pmAttrs is missing it means it's an external image.
                // @ts-expect-error
                if (token.pmAttrs) // @ts-expect-error
                return token.pmAttrs;
                return {
                    url: token.attrGet('url'),
                    type: 'external'
                };
            }
        },
        caption: {
            block: 'caption',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        alignment: {
            mark: 'alignment',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        breakout: {
            mark: 'breakout',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        border: {
            mark: 'border',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        textColor: {
            mark: 'textColor',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        underline: {
            mark: 'underline',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        subsup: {
            mark: 'subsup',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        emoji: {
            node: 'emoji',
            attrs: (token)=>{
                if (extendMarkdownSupport) // @ts-expect-error
                return token.pmAttrs;
                return {
                    shortName: `:${token.markup}:`,
                    text: token.content
                };
            }
        },
        inlineCard: {
            node: 'inlineCard',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        date: {
            node: 'date',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        status: {
            node: 'status',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        mention: {
            node: 'mention',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        placeholder: {
            node: 'placeholder',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        table: {
            block: 'table',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        tr: {
            block: 'tableRow',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        th: {
            block: 'tableHeader',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        td: {
            block: 'tableCell',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        s: {
            mark: 'strike'
        },
        strike: {
            mark: 'strike'
        },
        task_list: {
            block: 'taskList'
        },
        task_item: {
            block: 'taskItem',
            attrs: (tok)=>({
                    state: tok.meta
                })
        },
        layoutSection: {
            block: 'layoutSection',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        layoutColumn: {
            block: 'layoutColumn',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        panel: {
            block: 'panel',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        decisionList: {
            block: 'decisionList',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        decisionItem: {
            block: 'decisionItem',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        expand: {
            block: 'expand',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        extension: {
            node: 'extension',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        bodiedExtension: {
            block: 'bodiedExtension',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        nestedExpand: {
            block: 'nestedExpand',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        inlineExtension: {
            node: 'inlineExtension',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        }
    });


const $347ba1e2d3b8b47a$var$captionOpen = 'caption_open';
const $347ba1e2d3b8b47a$var$paragraphOpen = 'paragraph_open';
const $347ba1e2d3b8b47a$var$paragraphClose = 'paragraph_close';
function $347ba1e2d3b8b47a$export$eee367902819022(index, tokens) {
    // make sure we have an opening and closing paragraph token
    if (tokens[index]?.type !== $347ba1e2d3b8b47a$var$paragraphOpen && tokens[index + 2]?.type !== $347ba1e2d3b8b47a$var$paragraphClose) return;
    // remove the closing paragraph token from state.tokens so we don't add it into the acc
    // when we loop through the tokens
    tokens[index + 2]?.type === $347ba1e2d3b8b47a$var$paragraphClose && tokens.splice(index + 2, 1);
    // return empty to prevent adding the opening token to the acc
    return;
}
function $347ba1e2d3b8b47a$export$2e2bcd8739ae039(md, idMap) {
    md.core.ruler.after('custom-block', 'caption', function(state) {
        state.tokens = state.tokens.reduce((acc, token, index)=>{
            const { type: type } = token;
            const isWithinCaption = acc[acc.length - 1]?.type === $347ba1e2d3b8b47a$var$captionOpen;
            if (type === $347ba1e2d3b8b47a$var$paragraphOpen && isWithinCaption) /**
				 * paragraph_open and paragraph_close tokens get automatically added by markdown-it
				 * around text content. caption nodes do not allow paragraph nodes as children
				 * so we need to prevent these tokens from being added to the acc
				 */ $347ba1e2d3b8b47a$export$eee367902819022(index, state.tokens);
            else acc.push(token);
            return acc;
        }, []);
    });
}


// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $6076957fd7cd32c6$var$CITATION_REGEXP = /^\[\^[^\^]+\^]/;
function $6076957fd7cd32c6$export$2e2bcd8739ae039(md) {
    md.inline.ruler.before('text', 'citation', function(state, silent) {
        const str = state.src.slice(state.pos);
        /**
		 * Matches the following:
		 * [^00^]
		 */ const match = $6076957fd7cd32c6$var$CITATION_REGEXP.exec(str);
        if (!match) return false;
        if (silent) return true;
        // Just skip citation from parsing and don't render them in the output.
        state.pos += match[0].length;
        return true;
    });
}


function $9ab51ce7b808dc10$export$c255480b061bd6aa(state, type, level) {
    let nesting;
    if (type.includes('_open')) nesting = 1;
    else if (type.includes('_close')) nesting = -1;
    else nesting = 0;
    const token = new state.Token(type, '', nesting);
    if (level) token.level = level;
    return token;
}


function $711a479e43e35ace$export$e717b161ec14d433(tokens) {
    const openTokenIndexMap = new Map();
    const toRemove = new Set();
    for(let i = 0; i < tokens.length; i++){
        const token = tokens[i];
        // This attribute is set earlier in this file (customElementToken.attrPush(['isCustomBlock', 'true']))
        // So we can identify tokens added by this rule
        if (token.attrGet('isCustomBlock') === 'true') {
            // We split by the last underscore
            const type = token.type.substring(0, token.type.lastIndexOf('_'));
            const prevIndex = openTokenIndexMap.get(type);
            // Only check for removal if type exists
            if (type && token.nesting === 1) {
                if (prevIndex !== undefined) toRemove.add(prevIndex);
                openTokenIndexMap.set(type, i);
            } else if (type && token.nesting === -1) {
                if (prevIndex !== undefined) // If previous open token found, then we've found a match and we can close it
                openTokenIndexMap.delete(type);
                else toRemove.add(i);
            }
        }
    }
    // Anything left in the stack is an unmatched open token
    openTokenIndexMap.forEach((remainingIndex)=>toRemove.add(remainingIndex));
    return toRemove;
}


// Some nodes will be inline but it's content will be empty.
// That's why, don't remove paragraphs wrapping it.
// For example, inlineExtension is inline node, so there should be no content inside it.
//  So it's custom element is represented by <custom data-type="inlineExtension" ... />
const $6e900860f50f3a4b$var$emptyInlineCustomNodes = [
    'inlineExtension'
];
function $6e900860f50f3a4b$export$2e2bcd8739ae039(md, idMap, featureToggles, analyticsAttributes) {
    md.core.ruler.after('inline', 'custom-block', function(state) {
        state.tokens = state.tokens.reduce((acc, token, index)=>{
            const match = token.content.match(/**
				 * Matches the following:
				 * <custom data-type="smartlink" data-id="123" />
				 * <custom data-type="smartlink" />
				 * <custom data-type="panel_open" data-id="123" />
				 * <custom data-type="panel_close" />
				 */ // Ignored via go/ees005, go/ees019
            // @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
            // eslint-disable-next-line require-unicode-regexp, e18e/prefer-static-regex
            RegExp('<custom\\s+data-type="(?<dataType>.*?)"\\s*(data-id="(?<dataId>.*?)"\\s*)?\\/>'));
            const dataType = match?.groups?.dataType;
            if (match && dataType && !$6e900860f50f3a4b$var$emptyInlineCustomNodes.includes(dataType)) {
                const dataId = match.groups?.dataId;
                if (dataType) {
                    analyticsAttributes.htmlConvertedToNodes++;
                    const customElementToken = (0, $9ab51ce7b808dc10$export$c255480b061bd6aa)(state, dataType);
                    if (dataId && idMap[dataId]) // @ts-ignore
                    customElementToken.pmAttrs = idMap[dataId].attributes;
                    customElementToken.attrPush([
                        'isCustomBlock',
                        'true'
                    ]);
                    /**
					 * When the custom tag goes through the tokenizer it is transformed into this structure:
					 * paragraph_open
					 * inline
					 * paragraph_close
					 *
					 * so the following section removes the wrapping paragraph tokens
					 */ acc.splice(acc.length - 1, 1);
                    state.tokens.splice(index + 1, 1);
                    // We then push replace the inline token with our custom token
                    acc.push(customElementToken);
                } else {
                    analyticsAttributes.htmlConvertedToFallbackNodes++;
                    acc.push(token);
                }
            } else acc.push(token);
            return acc;
        }, []);
        const toRemove = (0, $711a479e43e35ace$export$e717b161ec14d433)(state.tokens);
        toRemove.forEach((index)=>{
            const tokenToBeRemoved = state.tokens[index];
            analyticsAttributes.unclosedTokens[tokenToBeRemoved.type] = (analyticsAttributes.unclosedTokens[tokenToBeRemoved.type] || 0) + 1;
        });
        // Remove all indices that have been set in `toRemove`
        if (featureToggles.markdownPlusRemoveUnclosedTokens) state.tokens = state.tokens.filter((_, index)=>!toRemove.has(index));
    });
}



var $3u5lg = parcelRequire("3u5lg");

function $1c81b4420832543a$export$2e2bcd8739ae039(md, idMap, featureToggles, analyticsAttributes, markdownPlusAttributeStatus) {
    const rule = md.inline.ruler.before('text', 'custom', function(state, silent) {
        const start = state.pos;
        const origSrc = state.src;
        let match;
        if (featureToggles.markdownPlusAttributeTest) match = state.src.slice(start).match(/**
				 * Matches the following:
				 * <custom data-type="smartlink" data-id="123">content</custom>
				 * <custom data-id="123">content</custom>
				 * <custom data-type="emoji">content</custom>
				 * <custom>content</custom>
				 * <custom data-type="status" data-id="id-0" data-attrs='{"text":"test","color":"neutral"}'>test</custom>
				 */ // Ignored via go/ees005, go/ees019
        // @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
        // eslint-disable-next-line require-unicode-regexp, e18e/prefer-static-regex
        RegExp('<custom(?:\\s+data-type="(?<dataType>[^"]*)")?(?:\\s+data-id="(?<dataId>[^"]*)")?(?:\\s+data-attrs="(?<dataAttrs>\\{.*?\\})")?\\s*>(?<dataContent>.*?)<\\/custom>'));
        else match = state.src.slice(start).match(/**
				 * Matches the following:
				 * <custom data-type="smartlink" data-id="123">content</custom>
				 * <custom data-id="123">content</custom>
				 * <custom data-type="emoji">content</custom>
				 * <custom>content</custom>
				 */ // Ignored via go/ees005, go/ees019
        // @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
        // eslint-disable-next-line require-unicode-regexp, e18e/prefer-static-regex
        RegExp('<custom(\\sdata-(type|id)="(?<dataType>.*?)")?(\\sdata-(type|id)="(?<dataId>.*?)")?>(?<dataContent>.*?)<\\/custom>'));
        if (!match) return false;
        const tagLength = match[0].length;
        const beforeTag = state.src.slice(start, state.src.indexOf(match[0]));
        const dataType = match.groups?.dataType;
        const dataId = match.groups?.dataId;
        const dataAttrs = match.groups?.dataAttrs;
        const dataContent = match.groups?.dataContent;
        const afterTag = state.src.slice(start + beforeTag.length + tagLength);
        function mapCustomDataTypeToNodeType(customDataType) {
            switch(customDataType){
                case 'smartlink':
                    return 'inlineCard';
                case 'date':
                case 'emoji':
                case 'status':
                case 'mention':
                case 'placeholder':
                    return customDataType;
                // Just move below case alongside mention above to remove markdownPlusExtensions FF.
                case 'inlineExtension':
                    return featureToggles.markdownPlusExtensions ? 'inlineExtension' : false;
                case 'mediaInline':
                    return featureToggles.markdownPlusAddComplexNodes ? 'mediaInline' : false;
                default:
                    return false;
            }
        }
        const customDataType = mapCustomDataTypeToNodeType(dataType);
        if (!silent) {
            // tokenize beforeTag
            if (beforeTag) {
                state.src = beforeTag;
                // @ts-ignore
                state.md.inline.tokenize(state, beforeTag);
            }
            if (featureToggles.markdownPlusAttributeTest && featureToggles.markdownPlusMentions && !dataId && dataAttrs && customDataType) {
                const customDataToken = state.push(customDataType, '', 0);
                // @ts-ignore
                customDataToken.pmAttrs = dataAttrs;
            }
            if (dataId && idMap?.[dataId]?.attributes && customDataType) {
                analyticsAttributes.htmlConvertedToNodes++;
                const customDataToken = state.push(customDataType, '', 0);
                // @ts-ignore
                customDataToken.pmAttrs = idMap[dataId].attributes;
                if (featureToggles.markdownPlusAttributeTest && dataAttrs) try {
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(idMap[dataId].attributes, JSON.parse(dataAttrs))) markdownPlusAttributeStatus.push([
                        customDataType,
                        true
                    ]);
                    else // We need to check this because when you type it calls this function multiple times and the first time its called the current text is not the same
                    if (idMap[dataId].attributes.text === JSON.parse(dataAttrs).text) markdownPlusAttributeStatus.push([
                        customDataType,
                        false
                    ]);
                } catch (e) {
                    markdownPlusAttributeStatus.push([
                        customDataType,
                        false
                    ]);
                }
            } else {
                analyticsAttributes.htmlConvertedToFallbackNodes++;
                const textToken = state.push('text', '', 0);
                // If there is no data content we want to hide the custom tags as the AI has hallucinated something
                if (!dataContent) textToken.content = '';
                else textToken.content = dataContent || match[0];
            }
            if (afterTag) {
                state.src = afterTag;
                state.pos = 0;
                // @ts-ignore
                state.md.inline.tokenize(state, afterTag);
            }
        }
        state.src = origSrc;
        state.pos = start + state.src.length;
        return true;
    });
    return rule;
}


const $69d4f76cefec72c0$var$decisionItemOpen = 'decisionItem_open';
const $69d4f76cefec72c0$var$paragraphOpen = 'paragraph_open';
const $69d4f76cefec72c0$var$paragraphClose = 'paragraph_close';
const $69d4f76cefec72c0$var$inline = 'inline';
function $69d4f76cefec72c0$var$handleParagraphs(acc, token) {
    /**
	 * Traverse up the acc token array, and if a chain of one or more inline tokens are under
	 * a decisionItem_open token, then it is considered to be a paragraph_close token within
	 * a decision item.
	 *
	 * This also works for a paragraph_open token as inlineCount would be zero meaning that
	 * the conditional applies to when decisionItem_open is right above paragraph_open.
	 */ let inlineCount = 0;
    let inlineChainEnded = false;
    for(let i = acc.length - 1; i >= 0; i--){
        const type = acc[i]?.type;
        if (!inlineChainEnded) {
            if (type === $69d4f76cefec72c0$var$inline) inlineCount += 1;
            else inlineChainEnded = true;
        }
    }
    const isWithinDecisionItem = acc[acc.length - (inlineCount + 1)]?.type === $69d4f76cefec72c0$var$decisionItemOpen;
    if (!isWithinDecisionItem) acc.push(token);
}
function $69d4f76cefec72c0$export$2e2bcd8739ae039(md, idMap) {
    md.core.ruler.after('custom-block', 'decision-list', function(state) {
        state.tokens = state.tokens.reduce((acc, token, index)=>{
            const { type: type } = token;
            if (type === $69d4f76cefec72c0$var$paragraphOpen || type === $69d4f76cefec72c0$var$paragraphClose) $69d4f76cefec72c0$var$handleParagraphs(acc, token);
            else acc.push(token);
            return acc;
        }, []);
    });
}


const $076f59d847c7ddfa$var$replaceBrWithLineBreak = (text)=>{
    // Matches <br> or <br /> or <br/> with optional trailing space
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return text.replace(/<br\s*\/?>\s?/gi, '\n');
};
const $076f59d847c7ddfa$var$processInlineChildren = (children)=>{
    for (const child of children)if (child.type === 'text') {
        const newText = $076f59d847c7ddfa$var$replaceBrWithLineBreak(child.content);
        if (child.content !== newText) child.content = newText;
    }
};
const $076f59d847c7ddfa$var$brToLineBreak = (state)=>{
    for (const token of state.tokens)if (token.type === 'inline' && token.children) $076f59d847c7ddfa$var$processInlineChildren(token.children);
};
var $076f59d847c7ddfa$export$2e2bcd8739ae039 = (md)=>md.core.ruler.after('inline', 'lineBreak', $076f59d847c7ddfa$var$brToLineBreak);


// File copied from packages/editor/editor-core/src/plugins/paste/linkify-md-plugin.ts

var $8Ik5z = parcelRequire("8Ik5z");


var $9p0BY = parcelRequire("9p0BY");

// File copied from packages/editor/editor-core/src/plugins/hyperlink/utils.ts
// Regular expression for a windows filepath in the format <DRIVE LETTER>:\<folder name>\
// Ignored via go/ees005
const $49c0612cc98e451f$export$893fccbed37586dd = // eslint-disable-next-line require-unicode-regexp
/([a-zA-Z]:|\\)([^\/:*?<>"|]+\\)?([^\/:*?<>"| ]+(?=\s?))?/gim;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $49c0612cc98e451f$var$HTTP_FTP_URL_REGEX = /^(https?|ftp|jamfselfservice):\/\/[^\s]+$/;
const $49c0612cc98e451f$export$d37783fe63e2f0fe = (text, offset = 0)=>{
    // Creation of a copy of the RegExp is necessary as lastIndex is stored on it when we run .exec()
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const localRegExp = new RegExp($49c0612cc98e451f$export$893fccbed37586dd);
    let match;
    const matchesList = [];
    const maxFilepathSize = 260;
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    while((match = localRegExp.exec(text)) !== null){
        const start = match.index + offset;
        let end = localRegExp.lastIndex + offset;
        if (end - start > maxFilepathSize) end = start + maxFilepathSize;
         // We don't care about big strings of text that are pretending to be filepaths!!
        matchesList.push({
            startIndex: start,
            endIndex: end
        });
    }
    return matchesList;
};
const $49c0612cc98e451f$export$5e652e74655163e5 = (linkStart, matchesList)=>{
    for(let i = 0; i < matchesList.length; i++){
        if (linkStart >= matchesList[i].startIndex && linkStart < matchesList[i].endIndex) return true;
    }
    return false;
};
function $49c0612cc98e451f$export$8acd10161c5f8b07(text) {
    return text.replace(// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    /(\[([^\]]+)\]\(|\!\[([^\]]*)\]\()?((https?|ftp|jamfselfservice):\/\/[^\s]+)/g, (str)=>{
        return str.match($49c0612cc98e451f$var$HTTP_FTP_URL_REGEX) ? `<${str}>` : str;
    });
}


// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $b55cb656ca55803d$var$IS_LINK_OPEN_REGEX = /^<a[>\s]/i;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $b55cb656ca55803d$var$IS_LINK_CLOSE_REGEX = /^<\/a\s*>/i;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $b55cb656ca55803d$var$STRIP_HTTP_PREFIX_REGEX = /^http:\/\//;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $b55cb656ca55803d$var$MAILTO_TEST_REGEX = /^mailto:/i;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $b55cb656ca55803d$var$STRIP_MAILTO_PREFIX_REGEX = /^mailto:/;
// modified version of the original Linkify plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.js
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b55cb656ca55803d$var$arrayReplaceAt = (src, pos, newElements)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
};
const $b55cb656ca55803d$var$isLinkOpen = (str)=>{
    return $b55cb656ca55803d$var$IS_LINK_OPEN_REGEX.test(str);
};
const $b55cb656ca55803d$var$isLinkClose = (str)=>{
    return $b55cb656ca55803d$var$IS_LINK_CLOSE_REGEX.test(str);
};
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b55cb656ca55803d$var$linkify = (state)=>{
    const blockTokens = state.tokens;
    const linkify = new (0, (/*@__PURE__*/$parcel$interopDefault($8Ik5z)))();
    for(let j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== 'inline' || !linkify.pretest(blockTokens[j].content)) continue;
        let tokens = blockTokens[j].children;
        let htmlLinkLevel = 0;
        // We scan from the end, to keep position when new tags added.
        // Use reversed logic in links start/end match
        for(let i = tokens.length - 1; i >= 0; i--){
            const currentToken = tokens[i];
            // Skip content of markdown links
            if (currentToken.type === 'link_close') {
                i--;
                while(tokens[i].level !== currentToken.level && tokens[i].type !== 'link_open')i--;
                continue;
            }
            // Skip content of html tag links
            if (currentToken.type === 'html_inline') {
                if ($b55cb656ca55803d$var$isLinkOpen(currentToken.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                if ($b55cb656ca55803d$var$isLinkClose(currentToken.content)) htmlLinkLevel++;
            }
            if (htmlLinkLevel > 0) continue;
            if (currentToken.type === 'text' && linkify.test(currentToken.content)) {
                const text = currentToken.content;
                let links = (0, $9p0BY.linkifyMatch)(text);
                if (!links.length) links = linkify.match(text) || [];
                // Now split string to nodes
                const nodes = [];
                let level = currentToken.level;
                let lastPos = 0;
                const filepaths = (0, $49c0612cc98e451f$export$d37783fe63e2f0fe)(text);
                for(let ln = 0; ln < links.length; ln++){
                    if ((0, $49c0612cc98e451f$export$5e652e74655163e5)(links[ln].index, filepaths)) continue;
                    const { url: url } = links[ln];
                    const fullUrl = state.md.normalizeLink(url);
                    if (!state.md.validateLink(fullUrl)) continue;
                    let urlText = links[ln].text;
                    // Linkifier might send raw hostnames like "example.com", where url
                    // starts with domain name. So we prepend http:// in those cases,
                    // and remove it afterwards.
                    //
                    if (!links[ln].schema) // Ignored via go/ees017 (to be fixed)
                    // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace
                    urlText = state.md.normalizeLinkText('http://' + urlText).replace($b55cb656ca55803d$var$STRIP_HTTP_PREFIX_REGEX, '');
                    else if (links[ln].schema === 'mailto:' && !$b55cb656ca55803d$var$MAILTO_TEST_REGEX.test(urlText)) // Ignored via go/ees017 (to be fixed)
                    // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace
                    urlText = state.md.normalizeLinkText('mailto:' + urlText).replace($b55cb656ca55803d$var$STRIP_MAILTO_PREFIX_REGEX, '');
                    else urlText = state.md.normalizeLinkText(urlText);
                    const pos = links[ln].index;
                    if (pos > lastPos) {
                        const token = new state.Token('text', '', 0);
                        token.content = text.slice(lastPos, pos);
                        token.level = level;
                        nodes.push(token);
                    }
                    let token = new state.Token('link_open', 'a', 1);
                    token.attrs = [
                        [
                            'href',
                            fullUrl
                        ]
                    ];
                    token.level = level++;
                    token.markup = 'linkify';
                    token.info = 'auto';
                    nodes.push(token);
                    token = new state.Token('text', '', 0);
                    token.content = urlText;
                    token.level = level;
                    nodes.push(token);
                    token = new state.Token('link_close', 'a', -1);
                    token.level = --level;
                    token.markup = 'linkify';
                    token.info = 'auto';
                    nodes.push(token);
                    lastPos = links[ln].lastIndex;
                }
                if (lastPos < text.length) {
                    const token = new state.Token('text', '', 0);
                    token.content = text.slice(lastPos);
                    token.level = level;
                    nodes.push(token);
                }
                // replace current node
                blockTokens[j].children = tokens = $b55cb656ca55803d$var$arrayReplaceAt(tokens, i, nodes);
            }
        }
    }
};
var // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$b55cb656ca55803d$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('custom-linkify', $b55cb656ca55803d$var$linkify);


// File copied from packages/editor/editor-markdown-transformer/src/media.ts

var $9t7Od = parcelRequire("9t7Od");

function $37fa07c339d48bac$var$createRule() {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const regx = /!\[[^\]]*\]\([^)]+\)/g;
    // Allow paragraph_close as a valid parent token for cases where a user has an image at the end of a paragraph
    // due to shift+enter
    const validParentTokens = [
        'th_open',
        'td_open',
        'list_item_open',
        'paragraph_close'
    ];
    /**
	 * This function looks for strings that matches ![description](url) inside Inline-tokens.
	 * It will then split the Inline-token with content before and after the image, example:
	 *
	 * Input (tokens):
	 *   paragraph_open
	 *   inline - content: Hello ![](image.jpg) World!
	 *   paragraph_close
	 * Output (tokens):
	 *   paragraph_open
	 *   inline - content: Hello
	 *   paragraph_close
	 *   media_single_open
	 *   media
	 *   media_single_close
	 *   paragraph_open
	 *   inline - content: World!
	 *   paragraph_close
	 *
	 * This is applied before the inline content is parsed, to ensure that the formatting of
	 * remaining inline content (bold, links, etc.) is kept intact!
	 */ return function media(State) {
        const getUrl = (str)=>{
            const res = State.md.helpers.parseLinkDestination(str, str.indexOf('(') + 1, str.length);
            if (res.ok) {
                const href = State.md.normalizeLink(res.str);
                if (State.md.validateLink(href)) return href;
            }
            return '';
        };
        const createMediaTokens = (url)=>{
            const mediaSingleOpen = new State.Token('media_single_open', '', 1);
            const media = new State.Token('media', '', 0);
            media.attrs = [
                [
                    'url',
                    getUrl(url)
                ],
                [
                    'type',
                    'external'
                ]
            ];
            if (url.includes((0, $9t7Od.MEDIA_BASE_URL_STAGING))) try {
                const urlObject = new URL(getUrl(url));
                const params = urlObject.searchParams;
                if (params.toString()) {
                    const pmAttrs = {};
                    for (const [key, value] of params)pmAttrs[key] = value;
                    // @ts-expect-error - pmAttrs is not a standard markdown-it attribute
                    media.pmAttrs = pmAttrs;
                }
            } catch  {}
            const mediaSingleClose = new State.Token('media_single_close', '', -1);
            return [
                mediaSingleOpen,
                media,
                mediaSingleClose
            ];
        };
        const createInlineTokens = (str, openingTokens, closingTokens)=>{
            if (!str || str.length === 0) return [];
            const inlineBefore = new State.Token('inline', '', 1);
            inlineBefore.content = str;
            inlineBefore.children = [];
            return [
                ...openingTokens,
                inlineBefore,
                ...closingTokens
            ];
        };
        let processedTokens = [];
        const newTokens = State.tokens.reduce((tokens, token, i, arr)=>{
            if (token.type === 'inline' && regx.test(token.content)) {
                const openingTokens = [];
                let cursor = i - 1;
                let previousToken = arr[cursor];
                let subTree = [];
                while(previousToken && previousToken.level > 0 && validParentTokens.indexOf(previousToken.type) === -1){
                    openingTokens.unshift(previousToken);
                    cursor--;
                    previousToken = arr[cursor];
                }
                if (validParentTokens.indexOf(previousToken.type) === -1) openingTokens.unshift(previousToken);
                else cursor++;
                const closingTokens = openingTokens// eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
                .map((token)=>new State.Token(token.type.replace('_open', '_close'), token.tag, -1)).reverse();
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const matches = token.content.match(regx);
                let inlineContentStack = token.content;
                matches.forEach((match)=>{
                    const start = inlineContentStack.indexOf(match);
                    const contentBefore = inlineContentStack.substr(0, start);
                    inlineContentStack = inlineContentStack.substr(start + match.length);
                    subTree = [
                        ...subTree,
                        ...createInlineTokens(contentBefore, openingTokens, closingTokens),
                        ...createMediaTokens(match)
                    ];
                });
                if (inlineContentStack.length) subTree = [
                    ...subTree,
                    ...createInlineTokens(inlineContentStack, openingTokens, closingTokens)
                ];
                processedTokens = [
                    ...processedTokens,
                    ...closingTokens.map((c)=>c.type)
                ];
                tokens = [
                    ...tokens.slice(0, cursor),
                    ...subTree
                ];
            } else if (processedTokens.indexOf(token.type) !== -1) // Ignore token if it's already processed
            processedTokens.splice(processedTokens.indexOf(token.type), 1);
            else tokens.push(token);
            return tokens;
        }, []);
        State.tokens = newTokens;
        return true;
    };
}
const $37fa07c339d48bac$export$c8dcbd316b71f8cf = (md)=>{
    md.core.ruler.before('inline', 'media', $37fa07c339d48bac$var$createRule());
};


// file copied from packages/editor/editor-core/src/plugins/paste/newline-md-plugin.ts
// ED-15363: modified version of the original newline plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_inline/newline.js
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $931c1633f054cf68$var$newline = (state, silent)=>{
    let pos = state.pos;
    // ED-15363: unread variables
    // max,
    // ws,
    if (state.src.charCodeAt(pos) !== 0x0a /* \n */ ) return false;
    const pmax = state.pending.length - 1;
    // ED-15363: unread variable
    // max = state.posMax;
    // '  \n' -> hardbreak
    // Lookup in pending chars is bad practice! Don't copy to other rules!
    // Pending string is stored in concat mode, indexed lookups will cause
    // convertion to flat mode.
    if (!silent) {
        if (pmax >= 0 && state.pending.charCodeAt(pmax) === 0x20) {
            if (pmax >= 1 && state.pending.charCodeAt(pmax - 1) === 0x20) // ED-15363: We commented out this logic to preserve trailing whitespaces
            // for each line of text when pasting plain text
            // // Find whitespaces tail of pending chars.
            // ws = pmax - 1;
            // while (ws >= 1 && state.pending.charCodeAt(ws - 1) === 0x20) {
            //   ws--;
            // }
            // state.pending = state.pending.slice(0, ws);
            state.push('hardbreak', 'br', 0);
            else {
                state.pending = state.pending.slice(0, -1);
                state.push('softbreak', 'br', 0);
            }
        } else state.push('softbreak', 'br', 0);
    }
    pos++;
    // ED-15363: We commented out this logic from the original library to
    // preserve leading whitespaces for each line of text when pasting plain
    // text (to preserve whitespace-based indentation).
    // // skip heading spaces for next line
    // while (pos < max && isSpace(state.src.charCodeAt(pos))) {
    //   pos++;
    // }
    state.pos = pos;
    return true;
};
var // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$931c1633f054cf68$export$2e2bcd8739ae039 = (md)=>md.inline.ruler.at('newline', $931c1633f054cf68$var$newline);






// eslint-disable-next-line require-unicode-regexp
// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
const $c6a726a34adc4bbd$var$mediaRegex = /(!\[[^\]]*\]\([^)]+\))|(\[!\[[^\]]*\]\([^)]+\)\]\([^)]+\))/gu;
// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
const $c6a726a34adc4bbd$var$INLINE_MEDIA_MATCH_REGEX = /!\[[^\]]*\]\([^)]+\)/u;
const $c6a726a34adc4bbd$var$getUrl = (state, str)=>{
    const res = state.md.helpers.parseLinkDestination(str, str.indexOf('(') + 1, str.length);
    if (res.ok) {
        const href = state.md.normalizeLink(res.str);
        if (state.md.validateLink(href)) return href;
    }
    return '';
};
const $c6a726a34adc4bbd$var$checkPreviousToken = (type, acc)=>{
    return acc.length > 0 && acc[acc.length - 1].type === type;
};
const $c6a726a34adc4bbd$var$createMediaTokens = (url, state, acc)=>{
    const mediaSingleOpen = (0, $9ab51ce7b808dc10$export$c255480b061bd6aa)(state, 'media_single_open');
    const media = (0, $9ab51ce7b808dc10$export$c255480b061bd6aa)(state, 'media');
    media.attrs = [
        [
            'url',
            $c6a726a34adc4bbd$var$getUrl(state, url)
        ],
        [
            'type',
            'external'
        ]
    ];
    // This is a hack to get internal media to work
    // to recreate the image correctly we need to apply the pmAttrs from the image
    // We store the pmAttrs in the "fake" image url and apply them to the token
    if (url.includes((0, $9t7Od.MEDIA_BASE_URL_STAGING))) try {
        const urlObject = new URL($c6a726a34adc4bbd$var$getUrl(state, url));
        const params = urlObject.searchParams;
        if (params.toString()) {
            const pmAttrs = {};
            for (const [key, value] of params)pmAttrs[key] = value;
            // @ts-expect-error - pmAttrs is not a standard markdown-it attribute
            media.pmAttrs = pmAttrs;
        }
    } catch  {}
    const mediaSingleClose = (0, $9ab51ce7b808dc10$export$c255480b061bd6aa)(state, 'media_single_close');
    acc.push(mediaSingleOpen, media, mediaSingleClose);
};
const $c6a726a34adc4bbd$var$createInlineTokens = (content, state, acc)=>{
    const paragraphOpen = (0, $9ab51ce7b808dc10$export$c255480b061bd6aa)(state, 'paragraph_open');
    const inline = (0, $9ab51ce7b808dc10$export$c255480b061bd6aa)(state, 'inline');
    inline.content = content;
    inline.children = [
        (0, $9ab51ce7b808dc10$export$c255480b061bd6aa)(state, 'text')
    ];
    const paragraphClose = (0, $9ab51ce7b808dc10$export$c255480b061bd6aa)(state, 'paragraph_close');
    acc.push(paragraphOpen, inline, paragraphClose);
};
/**
 * Splits the content of the inline token
 * Inline tokens can contain multiple media elements as well as regular text
 * We split the content into an array of strings which can then be converted into the correct tokens
 */ const $c6a726a34adc4bbd$var$findContent = (token)=>{
    let content = [];
    let lastIndex = 0;
    let match;
    $c6a726a34adc4bbd$var$mediaRegex.lastIndex = 0;
    // eslint-disable-next-line no-cond-assign
    while((match = $c6a726a34adc4bbd$var$mediaRegex.exec(token.content)) !== null){
        const matchedString = match[0];
        const matchIndex = match.index;
        if (lastIndex < matchIndex) content.push(token.content.substring(lastIndex, matchIndex));
        content.push(matchedString);
        lastIndex = matchIndex + matchedString.length;
    }
    if (lastIndex < token.content.length) content.push(token.content.substring(lastIndex));
    content = content.filter((item)=>item.length > 0);
    return content;
};
function $c6a726a34adc4bbd$export$2e2bcd8739ae039(md) {
    md.core.ruler.before('inline', 'media', function(state) {
        state.tokens = state.tokens.reduce((acc, token, index)=>{
            const { type: type } = token;
            if (type === 'inline' && $c6a726a34adc4bbd$var$mediaRegex.test(token.content)) {
                // If the previous token is a paragraph_open we want to remove it
                if ($c6a726a34adc4bbd$var$checkPreviousToken('paragraph_open', acc)) acc.pop();
                const content = $c6a726a34adc4bbd$var$findContent(token);
                content.forEach((item)=>{
                    // @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
                    const doesMatch = $c6a726a34adc4bbd$var$INLINE_MEDIA_MATCH_REGEX.test(item);
                    if (doesMatch) $c6a726a34adc4bbd$var$createMediaTokens(item, state, acc);
                    else $c6a726a34adc4bbd$var$createInlineTokens(item, state, acc);
                });
            // If the current token is paragraph close we want to make sure that the previous token isn't a media_single_close
            // or paragraph_close
            } else if (type === 'paragraph_close') {
                if (!$c6a726a34adc4bbd$var$checkPreviousToken('media_single_close', acc) && !$c6a726a34adc4bbd$var$checkPreviousToken('paragraph_close', acc)) acc.push(token);
            } else acc.push(token);
            return acc;
        }, []);
    });
}


// File copied from packages/editor/editor-core/src/plugins/paste/paragraph-md-plugin.ts
// ED-15363: modified version of the original paragraph plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_block/paragraph.js
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $79a66323a159f1f1$var$paragraph = (state, startLine /*, endLine*/ )=>{
    let terminate, i, l, token, nextLine = startLine + 1;
    const terminatorRules = state.md.block.ruler.getRules('paragraph');
    const endLine = state.lineMax;
    const oldParentType = state.parentType;
    state.parentType = 'paragraph';
    // jump line-by-line until empty one or EOF
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    const content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine;
    token = state.push('paragraph_open', 'p', 1);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push('inline', '', 0);
    token.content = content;
    token.map = [
        startLine,
        state.line
    ];
    token.children = [];
    token = state.push('paragraph_close', 'p', -1);
    state.parentType = oldParentType;
    return true;
};
var // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$79a66323a159f1f1$export$2e2bcd8739ae039 = (md)=>md.block.ruler.at('paragraph', $79a66323a159f1f1$var$paragraph);



// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $e4b8821874531627$var$REMOVE_TODO_MARKDOWN_REGEX = /(\[x\]\s)|(\[\s\]\s)/;
const $e4b8821874531627$var$bulletListOpen = 'bullet_list_open';
const $e4b8821874531627$var$bulletListClose = 'bullet_list_close';
const $e4b8821874531627$var$listItemOpen = 'list_item_open';
const $e4b8821874531627$var$listItemClose = 'list_item_close';
const $e4b8821874531627$var$taskListOpen = 'task_list_open';
const $e4b8821874531627$var$taskListClose = 'task_list_close';
const $e4b8821874531627$var$taskItemOpen = 'task_item_open';
const $e4b8821874531627$var$taskItemClose = 'task_item_close';
const $e4b8821874531627$var$paragraphOpen = 'paragraph_open';
const $e4b8821874531627$var$paragraphClose = 'paragraph_close';
function $e4b8821874531627$var$checkTypeByIndex(acc, type, indexOffset = -1) {
    return acc[acc.length + indexOffset]?.type === type;
}
function $e4b8821874531627$var$getTokenByIndex(acc, indexOffset = -1) {
    return acc[acc.length + indexOffset];
}
function $e4b8821874531627$var$handleBulletListOpen(state, token, acc, index) {
    const isPreviousTokenInline = $e4b8821874531627$var$checkTypeByIndex(acc, 'inline');
    const isStartOfTaskList = state.tokens[index + 3].type === 'inline' && $e4b8821874531627$var$startsWithTodoMarkdown(state.tokens[index + 3]);
    // If the previous token is inline and our current token is a bullet_list_open that
    // means we have found the start of a nested list, due to current ADF limitations task items
    // cannot contain new task lists so first we must close the task item and then convert the
    // bullet_list_open to task_list_open
    if (isPreviousTokenInline) {
        acc.push((0, $9ab51ce7b808dc10$export$c255480b061bd6aa)(state, $e4b8821874531627$var$taskItemClose, $e4b8821874531627$var$getTokenByIndex(acc).level - 1));
        acc.push((0, $9ab51ce7b808dc10$export$c255480b061bd6aa)(state, $e4b8821874531627$var$taskListOpen, $e4b8821874531627$var$getTokenByIndex(acc).level));
    } else if (isStartOfTaskList) acc.push((0, $9ab51ce7b808dc10$export$c255480b061bd6aa)(state, $e4b8821874531627$var$taskListOpen));
    else acc.push(token);
}
function $e4b8821874531627$var$handleBulletListClose(state, token, acc) {
    const isPreviousTokenTaskItemClose = $e4b8821874531627$var$checkTypeByIndex(acc, $e4b8821874531627$var$taskItemClose);
    const isPreviousTokenTaskListClose = $e4b8821874531627$var$checkTypeByIndex(acc, $e4b8821874531627$var$taskListClose);
    if (isPreviousTokenTaskItemClose || isPreviousTokenTaskListClose) acc.push((0, $9ab51ce7b808dc10$export$c255480b061bd6aa)(state, $e4b8821874531627$var$taskListClose, $e4b8821874531627$var$getTokenByIndex(acc).level - 1));
    else acc.push(token);
}
function $e4b8821874531627$var$handleListItemOpen(state, token, acc, index) {
    const newTaskItemOpen = (0, $9ab51ce7b808dc10$export$c255480b061bd6aa)(state, $e4b8821874531627$var$taskItemOpen);
    const isTaskItem = state.tokens[index + 2].type === 'inline' && $e4b8821874531627$var$startsWithTodoMarkdown(state.tokens[index + 2]);
    const isPreviousTokenTaskItemClose = $e4b8821874531627$var$checkTypeByIndex(acc, $e4b8821874531627$var$taskItemClose);
    const isPreviousTokenListItemClose = $e4b8821874531627$var$checkTypeByIndex(acc, $e4b8821874531627$var$listItemClose);
    const isPreviousTokenTaskListClose = $e4b8821874531627$var$checkTypeByIndex(acc, $e4b8821874531627$var$taskListClose);
    if (isTaskItem) {
        // If the previous token is a list item close then we have run into some incorrect task list / list markdown
        // We need to complete the previous bullet list and then open a new task list
        if (isPreviousTokenListItemClose) {
            acc.push((0, $9ab51ce7b808dc10$export$c255480b061bd6aa)(state, $e4b8821874531627$var$bulletListClose));
            acc.push((0, $9ab51ce7b808dc10$export$c255480b061bd6aa)(state, $e4b8821874531627$var$taskListOpen));
        }
        newTaskItemOpen.meta = $e4b8821874531627$var$isDone(state.tokens[index + 2]);
        newTaskItemOpen.level = $e4b8821874531627$var$getTokenByIndex(acc).level + (isPreviousTokenTaskListClose ? 0 : 1);
        acc.push(newTaskItemOpen);
    } else {
        // If the previous token is a task item close but the current token is not a task item we need to
        // close the current task item list and then open a new bullet list
        if (isPreviousTokenTaskItemClose) {
            acc.push((0, $9ab51ce7b808dc10$export$c255480b061bd6aa)(state, $e4b8821874531627$var$taskListClose));
            acc.push((0, $9ab51ce7b808dc10$export$c255480b061bd6aa)(state, $e4b8821874531627$var$bulletListOpen));
        }
        acc.push(token);
    }
}
function $e4b8821874531627$var$handleListItemClose(state, token, acc) {
    const isWithinTaskList = $e4b8821874531627$var$checkTypeByIndex(acc, 'inline') && $e4b8821874531627$var$checkTypeByIndex(acc, $e4b8821874531627$var$taskItemOpen, -2);
    if (isWithinTaskList) acc.push((0, $9ab51ce7b808dc10$export$c255480b061bd6aa)(state, $e4b8821874531627$var$taskItemClose, $e4b8821874531627$var$getTokenByIndex(acc, -2).level));
    else if (!$e4b8821874531627$var$checkTypeByIndex(acc, $e4b8821874531627$var$taskListClose)) acc.push(token);
}
function $e4b8821874531627$var$handleInline(token, acc) {
    if (token.children?.[0]) // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    token.children[0].content = $e4b8821874531627$var$removeTodoMarkdown(token.children[0].content);
    token.content = $e4b8821874531627$var$removeTodoMarkdown(token.content);
    token.level = $e4b8821874531627$var$getTokenByIndex(acc).level + 1;
    acc.push(token);
}
function $e4b8821874531627$var$handleParagraphs(token, acc) {
    const isWithinTaskItem = $e4b8821874531627$var$checkTypeByIndex(acc, $e4b8821874531627$var$taskItemOpen) || $e4b8821874531627$var$checkTypeByIndex(acc, $e4b8821874531627$var$taskItemOpen, -2);
    if (!isWithinTaskItem) acc.push(token);
}
function $e4b8821874531627$var$isInlineAfterTaskItemOpen(token, acc) {
    return token.type === 'inline' && acc[acc.length - 1].type === $e4b8821874531627$var$taskItemOpen;
}
function $e4b8821874531627$var$startsWithTodoMarkdown(token) {
    // leading whitespace in a list item is already trimmed off by markdown-it
    return token.content.indexOf('[ ] ') === 0 || token.content.indexOf('[x] ') === 0 || token.content.indexOf('[X] ') === 0;
}
function $e4b8821874531627$var$removeTodoMarkdown(content) {
    return content.replace($e4b8821874531627$var$REMOVE_TODO_MARKDOWN_REGEX, '');
}
function $e4b8821874531627$var$isDone(token) {
    if (token.content.indexOf('[ ] ') === 0) return 'TODO';
    else return 'DONE';
}
function $e4b8821874531627$export$2e2bcd8739ae039(md) {
    md.core.ruler.after('inline', 'github-task-lists', function(state) {
        state.tokens = state.tokens.reduce((acc, token, index)=>{
            const { type: type } = token;
            if (type === $e4b8821874531627$var$bulletListOpen) $e4b8821874531627$var$handleBulletListOpen(state, token, acc, index);
            else if (type === $e4b8821874531627$var$bulletListClose) $e4b8821874531627$var$handleBulletListClose(state, token, acc);
            else if (type === $e4b8821874531627$var$listItemOpen) $e4b8821874531627$var$handleListItemOpen(state, token, acc, index);
            else if ($e4b8821874531627$var$isInlineAfterTaskItemOpen(token, acc)) $e4b8821874531627$var$handleInline(token, acc);
            else if (type === $e4b8821874531627$var$listItemClose) $e4b8821874531627$var$handleListItemClose(state, token, acc);
            else if (type === $e4b8821874531627$var$paragraphOpen || type === $e4b8821874531627$var$paragraphClose) $e4b8821874531627$var$handleParagraphs(token, acc);
            else acc.push(token);
            return acc;
        }, []);
    });
}



function $2c1f17fa8725a273$var$getFragmentBackingArray(fragment) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return fragment.content;
}
function $2c1f17fa8725a273$var$mapFragment(content, callback, parent = null) {
    const children = [];
    for(let i = 0, size = content.childCount; i < size; i++){
        const node = content.child(i);
        const transformed = node.isLeaf ? callback(node, parent, i) : callback(node.copy($2c1f17fa8725a273$var$mapFragment(node.content, callback, node)), parent, i);
        if (transformed) {
            if (transformed instanceof (0, $aPdNQ.Fragment)) children.push(...$2c1f17fa8725a273$var$getFragmentBackingArray(transformed));
            else if (Array.isArray(transformed)) children.push(...transformed);
            else children.push(transformed);
        }
    }
    return (0, $aPdNQ.Fragment).fromArray(children);
}
function $2c1f17fa8725a273$export$b2bf04f78f72b123({ markdown: markdown, schema: schema, idMap: idMap, featureToggles: featureToggles = {} }) {
    const { markdownPlus: markdownPlus } = featureToggles;
    const tokenizer = new (0, (/*@__PURE__*/$parcel$interopDefault($fT7Fj)))('zero', {
        html: false
    });
    tokenizer.enable([
        // Process html entity - &#123;, &#xAF;, &quot;, ...
        'entity',
        // Process escaped chars and hardbreaks
        'escape',
        'newline'
    ]);
    [
        'nodes',
        'marks'
    ].forEach((key)=>{
        for(const idx in (0, $c5a7138b7add57b2$export$b535e2638dcce02)[key])if (schema[key][idx]) tokenizer.enable((0, $c5a7138b7add57b2$export$b535e2638dcce02)[key][idx]);
    });
    const analyticsAttributes = {
        htmlConvertedToNodes: 0,
        htmlConvertedToFallbackNodes: 0,
        unclosedTokens: {}
    };
    // Remove once markdownPlusAttributeTest is removed
    const markdownPlusAttributeStatus = [];
    if (markdownPlus) {
        tokenizer.use((0, $6e900860f50f3a4b$export$2e2bcd8739ae039), idMap, featureToggles, analyticsAttributes);
        tokenizer.use((0, $69d4f76cefec72c0$export$2e2bcd8739ae039), idMap);
        tokenizer.use((0, $1c81b4420832543a$export$2e2bcd8739ae039), idMap, featureToggles, analyticsAttributes, markdownPlusAttributeStatus);
    }
    tokenizer.use((0, $6076957fd7cd32c6$export$2e2bcd8739ae039), idMap);
    tokenizer.use((0, $79a66323a159f1f1$export$2e2bcd8739ae039));
    // enable modified version of linkify plugin
    // @see https://product-fabric.atlassian.net/browse/ED-3097
    tokenizer.use((0, $b55cb656ca55803d$export$2e2bcd8739ae039));
    tokenizer.use((0, $931c1633f054cf68$export$2e2bcd8739ae039));
    tokenizer.use((0, $076f59d847c7ddfa$export$2e2bcd8739ae039));
    // Custom Table tokenizer
    if (schema.nodes.table) tokenizer.use((0, $zBSTr.markdownItTable));
    // Custom Media tokenizer
    if (schema.nodes.media && schema.nodes.mediaSingle) {
        if (featureToggles.markdownPlusUseNextMediaPlugin) tokenizer.use((0, $c6a726a34adc4bbd$export$2e2bcd8739ae039));
        else tokenizer.use((0, $37fa07c339d48bac$export$c8dcbd316b71f8cf));
        if (markdownPlus && featureToggles.markdownPlusAddComplexNodes) tokenizer.use((0, $347ba1e2d3b8b47a$export$2e2bcd8739ae039));
    }
    // Custom TaskList tokenizer
    if (schema.nodes.taskList) tokenizer.use((0, $e4b8821874531627$export$2e2bcd8739ae039));
    const markdownParser = new (0, $2jzwX.MarkdownParser)(schema, tokenizer, (0, $c5a7138b7add57b2$export$a9d25ff08f358d72)(schema, (0, $c5a7138b7add57b2$export$8f853a1c35ed8bbe)(!!markdownPlus)));
    if (markdown === '') return {
        htmlConvertedToNodes: 0,
        htmlConvertedToFallbackNodes: 0,
        unclosedTokens: {},
        markdownPlusAttributeStatus: [],
        pmFragment: (0, $aPdNQ.Fragment).empty
    };
    // normalize duplicated backticks (needed as a safeguard to avoid rendering malformed escape characters coming from backed)
    // the case with newline characters
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    markdown = markdown.replace(/\\n/g, '\n');
    // the case with custom field attributes (limit only to data- attributes inside custom fields)
    if (markdownPlus) // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    markdown = markdown.replace(/<custom[^>]*?>/g, function(match) {
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        return match.replace(/(data-\w+=)\\\"(.*?)\\\"/g, '$1"$2"');
    });
    const prosemirrorNode = markdownPlus ? markdownParser.parse(markdown) : markdownParser.parse((0, $49c0612cc98e451f$export$8acd10161c5f8b07)(markdown));
    if (!prosemirrorNode.content) throw new Error('Markdown conversion did not result in a valid document being created');
    // This logic is duplicated from editor-cores paste transformation.
    // The editor-plugin-ai package is avoiding sharing dependencies with editor-core to support
    // products using it with various versions of editor packages.
    // The duplication is from the following file:
    // packages/editor/editor-core/src/plugins/media/utils/media-single.ts
    // WARNING
    // If the `mapFragment` usage changes -- it means we have a breaking change for products
    // where currently it's expected they are using older versions of editor-common
    const mappedContent = $2c1f17fa8725a273$var$mapFragment(prosemirrorNode.content, (node)=>{
        if (node.type.name === 'media') {
            const replacedAttrs = Object.fromEntries(Object.entries(node.attrs).map(([key, value])=>{
                // If value is the literal string 'null', convert it to JS null
                return [
                    key,
                    value === 'null' ? null : value
                ];
            }));
            return schema.nodes.media.createChecked({
                ...replacedAttrs,
                // Adding this attribute results in the media node being rendered
                // initially using the external url, but then triggering an upload
                // of the external url as an atlassian artifact, and this media
                // will then be replaced to use the atlassian artifact.
                //
                // This is done in the media nodeview by checking the attributes
                // when rendering.
                __external: replacedAttrs.type === 'external',
                __mediaTraceId: null
            }, node.content, node.marks);
        }
        return node;
    });
    return {
        ...analyticsAttributes,
        markdownPlusAttributeStatus: markdownPlusAttributeStatus,
        pmFragment: mappedContent
    };
}
function $2c1f17fa8725a273$export$e661a057c2263d64({ markdown: markdown, schema: schema, idMap: idMap, featureToggles: featureToggles = {} }) {
    const fragment = $2c1f17fa8725a273$export$b2bf04f78f72b123({
        markdown: markdown,
        schema: schema,
        idMap: idMap,
        featureToggles: {
            markdownPlus: true,
            ...featureToggles
        }
    });
    try {
        const node = schema.nodes.doc.createChecked({}, fragment.pmFragment);
        return node;
    } catch  {
        throw new Error('Markdown conversion did not result in a valid ProseMirror node');
    }
}
module.exports["convertMarkdownToProsemirror"] = $2c1f17fa8725a273$export$b2bf04f78f72b123;
module.exports["backendConvertMarkdownToProsemirrorNode"] = $2c1f17fa8725a273$export$e661a057c2263d64;

});

parcelRegister("6e6HL", function(module, exports) {
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $1HhPq = parcelRequire("1HhPq");

const $788ef638343efbc9$export$d109ab46c9575565 = ()=>({
        type: 'doc',
        version: 1,
        content: []
    });
module.exports["getEmptyADF"] = $788ef638343efbc9$export$d109ab46c9575565;

});

parcelRegister("3sXr4", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");

const $f685837601709ec0$var$GRADIENT_ANGLE_VARIABLE = '--gradient-angle';
const $f685837601709ec0$var$BORDER_ORANGE = "var(--ds-rovo-border-saffron, #FCA700)";
const $f685837601709ec0$var$BORDER_GREEN = "var(--ds-rovo-border-lime, #6A9A23)";
const $f685837601709ec0$var$BORDER_BLUE = "var(--ds-rovo-border-blue, #1868DB)";
const $f685837601709ec0$var$BORDER_PURPLE = "var(--ds-rovo-border-purple, #AF59E1)"; /**
                                                                * Because the aspect ratio of the actual thinking bars is very wide,
                                                                * the gradient will stretch out at each corner which would make the
                                                                * rovo colours very disproportionate.
                                                                *
                                                                * To workaround this we use a dynamic angle amplitude to narrow the angles as we approach
                                                                * 90 and 180 degrees, and we have a general aspect ratio of the expected design as
                                                                * it's not worth calculating the width and height of the actual components.
                                                                *
                                                                * Approximating the minimum edge span as inversely proportional to the expected
                                                                * wrapper aspect ratio.
                                                                *
                                                                * 360 / 48 is the approximated aspect ratio.
                                                                */ 
const $f685837601709ec0$var$DEFAULT_SIDE_ANGLE_SPAN = `2 * atan(1 / (360 / 48))`; /**
                                                             * Squared cosine produces a symmetric 0..1 signal based on rotation angle:
                                                             * 0 at top/bottom, 1 at left/right, which tells us how close the highlight is
                                                             * to the side edges.
                                                             */ 
const $f685837601709ec0$var$DEFAULT_SIDE_WEIGHT = `calc(cos(var(${$f685837601709ec0$var$GRADIENT_ANGLE_VARIABLE}, 39deg)) * cos(var(${$f685837601709ec0$var$GRADIENT_ANGLE_VARIABLE}, 39deg)))`; /**
                                                                                                                                * Interpolates the highlight span between the minimum side-edge span and a
                                                                                                                                * wider 90deg span, with amplitude scaling and side weighting for earlier/
                                                                                                                                * longer narrowing near the left and right edges.
                                                                                                                                */ 
const $f685837601709ec0$var$DEFAULT_HIGHLIGHT_SPAN = `calc(${$f685837601709ec0$var$DEFAULT_SIDE_ANGLE_SPAN} + ((90deg - ${$f685837601709ec0$var$DEFAULT_SIDE_ANGLE_SPAN})  * ${$f685837601709ec0$var$DEFAULT_SIDE_WEIGHT}))`; // Conic gradient that drives both the visible border and blurred glow.
const $f685837601709ec0$var$ROVO_MOSAIC_GRADIENT_BACKGROUND = `conic-gradient(
	from calc(var(${$f685837601709ec0$var$GRADIENT_ANGLE_VARIABLE}, 39deg) - (${$f685837601709ec0$var$DEFAULT_HIGHLIGHT_SPAN} / 2)) at 50% 50%,
	${$f685837601709ec0$var$BORDER_ORANGE} 0deg ${$f685837601709ec0$var$DEFAULT_HIGHLIGHT_SPAN},
	${$f685837601709ec0$var$BORDER_GREEN} ${$f685837601709ec0$var$DEFAULT_HIGHLIGHT_SPAN} 180deg,
	${$f685837601709ec0$var$BORDER_BLUE} 180deg calc(180deg + ${$f685837601709ec0$var$DEFAULT_HIGHLIGHT_SPAN}),
	${$f685837601709ec0$var$BORDER_PURPLE} calc(180deg + ${$f685837601709ec0$var$DEFAULT_HIGHLIGHT_SPAN}) 360deg
)`; // Rotate the custom angle property so the highlight continuously sweeps around the border.
const $f685837601709ec0$var$gradientRotation = null; // @property is required so the browser knows --gradient-angle is an interpolatable
// <angle> — without it, keyframe animation of a custom property has no effect.
const $f685837601709ec0$var$gradientAngleProperty = null;
const $f685837601709ec0$var$BLUR_SIZE = 32;
const $f685837601709ec0$var$BORDER_WIDTH = 1; // Outer position context for the decorative glow and border layers.
const $f685837601709ec0$var$wrapperBaseStyle = null; // Thinking shell uses pseudo-elements for the blurred glow and rotating gradient border.
const $f685837601709ec0$var$thinkingWrapperStyle = null;
const $f685837601709ec0$var$plainBorderStyle = null; // Shared layout/padding base for the actual content area so children can stay mounted
// while the surrounding thinking chrome changes.
const $f685837601709ec0$var$contentBaseStyle = null;
const $f685837601709ec0$export$f2f0a5c9bccb33b1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { children: children, isThinking: isThinking } = t0;
    const t1 = isThinking ? "rovo-thinking-bar-wrapper__thinking" : "rovo-thinking-bar-wrapper__idle";
    const t2 = isThinking && "";
    const t3 = isThinking && "";
    const t4 = isThinking && "";
    const t5 = isThinking && "_2rkopb1k _1rjct94y _18zrt94y _kqswh2mm _1bsb1osq _19121cl4 _rfx31ahh _1s6ktrqk _16qq1auy _1kt9b3bt _1cs8stnw _1mp41kdh _kfgt1kdh _1auk7vkz _qnec7vkz _1dbx7b89 _dsq4glyw _1g0v1mrw _9v7aidpf _14mj1ahh _16r2trqk _46ts1auy _aetrb3bt _18postnw _11fnglyw _1bqq1mrw _1a4fglyw _1388glyw";
    const t6 = !isThinking && "_2rkopb1k _1reo15vq _18m915vq _1rjct94y _18zrt94y _1bsb1osq _bfhk1bhr _16qs130s";
    let t7;
    if ($[0] !== t2 || $[1] !== t3 || $[2] !== t4 || $[3] !== t5 || $[4] !== t6) {
        t7 = (0, $hekY6.default)([
            "_2rkopb1k _kqswh2mm _1bsb1osq",
            t2,
            t3,
            t4,
            t5,
            t6
        ]);
        $[0] = t2;
        $[1] = t3;
        $[2] = t4;
        $[3] = t5;
        $[4] = t6;
        $[5] = t7;
    } else t7 = $[5];
    let t8;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = (0, $hekY6.default)([
            "_2rkopb1k _18zru2gc _1rjcu2gc _1bsb1osq _kqswh2mm _1pbyidpf _bfhk1bhr _vchhusvi"
        ]);
        $[6] = t8;
    } else t8 = $[6];
    let t9;
    if ($[7] !== children) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t8
        }, children);
        $[7] = children;
        $[8] = t9;
    } else t9 = $[8];
    let t10;
    if ($[9] !== t1 || $[10] !== t7 || $[11] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": t1,
            className: t7
        }, t9);
        $[9] = t1;
        $[10] = t7;
        $[11] = t9;
        $[12] = t10;
    } else t10 = $[12];
    return t10;
} : ({ children: children, isThinking: isThinking })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": isThinking ? 'rovo-thinking-bar-wrapper__thinking' : 'rovo-thinking-bar-wrapper__idle',
        className: (0, $hekY6.default)([
            "_2rkopb1k _kqswh2mm _1bsb1osq",
            isThinking && "",
            isThinking && "",
            isThinking && "",
            isThinking && "_2rkopb1k _1rjct94y _18zrt94y _kqswh2mm _1bsb1osq _19121cl4 _rfx31ahh _1s6ktrqk _16qq1auy _1kt9b3bt _1cs8stnw _1mp41kdh _kfgt1kdh _1auk7vkz _qnec7vkz _1dbx7b89 _dsq4glyw _1g0v1mrw _9v7aidpf _14mj1ahh _16r2trqk _46ts1auy _aetrb3bt _18postnw _11fnglyw _1bqq1mrw _1a4fglyw _1388glyw",
            !isThinking && "_2rkopb1k _1reo15vq _18m915vq _1rjct94y _18zrt94y _1bsb1osq _bfhk1bhr _16qs130s"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_2rkopb1k _18zru2gc _1rjcu2gc _1bsb1osq _kqswh2mm _1pbyidpf _bfhk1bhr _vchhusvi"
        ])
    }, children));
};
module.exports["RovoThinkingBarWrapper"] = $f685837601709ec0$export$f2f0a5c9bccb33b1;

});

parcelRegister("02Wb7", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $353693fd10aa5589$var$message = (0, $kSwu1.defineMessages)({
    followAiMateButton: {
        id: "ai-mate.inline-chat-input.follow-button.label",
        defaultMessage: "Follow"
    },
    stopGeneratingButtonLabel: {
        id: "ai-mate.inline-chat-input.stop-generating-button.label",
        defaultMessage: "Stop generating"
    },
    thinkingText: {
        id: "ai-mate.inline-chat-input.thinking",
        defaultMessage: "Rovo is analyzing"
    },
    thinkingTextShort: {
        id: "ai-mate.inline-chat-input.thinking.short",
        defaultMessage: "Analyzing"
    },
    editingText: {
        id: "ai-mate.inline-chat-input.editing",
        defaultMessage: "Rovo is editing"
    },
    editingTextShort: {
        id: "ai-mate.inline-chat-input.editing.short",
        defaultMessage: "Editing"
    },
    thinkingReadyMessage: {
        id: "ai-mate.thinking-bar.ready.message",
        defaultMessage: "Your edits are ready"
    },
    thinkingReadyClose: {
        id: "ai-mate.thinking-bar.ready.close",
        defaultMessage: "Close"
    },
    thinkingReadyView: {
        id: "ai-mate.thinking-bar.ready.view",
        defaultMessage: "View"
    }
});
var $353693fd10aa5589$export$2e2bcd8739ae039 = $353693fd10aa5589$var$message;
module.exports["default"] = $353693fd10aa5589$export$2e2bcd8739ae039;

});

parcelRegister("kb1I3", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");

var $1sCHt = parcelRequire("1sCHt");


var $1pTZX = parcelRequire("1pTZX");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");


var $1kxki = parcelRequire("1kxki");


var $2diYd = parcelRequire("2diYd");


var $02Wb7 = parcelRequire("02Wb7");




const $cccd0e8042c52039$var$DEFAULT_ESTIMATED_DURATION_MS = 30000;
const $cccd0e8042c52039$var$COMPLETION_ANIMATION_MS = 150;
function $cccd0e8042c52039$export$c350fe90f7013d5f({ isComplete: isComplete = false, onCompleteAnimationFinished: onCompleteAnimationFinished, estimatedDurationMs: estimatedDurationMs = $cccd0e8042c52039$var$DEFAULT_ESTIMATED_DURATION_MS }) {
    const [progress, setProgress] = (0, $cozmU.useState)(0);
    const targetRef = (0, $cozmU.useRef)(85 + Math.random() * 10);
    const completionStartValueRef = (0, $cozmU.useRef)(0);
    const completionStartTimeRef = (0, $cozmU.useRef)(null);
    const hasCalledFinishedRef = (0, $cozmU.useRef)(false);
    const onCompleteAnimationFinishedRef = (0, $cozmU.useRef)(onCompleteAnimationFinished);
    onCompleteAnimationFinishedRef.current = onCompleteAnimationFinished;
    // Phase 1: Animate from 0 → target over estimatedDurationMs
    (0, $cozmU.useEffect)(()=>{
        if (isComplete) return;
        let rafId;
        let startTime = null;
        const target = targetRef.current;
        const tick = (timestamp)=>{
            if (startTime === null) startTime = timestamp;
            const elapsed = timestamp - startTime;
            const linearProgress = Math.min(1, elapsed / estimatedDurationMs);
            setProgress(linearProgress * target);
            if (linearProgress < 1) rafId = requestAnimationFrame(tick);
        };
        rafId = requestAnimationFrame(tick);
        return ()=>{
            cancelAnimationFrame(rafId);
        };
    }, [
        isComplete,
        estimatedDurationMs
    ]);
    // Phase 2: When isComplete, rapidly animate from current value → 100
    const handleCompletion = (0, $cozmU.useCallback)(()=>{
        completionStartTimeRef.current = null;
        hasCalledFinishedRef.current = false;
        let rafId;
        const tick = (timestamp)=>{
            if (completionStartTimeRef.current === null) completionStartTimeRef.current = timestamp;
            const elapsed = timestamp - completionStartTimeRef.current;
            const t = Math.min(1, elapsed / $cccd0e8042c52039$var$COMPLETION_ANIMATION_MS);
            const startValue = completionStartValueRef.current;
            const value = startValue + (100 - startValue) * t;
            setProgress(value);
            if (t < 1) rafId = requestAnimationFrame(tick);
            else if (!hasCalledFinishedRef.current) {
                hasCalledFinishedRef.current = true;
                onCompleteAnimationFinishedRef.current?.();
            }
        };
        rafId = requestAnimationFrame(tick);
        return ()=>{
            cancelAnimationFrame(rafId);
        };
    }, []);
    (0, $cozmU.useEffect)(()=>{
        if (!isComplete) return;
        completionStartValueRef.current = progress;
        const cleanup = handleCompletion();
        return cleanup;
    // eslint-disable-next-line react-hooks/exhaustive-deps -- only trigger when isComplete changes to true
    }, [
        isComplete,
        handleCompletion
    ]);
    return progress;
}


const $6437c80744d7a710$var$ROTATION_INTERVAL_MS = 4000;
const $6437c80744d7a710$var$rotatingMessages = (0, $kSwu1.defineMessages)({
    rovoIsThinking: {
        id: "ai-mate.inline-chat-input.thinking.rotating.rovo-is-thinking",
        defaultMessage: "Rovo is thinking"
    },
    analyzingContent: {
        id: "ai-mate.inline-chat-input.thinking.rotating.analyzing-content",
        defaultMessage: "Analyzing your content"
    },
    puttingPiecesTogether: {
        id: "ai-mate.inline-chat-input.thinking.rotating.putting-pieces-together",
        defaultMessage: "Putting the pieces together"
    },
    structuringResponse: {
        id: "ai-mate.inline-chat-input.thinking.rotating.structuring-response",
        defaultMessage: "Structuring your response"
    },
    designingResponse: {
        id: "ai-mate.inline-chat-input.thinking.rotating.designing-response",
        defaultMessage: "Designing your response"
    },
    addingItAllTogether: {
        id: "ai-mate.inline-chat-input.thinking.rotating.adding-it-all-together",
        defaultMessage: "Adding it all together"
    },
    applyingFinalTouches: {
        id: "ai-mate.inline-chat-input.thinking.rotating.applying-final-touches",
        defaultMessage: "Applying the final touches"
    },
    almostDone: {
        id: "ai-mate.inline-chat-input.thinking.rotating.almost-done",
        defaultMessage: "Almost done"
    }
});
/** Cycles through `texts` at a fixed interval, stopping on the last item. */ function $6437c80744d7a710$var$useSequentialText(texts, enabled) {
    const [index, setIndex] = (0, $cozmU.useState)(0);
    const indexRef = (0, $cozmU.useRef)(0);
    const textsRef = (0, $cozmU.useRef)(texts);
    textsRef.current = texts;
    (0, $cozmU.useEffect)(()=>{
        if (!enabled || textsRef.current.length <= 1) return;
        const interval = setInterval(()=>{
            const next = indexRef.current + 1;
            if (next < textsRef.current.length) {
                indexRef.current = next;
                setIndex(next);
            } else clearInterval(interval);
        }, $6437c80744d7a710$var$ROTATION_INTERVAL_MS);
        return ()=>clearInterval(interval);
    }, [
        enabled
    ]);
    return texts[index] ?? texts[texts.length - 1] ?? '';
}
const $6437c80744d7a710$var$styles = {
    container: "_zulpu2gc _1e0c1txw _2lx2vrvc _4cvr1h6o _1bsb1osq",
    actions: "_18u01wug",
    indicatorWrapper: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _1ul9idpf"
};
const $6437c80744d7a710$export$6430bc5d6cac94e6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(52);
    const { status: t1, onStop: onStop, onFollow: onFollow, useShortMessages: t2, showProgressBar: t3, isComplete: isComplete, onCompleteAnimationFinished: onCompleteAnimationFinished, useRotatingTitle: t4, customRotatingMessages: customRotatingMessages } = t0;
    const status = t1 === undefined ? "analyzing" : t1;
    const useShortMessages = t2 === undefined ? false : t2;
    const showProgressBar = t3 === undefined ? false : t3;
    const useRotatingTitle = t4 === undefined ? false : t4;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t5;
    if ($[0] !== isComplete || $[1] !== onCompleteAnimationFinished) {
        t5 = {
            isComplete: isComplete,
            onCompleteAnimationFinished: onCompleteAnimationFinished
        };
        $[0] = isComplete;
        $[1] = onCompleteAnimationFinished;
        $[2] = t5;
    } else t5 = $[2];
    const progress = (0, $cccd0e8042c52039$export$c350fe90f7013d5f)(t5);
    const t6 = status === "editing" ? useShortMessages ? (0, $02Wb7.default).editingTextShort : (0, $02Wb7.default).editingText : useShortMessages ? (0, $02Wb7.default).thinkingTextShort : (0, $02Wb7.default).thinkingText;
    let t7;
    if ($[3] !== formatMessage || $[4] !== t6) {
        t7 = formatMessage(t6);
        $[3] = formatMessage;
        $[4] = t6;
        $[5] = t7;
    } else t7 = $[5];
    const staticTitle = t7;
    const rotatingEnabled = useRotatingTitle && !useShortMessages;
    let t8;
    if ($[6] !== formatMessage) {
        t8 = formatMessage($6437c80744d7a710$var$rotatingMessages.rovoIsThinking);
        $[6] = formatMessage;
        $[7] = t8;
    } else t8 = $[7];
    let t9;
    if ($[8] !== formatMessage) {
        t9 = formatMessage($6437c80744d7a710$var$rotatingMessages.analyzingContent);
        $[8] = formatMessage;
        $[9] = t9;
    } else t9 = $[9];
    let t10;
    if ($[10] !== formatMessage) {
        t10 = formatMessage($6437c80744d7a710$var$rotatingMessages.puttingPiecesTogether);
        $[10] = formatMessage;
        $[11] = t10;
    } else t10 = $[11];
    let t11;
    if ($[12] !== formatMessage) {
        t11 = formatMessage($6437c80744d7a710$var$rotatingMessages.structuringResponse);
        $[12] = formatMessage;
        $[13] = t11;
    } else t11 = $[13];
    let t12;
    if ($[14] !== formatMessage) {
        t12 = formatMessage($6437c80744d7a710$var$rotatingMessages.designingResponse);
        $[14] = formatMessage;
        $[15] = t12;
    } else t12 = $[15];
    let t13;
    if ($[16] !== formatMessage) {
        t13 = formatMessage($6437c80744d7a710$var$rotatingMessages.addingItAllTogether);
        $[16] = formatMessage;
        $[17] = t13;
    } else t13 = $[17];
    let t14;
    if ($[18] !== formatMessage) {
        t14 = formatMessage($6437c80744d7a710$var$rotatingMessages.applyingFinalTouches);
        $[18] = formatMessage;
        $[19] = t14;
    } else t14 = $[19];
    let t15;
    if ($[20] !== formatMessage) {
        t15 = formatMessage($6437c80744d7a710$var$rotatingMessages.almostDone);
        $[20] = formatMessage;
        $[21] = t15;
    } else t15 = $[21];
    let t16;
    if ($[22] !== t10 || $[23] !== t11 || $[24] !== t12 || $[25] !== t13 || $[26] !== t14 || $[27] !== t15 || $[28] !== t8 || $[29] !== t9) {
        t16 = [
            t8,
            t9,
            t10,
            t11,
            t12,
            t13,
            t14,
            t15
        ];
        $[22] = t10;
        $[23] = t11;
        $[24] = t12;
        $[25] = t13;
        $[26] = t14;
        $[27] = t15;
        $[28] = t8;
        $[29] = t9;
        $[30] = t16;
    } else t16 = $[30];
    const defaultRotatingTitles = t16;
    const rotatingTitles = customRotatingMessages && customRotatingMessages.length > 0 ? customRotatingMessages : defaultRotatingTitles;
    const rotatingTitle = $6437c80744d7a710$var$useSequentialText(rotatingTitles, rotatingEnabled);
    const title = rotatingEnabled ? rotatingTitle : staticTitle;
    let t17;
    if ($[31] !== formatMessage || $[32] !== onFollow) {
        t17 = onFollow && /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            appearance: "subtle",
            onClick: onFollow
        }, formatMessage((0, $02Wb7.default).followAiMateButton));
        $[31] = formatMessage;
        $[32] = onFollow;
        $[33] = t17;
    } else t17 = $[33];
    let t18;
    if ($[34] !== formatMessage) {
        t18 = formatMessage((0, $02Wb7.default).stopGeneratingButtonLabel);
        $[34] = formatMessage;
        $[35] = t18;
    } else t18 = $[35];
    let t19;
    if ($[36] !== onStop || $[37] !== t18) {
        t19 = /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
            isTooltipDisabled: false,
            shape: "default",
            onClick: onStop,
            icon: $6437c80744d7a710$var$_temp,
            label: t18
        });
        $[36] = onStop;
        $[37] = t18;
        $[38] = t19;
    } else t19 = $[38];
    let t20;
    if ($[39] !== t17 || $[40] !== t19) {
        t20 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            testId: "inline-chat__thinking-view",
            alignBlock: "center",
            space: "space.100",
            xcss: $6437c80744d7a710$var$styles.actions
        }, t17, t19);
        $[39] = t17;
        $[40] = t19;
        $[41] = t20;
    } else t20 = $[41];
    const actionsNode = t20;
    let t21;
    if ($[42] !== progress || $[43] !== showProgressBar || $[44] !== title) {
        t21 = showProgressBar ? /*#__PURE__*/ $cozmU.createElement((0, $1kxki.RainbowProgressBar), {
            testId: "rovo-thinking-progress-bar",
            progress: progress,
            appearance: "static-rainbow",
            label: title
        }) : undefined;
        $[42] = progress;
        $[43] = showProgressBar;
        $[44] = title;
        $[45] = t21;
    } else t21 = $[45];
    let t22;
    if ($[46] !== t21 || $[47] !== title) {
        t22 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $6437c80744d7a710$var$styles.indicatorWrapper
        }, /*#__PURE__*/ $cozmU.createElement((0, $2diYd.RovoThinkingIndicator), {
            title: title,
            animation: true,
            bottomAdornment: t21
        }));
        $[46] = t21;
        $[47] = title;
        $[48] = t22;
    } else t22 = $[48];
    let t23;
    if ($[49] !== actionsNode || $[50] !== t22) {
        t23 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $6437c80744d7a710$var$styles.container
        }, t22, actionsNode);
        $[49] = actionsNode;
        $[50] = t22;
        $[51] = t23;
    } else t23 = $[51];
    return t23;
} : ({ status: status = 'analyzing', onStop: onStop, onFollow: onFollow, useShortMessages: useShortMessages = false, showProgressBar: showProgressBar = false, isComplete: isComplete, onCompleteAnimationFinished: onCompleteAnimationFinished, useRotatingTitle: useRotatingTitle = false, customRotatingMessages: customRotatingMessages })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const progress = (0, $cccd0e8042c52039$export$c350fe90f7013d5f)({
        isComplete: isComplete,
        onCompleteAnimationFinished: onCompleteAnimationFinished
    });
    const staticTitle = formatMessage(status === 'editing' ? useShortMessages ? (0, $02Wb7.default).editingTextShort : (0, $02Wb7.default).editingText : useShortMessages ? (0, $02Wb7.default).thinkingTextShort : (0, $02Wb7.default).thinkingText);
    const rotatingEnabled = useRotatingTitle && !useShortMessages;
    const defaultRotatingTitles = [
        formatMessage($6437c80744d7a710$var$rotatingMessages.rovoIsThinking),
        formatMessage($6437c80744d7a710$var$rotatingMessages.analyzingContent),
        formatMessage($6437c80744d7a710$var$rotatingMessages.puttingPiecesTogether),
        formatMessage($6437c80744d7a710$var$rotatingMessages.structuringResponse),
        formatMessage($6437c80744d7a710$var$rotatingMessages.designingResponse),
        formatMessage($6437c80744d7a710$var$rotatingMessages.addingItAllTogether),
        formatMessage($6437c80744d7a710$var$rotatingMessages.applyingFinalTouches),
        formatMessage($6437c80744d7a710$var$rotatingMessages.almostDone)
    ];
    const rotatingTitles = customRotatingMessages && customRotatingMessages.length > 0 ? customRotatingMessages : defaultRotatingTitles;
    const rotatingTitle = $6437c80744d7a710$var$useSequentialText(rotatingTitles, rotatingEnabled);
    const title = rotatingEnabled ? rotatingTitle : staticTitle;
    const actionsNode = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        testId: "inline-chat__thinking-view",
        alignBlock: "center",
        space: "space.100",
        xcss: $6437c80744d7a710$var$styles.actions
    }, onFollow && /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: onFollow
    }, formatMessage((0, $02Wb7.default).followAiMateButton)), /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        isTooltipDisabled: false,
        shape: 'default',
        onClick: onStop,
        icon: (iconProps)=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($1pTZX))), {
                ...iconProps,
                color: "var(--ds-icon-danger, #C9372C)",
                label: ''
            }),
        label: formatMessage((0, $02Wb7.default).stopGeneratingButtonLabel)
    }));
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $6437c80744d7a710$var$styles.container
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $6437c80744d7a710$var$styles.indicatorWrapper
    }, /*#__PURE__*/ $cozmU.createElement((0, $2diYd.RovoThinkingIndicator), {
        title: title,
        animation: true,
        bottomAdornment: showProgressBar ? /*#__PURE__*/ $cozmU.createElement((0, $1kxki.RainbowProgressBar), {
            testId: "rovo-thinking-progress-bar",
            progress: progress,
            appearance: "static-rainbow",
            label: title
        }) : undefined
    })), actionsNode);
};
function $6437c80744d7a710$var$_temp(iconProps) {
    return /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($1pTZX))), {
        ...iconProps,
        color: "var(--ds-icon-danger, #C9372C)",
        label: ""
    });
}
module.exports["RovoThinkingBar"] = $6437c80744d7a710$export$6430bc5d6cac94e6;

});

parcelRegister("1kxki", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $12c61bdb5e5d4432$var$slideAnimation = null; // 'planning' / 'running' animation: scroll a 200% wide inner div by -50% of its
// own width so it loops seamlessly within the fixed-width clip region.
const $12c61bdb5e5d4432$var$scrollAnimation = null; // Order: orange, green, blue, purple
const $12c61bdb5e5d4432$var$COLORS = [
    "var(--ds-chart-categorical-4, #F68909)",
    // orange
    "var(--ds-chart-categorical-2, #82B536)",
    // green
    "var(--ds-chart-categorical-1, #357DE8)",
    // blue
    "var(--ds-chart-categorical-3, #BF63F3)" // purple
];
const $12c61bdb5e5d4432$var$COMPLETE_COLOR = "var(--ds-chart-categorical-2, #82B536)"; // green
const $12c61bdb5e5d4432$var$containerStyles = null;
const $12c61bdb5e5d4432$var$containerThickStyles = null; // 'start': sliding train of divs
const $12c61bdb5e5d4432$var$trainStyles = null;
const $12c61bdb5e5d4432$var$blockStyles = null; // Scroll train blocks are 1/8th of the inner div width (which is 200% of the clip container)
const $12c61bdb5e5d4432$var$scrollBlockStyles = null;
const $12c61bdb5e5d4432$var$scrollInnerStyles = null;
const $12c61bdb5e5d4432$var$completeStyles = null; // Clipping container for 'planning' and 'running' — width is set dynamically via inline style
const $12c61bdb5e5d4432$var$scrollRegionStyles = null; // Determinate mode: width is driven by the `progress` prop. Parents are
// responsible for animating it smoothly (e.g. via requestAnimationFrame).
const $12c61bdb5e5d4432$var$determinateRegionStyles = null; // Static rainbow: same 4 color blocks as the animated version, no scroll.
const $12c61bdb5e5d4432$var$staticRainbowFillStyles = null;
const $12c61bdb5e5d4432$var$solidFillStyles = null; /**
                               * Determinate-mode fill style:
                               * - `'rainbow'`: scrolling rainbow color blocks
                               * - `'static-rainbow'`: static rainbow gradient
                               * - any other string: a solid CSS color (e.g. a design token value)
                               */ 
const $12c61bdb5e5d4432$var$ColorTrain = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                "_1e0c1txw _kqswstnw _4t3i1osq _j7hqax4i _5sag126j _tip812c5 _1pglp3kn"
            ])
        }, $12c61bdb5e5d4432$var$COLORS.map($12c61bdb5e5d4432$var$_temp));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_1e0c1txw _kqswstnw _4t3i1osq _j7hqax4i _5sag126j _tip812c5 _1pglp3kn"
        ])
    }, $12c61bdb5e5d4432$var$COLORS.map((color)=>/*#__PURE__*/ $cozmU.createElement("div", {
            key: color,
            style: {
                backgroundColor: color
            },
            className: (0, $hekY6.default)([
                "_16jlkb7n _1o9zidpf _i0dl1x1l _4t3i1osq"
            ])
        })));
const $12c61bdb5e5d4432$var$ScrollTrainInner = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                "_1e0c1txw _4t3i1osq _1bsb15ob _j7hq3p39 _5sag126j _tip812c5 _1pglp3kn"
            ])
        }, [
            0,
            1
        ].map($12c61bdb5e5d4432$var$_temp2));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_1e0c1txw _4t3i1osq _1bsb15ob _j7hq3p39 _5sag126j _tip812c5 _1pglp3kn"
        ])
    }, [
        0,
        1
    ].map((copy)=>$12c61bdb5e5d4432$var$COLORS.map((color)=>/*#__PURE__*/ $cozmU.createElement("div", {
                key: `${copy}-${color}`,
                style: {
                    backgroundColor: color
                },
                className: (0, $hekY6.default)([
                    "_16jlkb7n _1o9zidpf _i0dlgojt _4t3i1osq"
                ])
            }))));
const $12c61bdb5e5d4432$var$ARIA_VALUE_TEXT = {
    planning: 'Planning...',
    running: 'Running...'
};
const $12c61bdb5e5d4432$var$StaticRainbowFill = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                "_1e0c1txw _4t3i1osq _1bsb1osq"
            ])
        }, $12c61bdb5e5d4432$var$COLORS.map($12c61bdb5e5d4432$var$_temp3));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_1e0c1txw _4t3i1osq _1bsb1osq"
        ])
    }, $12c61bdb5e5d4432$var$COLORS.map((color)=>/*#__PURE__*/ $cozmU.createElement("div", {
            key: color,
            style: {
                backgroundColor: color
            },
            className: (0, $hekY6.default)([
                "_16jlkb7n _1o9zidpf _i0dl1x1l _4t3i1osq"
            ])
        })));
const $12c61bdb5e5d4432$var$DeterminateFill = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { appearance: appearance } = t0;
    if (appearance === "rainbow") {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = /*#__PURE__*/ $cozmU.createElement($12c61bdb5e5d4432$var$ScrollTrainInner, null);
            $[0] = t1;
        } else t1 = $[0];
        return t1;
    }
    if (appearance === "static-rainbow") {
        let t1;
        if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = /*#__PURE__*/ $cozmU.createElement($12c61bdb5e5d4432$var$StaticRainbowFill, null);
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    let t1;
    if ($[2] !== appearance) {
        t1 = {
            backgroundColor: appearance
        };
        $[2] = appearance;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            "_1r04idpf _kqswstnw"
        ]);
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== t1 || $[6] !== t2) {
        t3 = /*#__PURE__*/ $cozmU.createElement("div", {
            style: t1,
            className: t2
        });
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ appearance: appearance })=>{
    if (appearance === 'rainbow') return /*#__PURE__*/ $cozmU.createElement($12c61bdb5e5d4432$var$ScrollTrainInner, null);
    if (appearance === 'static-rainbow') return /*#__PURE__*/ $cozmU.createElement($12c61bdb5e5d4432$var$StaticRainbowFill, null);
     // Treat any other string as a CSS color.
    return /*#__PURE__*/ $cozmU.createElement("div", {
        style: {
            backgroundColor: appearance
        },
        className: (0, $hekY6.default)([
            "_1r04idpf _kqswstnw"
        ])
    });
};
const $12c61bdb5e5d4432$export$38b7902100288853 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(21);
    const { testId: testId, status: t1, label: t2, progress: progress, appearance: t3, thickness: t4 } = t0;
    const status = t1 === undefined ? "start" : t1;
    const label = t2 === undefined ? "Loading" : t2;
    const appearance = t3 === undefined ? "rainbow" : t3;
    const thickness = t4 === undefined ? "default" : t4;
    const isDeterminate = progress !== undefined;
    const isComplete = status === "complete";
    const ariaValueText = isDeterminate ? undefined : $12c61bdb5e5d4432$var$ARIA_VALUE_TEXT[status];
    const clampedProgress = isDeterminate ? Math.min(100, Math.max(0, progress)) : undefined;
    let t5;
    if ($[0] !== clampedProgress || $[1] !== isComplete || $[2] !== isDeterminate) {
        t5 = isDeterminate ? Math.round(clampedProgress) : isComplete ? 100 : undefined;
        $[0] = clampedProgress;
        $[1] = isComplete;
        $[2] = isDeterminate;
        $[3] = t5;
    } else t5 = $[3];
    const t6 = isDeterminate || isComplete ? 0 : undefined;
    const t7 = isDeterminate || isComplete ? 100 : undefined;
    const t8 = thickness === "thick" && "_2rko1rr0 _4t3ii2wt";
    let t9;
    if ($[4] !== t8) {
        t9 = (0, $hekY6.default)([
            "_2rkolb4i _1reo15vq _18m915vq _1bsb1osq _4t3i1l7b _kqswh2mm _bfhki8nm",
            t8
        ]);
        $[4] = t8;
        $[5] = t9;
    } else t9 = $[5];
    let t10;
    if ($[6] !== appearance || $[7] !== clampedProgress || $[8] !== isComplete || $[9] !== isDeterminate || $[10] !== status) {
        t10 = isDeterminate ? /*#__PURE__*/ $cozmU.createElement("div", {
            style: {
                width: `${clampedProgress}%`
            },
            className: (0, $hekY6.default)([
                "_1reo15vq _18m915vq _kqswstnw _154iidpf _1ltvidpf _4t3i1osq"
            ])
        }, /*#__PURE__*/ $cozmU.createElement($12c61bdb5e5d4432$var$DeterminateFill, {
            appearance: appearance
        })) : isComplete ? /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                "_1r04idpf _kqswstnw _bfhk1oty"
            ])
        }) : status === "planning" || status === "running" ? /*#__PURE__*/ $cozmU.createElement("div", {
            style: {
                width: status === "planning" ? "30%" : "60%"
            },
            className: (0, $hekY6.default)([
                "_1reo15vq _18m915vq _kqswstnw _154iidpf _1ltvidpf _4t3i1osq"
            ])
        }, /*#__PURE__*/ $cozmU.createElement($12c61bdb5e5d4432$var$ScrollTrainInner, null)) : /*#__PURE__*/ $cozmU.createElement($12c61bdb5e5d4432$var$ColorTrain, null);
        $[6] = appearance;
        $[7] = clampedProgress;
        $[8] = isComplete;
        $[9] = isDeterminate;
        $[10] = status;
        $[11] = t10;
    } else t10 = $[11];
    let t11;
    if ($[12] !== ariaValueText || $[13] !== label || $[14] !== t10 || $[15] !== t5 || $[16] !== t6 || $[17] !== t7 || $[18] !== t9 || $[19] !== testId) {
        t11 = /*#__PURE__*/ $cozmU.createElement("div", {
            "data-testid": testId,
            role: "progressbar",
            "aria-label": label,
            "aria-valuetext": ariaValueText,
            "aria-valuenow": t5,
            "aria-valuemin": t6,
            "aria-valuemax": t7,
            className: t9
        }, t10);
        $[12] = ariaValueText;
        $[13] = label;
        $[14] = t10;
        $[15] = t5;
        $[16] = t6;
        $[17] = t7;
        $[18] = t9;
        $[19] = testId;
        $[20] = t11;
    } else t11 = $[20];
    return t11;
} : ({ testId: testId, status: status = 'start', label: label = 'Loading', progress: progress, appearance: appearance = 'rainbow', thickness: thickness = 'default' })=>{
    const isDeterminate = progress !== undefined;
    const isComplete = status === 'complete'; // Indeterminate states: omit aria-valuenow/min/max (per the ARIA spec) and
    // surface contextual feedback via aria-valuetext for planning/running.
    const ariaValueText = isDeterminate ? undefined : $12c61bdb5e5d4432$var$ARIA_VALUE_TEXT[status];
    const clampedProgress = isDeterminate ? Math.min(100, Math.max(0, progress)) : undefined;
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": testId,
        role: "progressbar",
        "aria-label": label,
        "aria-valuetext": ariaValueText,
        "aria-valuenow": isDeterminate ? Math.round(clampedProgress) : isComplete ? 100 : undefined,
        "aria-valuemin": isDeterminate || isComplete ? 0 : undefined,
        "aria-valuemax": isDeterminate || isComplete ? 100 : undefined,
        className: (0, $hekY6.default)([
            "_2rkolb4i _1reo15vq _18m915vq _1bsb1osq _4t3i1l7b _kqswh2mm _bfhki8nm",
            thickness === 'thick' && "_2rko1rr0 _4t3ii2wt"
        ])
    }, isDeterminate ? /*#__PURE__*/ $cozmU.createElement("div", {
        style: {
            width: `${clampedProgress}%`
        },
        className: (0, $hekY6.default)([
            "_1reo15vq _18m915vq _kqswstnw _154iidpf _1ltvidpf _4t3i1osq"
        ])
    }, /*#__PURE__*/ $cozmU.createElement($12c61bdb5e5d4432$var$DeterminateFill, {
        appearance: appearance
    })) : isComplete ? /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_1r04idpf _kqswstnw _bfhk1oty"
        ])
    }) : status === 'planning' || status === 'running' ? /*#__PURE__*/ $cozmU.createElement("div", {
        style: {
            width: status === 'planning' ? '30%' : '60%'
        },
        className: (0, $hekY6.default)([
            "_1reo15vq _18m915vq _kqswstnw _154iidpf _1ltvidpf _4t3i1osq"
        ])
    }, /*#__PURE__*/ $cozmU.createElement($12c61bdb5e5d4432$var$ScrollTrainInner, null)) : // Full-bar sliding train (start).
    /*#__PURE__*/ $cozmU.createElement($12c61bdb5e5d4432$var$ColorTrain, null));
};
function $12c61bdb5e5d4432$var$_temp(color) {
    return /*#__PURE__*/ $cozmU.createElement("div", {
        key: color,
        style: {
            backgroundColor: color
        },
        className: (0, $hekY6.default)([
            "_16jlkb7n _1o9zidpf _i0dl1x1l _4t3i1osq"
        ])
    });
}
function $12c61bdb5e5d4432$var$_temp2(copy) {
    return $12c61bdb5e5d4432$var$COLORS.map((color)=>/*#__PURE__*/ $cozmU.createElement("div", {
            key: `${copy}-${color}`,
            style: {
                backgroundColor: color
            },
            className: (0, $hekY6.default)([
                "_16jlkb7n _1o9zidpf _i0dlgojt _4t3i1osq"
            ])
        }));
}
function $12c61bdb5e5d4432$var$_temp3(color) {
    return /*#__PURE__*/ $cozmU.createElement("div", {
        key: color,
        style: {
            backgroundColor: color
        },
        className: (0, $hekY6.default)([
            "_16jlkb7n _1o9zidpf _i0dl1x1l _4t3i1osq"
        ])
    });
}
module.exports["RainbowProgressBar"] = $12c61bdb5e5d4432$export$38b7902100288853;

});

parcelRegister("2diYd", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");


var $6wOvs = parcelRequire("6wOvs");


var $f6wWZ = parcelRequire("f6wWZ");


var $ikV3b = parcelRequire("ikV3b");


var $k22Xw = parcelRequire("k22Xw");

const $4ec713fa0db90eb4$var$styles = {
    root: "_4t3i1tcg _1e0c1txw _2lx2vrvc _1bah1e5h _1n261q9c _4cvr1h6o",
    rootWithAdornment: "_16jlkb7n _1o9zkb7n _i0dlf1ug _zulpu2gc _1e0c1txw _2lx2vrvc _1bah1e5h _1n261q9c _4cvr1h6o",
    iconContainer: "_zulpu2gc _2hwxv77o _1e0c1txw _4cvr1h6o",
    textColumn: "_16jlkb7n _1o9zkb7n _i0dlf1ug _zulp1b66 _1e0c1txw _2lx21bp4",
    textRow: "_4t3i1tcg _1e0c1txw _2lx2vrvc _4cvr1h6o",
    text: "_11c8fhey _syazi7uo _1nmz1hna",
    textNoWrap: "_11c8fhey _1reo15vq _18m915vq _syazi7uo _o5721q9c",
    ellipsesContainer: "_16jlkb7n _1o9zkb7n _i0dlf1ug"
};
const $4ec713fa0db90eb4$var$getLoadingMorphingIcon = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ikV3b.MorphingShapeLoader), {
        testId: "morphing-loader"
    });
};
const $4ec713fa0db90eb4$var$getIcon = (icon)=>{
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(icon)) return icon;
    else if (icon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $k22Xw.LazyAnimatedRovoIcon), {
        alt: "Rovo",
        testId: "rovo-loading-animation",
        width: "24px",
        height: "24px"
    });
    return null;
};
const $4ec713fa0db90eb4$export$cc468b3595726b51 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(32);
    const { title: title, isAnimated: t1, icon: t2, animation: t3, disableMorphingAnimation: t4, showEllipsis: t5, testId: testId, bottomAdornment: bottomAdornment } = t0;
    const isAnimated = t1 === undefined ? true : t1;
    const icon = t2 === undefined ? true : t2;
    const animation = t3 === undefined ? false : t3;
    const disableMorphingAnimation = t4 === undefined ? false : t4;
    const showEllipsis = t5 === undefined ? true : t5;
    const enableAnimation = animation;
    let t6;
    if ($[0] !== disableMorphingAnimation || $[1] !== enableAnimation || $[2] !== icon) {
        t6 = enableAnimation && !disableMorphingAnimation ? $4ec713fa0db90eb4$var$getLoadingMorphingIcon() : $4ec713fa0db90eb4$var$getIcon(icon);
        $[0] = disableMorphingAnimation;
        $[1] = enableAnimation;
        $[2] = icon;
        $[3] = t6;
    } else t6 = $[3];
    const iconNode = t6;
    const t7 = showEllipsis ? $4ec713fa0db90eb4$var$styles.textNoWrap : $4ec713fa0db90eb4$var$styles.text;
    let t8;
    if ($[4] !== enableAnimation || $[5] !== title) {
        t8 = enableAnimation ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6wOvs.ShimmerText), null, title) : title;
        $[4] = enableAnimation;
        $[5] = title;
        $[6] = t8;
    } else t8 = $[6];
    let t9;
    if ($[7] !== t7 || $[8] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t7
        }, t8);
        $[7] = t7;
        $[8] = t8;
        $[9] = t9;
    } else t9 = $[9];
    const textNode = t9;
    let t10;
    if ($[10] !== isAnimated || $[11] !== showEllipsis) {
        t10 = showEllipsis ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $4ec713fa0db90eb4$var$styles.ellipsesContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f6wWZ.EllipsesAnimation), {
            isAnimated: isAnimated
        })) : null;
        $[10] = isAnimated;
        $[11] = showEllipsis;
        $[12] = t10;
    } else t10 = $[12];
    const ellipsesNode = t10;
    if (bottomAdornment) {
        let t11;
        if ($[13] !== iconNode) {
            t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $4ec713fa0db90eb4$var$styles.iconContainer
            }, iconNode);
            $[13] = iconNode;
            $[14] = t11;
        } else t11 = $[14];
        let t12;
        if ($[15] !== ellipsesNode || $[16] !== textNode) {
            t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $4ec713fa0db90eb4$var$styles.textRow
            }, textNode, ellipsesNode);
            $[15] = ellipsesNode;
            $[16] = textNode;
            $[17] = t12;
        } else t12 = $[17];
        let t13;
        if ($[18] !== bottomAdornment || $[19] !== t12) {
            t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $4ec713fa0db90eb4$var$styles.textColumn
            }, t12, bottomAdornment);
            $[18] = bottomAdornment;
            $[19] = t12;
            $[20] = t13;
        } else t13 = $[20];
        let t14;
        if ($[21] !== t11 || $[22] !== t13 || $[23] !== testId) {
            t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $4ec713fa0db90eb4$var$styles.rootWithAdornment,
                testId: testId
            }, t11, t13);
            $[21] = t11;
            $[22] = t13;
            $[23] = testId;
            $[24] = t14;
        } else t14 = $[24];
        return t14;
    }
    let t11;
    if ($[25] !== iconNode || $[26] !== textNode) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $4ec713fa0db90eb4$var$styles.iconContainer
        }, iconNode, textNode);
        $[25] = iconNode;
        $[26] = textNode;
        $[27] = t11;
    } else t11 = $[27];
    let t12;
    if ($[28] !== ellipsesNode || $[29] !== t11 || $[30] !== testId) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $4ec713fa0db90eb4$var$styles.root,
            testId: testId
        }, t11, ellipsesNode);
        $[28] = ellipsesNode;
        $[29] = t11;
        $[30] = testId;
        $[31] = t12;
    } else t12 = $[31];
    return t12;
} : ({ title: title, isAnimated: isAnimated = true, icon: icon = true, animation: animation = false, disableMorphingAnimation: disableMorphingAnimation = false, showEllipsis: showEllipsis = true, testId: testId, bottomAdornment: bottomAdornment })=>{
    const enableAnimation = animation;
    const iconNode = enableAnimation && !disableMorphingAnimation ? $4ec713fa0db90eb4$var$getLoadingMorphingIcon() : $4ec713fa0db90eb4$var$getIcon(icon);
    const textNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: showEllipsis ? $4ec713fa0db90eb4$var$styles.textNoWrap : $4ec713fa0db90eb4$var$styles.text
    }, enableAnimation ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6wOvs.ShimmerText), null, title) : title);
    const ellipsesNode = showEllipsis ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $4ec713fa0db90eb4$var$styles.ellipsesContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f6wWZ.EllipsesAnimation), {
        isAnimated: isAnimated
    })) : null;
    if (bottomAdornment) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $4ec713fa0db90eb4$var$styles.rootWithAdornment,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $4ec713fa0db90eb4$var$styles.iconContainer
    }, iconNode), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $4ec713fa0db90eb4$var$styles.textColumn
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $4ec713fa0db90eb4$var$styles.textRow
    }, textNode, ellipsesNode), bottomAdornment));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $4ec713fa0db90eb4$var$styles.root,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $4ec713fa0db90eb4$var$styles.iconContainer
    }, iconNode, textNode), ellipsesNode);
};
module.exports["RovoThinkingIndicator"] = $4ec713fa0db90eb4$export$cc468b3595726b51;

});

parcelRegister("6wOvs", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $4aRua = parcelRequire("4aRua");

const $b90e25146b4dbd96$var$shimmerAnimation = null;
const $b90e25146b4dbd96$var$shimmerGradient = null; /** Single-line ellipsis + flex/grid-safe width. */ 
const $b90e25146b4dbd96$var$truncateSingleLine = null;
const $b90e25146b4dbd96$export$f35c7d979dec8662 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { children: children, size: t1, weight: t2, truncate: t3 } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const weight = t2 === undefined ? "regular" : t2;
    const truncate = t3 === undefined ? false : t3;
    const t4 = truncate && "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _1ul9idpf _1bsb1osq _p12f1osq";
    let t5;
    if ($[0] !== t4) {
        t5 = (0, $hekY6.default)([
            "_11q7gl65 _y44vgcf4 _1lrwm4tz _pjrq1kdv _oo9g1j28 _1y1m1kdv",
            t4
        ]);
        $[0] = t4;
        $[1] = t5;
    } else t5 = $[1];
    let t6;
    if ($[2] !== children || $[3] !== size || $[4] !== weight) {
        t6 = /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            size: size,
            weight: weight,
            color: "color.text.subtlest"
        }, children);
        $[2] = children;
        $[3] = size;
        $[4] = weight;
        $[5] = t6;
    } else t6 = $[5];
    let t7;
    if ($[6] !== t5 || $[7] !== t6) {
        t7 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t5
        }, t6);
        $[6] = t5;
        $[7] = t6;
        $[8] = t7;
    } else t7 = $[8];
    return t7;
} : ({ children: children, size: size = 'medium', weight: weight = 'regular', truncate: truncate = false })=>{
    return /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_11q7gl65 _y44vgcf4 _1lrwm4tz _pjrq1kdv _oo9g1j28 _1y1m1kdv",
            truncate && "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _1ul9idpf _1bsb1osq _p12f1osq"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        size: size,
        weight: weight,
        color: "color.text.subtlest"
    }, children));
};
module.exports["ShimmerText"] = $b90e25146b4dbd96$export$f35c7d979dec8662;

});

parcelRegister("f6wWZ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $942fc30d2b38e6cb$var$animation = null;
const $942fc30d2b38e6cb$var$animation1 = null;
const $942fc30d2b38e6cb$var$animation2 = null;
const $942fc30d2b38e6cb$var$dot1 = null;
const $942fc30d2b38e6cb$var$dot2 = null;
const $942fc30d2b38e6cb$var$dot3 = null;
const $942fc30d2b38e6cb$var$animatedOpacity = null;
const $942fc30d2b38e6cb$export$c0e6915bcce7d1d0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(22);
    const { isAnimated: t1 } = t0;
    const isAnimated = t1 === undefined ? true : t1;
    const t2 = isAnimated && "";
    const t3 = isAnimated && "_y44v1gpk";
    const t4 = isAnimated && $942fc30d2b38e6cb$var$animatedOpacity;
    let t5;
    if ($[0] !== t2 || $[1] !== t3 || $[2] !== t4) {
        t5 = (0, $hekY6.default)([
            t2,
            t3,
            t4
        ]);
        $[0] = t2;
        $[1] = t3;
        $[2] = t4;
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== t5) {
        t6 = /*#__PURE__*/ $cozmU.createElement("path", {
            className: t5,
            d: "M0.0800781 2V0.414062H1.67969V2H0.0800781Z",
            fill: "#1868DB"
        });
        $[4] = t5;
        $[5] = t6;
    } else t6 = $[5];
    const t7 = isAnimated && "";
    const t8 = isAnimated && "_y44v18gg";
    const t9 = isAnimated && $942fc30d2b38e6cb$var$animatedOpacity;
    let t10;
    if ($[6] !== t7 || $[7] !== t8 || $[8] !== t9) {
        t10 = (0, $hekY6.default)([
            t7,
            t8,
            t9
        ]);
        $[6] = t7;
        $[7] = t8;
        $[8] = t9;
        $[9] = t10;
    } else t10 = $[9];
    let t11;
    if ($[10] !== t10) {
        t11 = /*#__PURE__*/ $cozmU.createElement("path", {
            className: t10,
            d: "M3.83984 2V0.414062H5.43945V2H3.83984Z",
            fill: "#BF63F3"
        });
        $[10] = t10;
        $[11] = t11;
    } else t11 = $[11];
    const t12 = isAnimated && "";
    const t13 = isAnimated && "_y44voqx9";
    const t14 = isAnimated && $942fc30d2b38e6cb$var$animatedOpacity;
    let t15;
    if ($[12] !== t12 || $[13] !== t13 || $[14] !== t14) {
        t15 = (0, $hekY6.default)([
            t12,
            t13,
            t14
        ]);
        $[12] = t12;
        $[13] = t13;
        $[14] = t14;
        $[15] = t15;
    } else t15 = $[15];
    let t16;
    if ($[16] !== t15) {
        t16 = /*#__PURE__*/ $cozmU.createElement("path", {
            className: t15,
            d: "M7.59961 2V0.414062H9.19922V2H7.59961Z",
            fill: "#FCA700"
        });
        $[16] = t15;
        $[17] = t16;
    } else t16 = $[17];
    let t17;
    if ($[18] !== t11 || $[19] !== t16 || $[20] !== t6) {
        t17 = /*#__PURE__*/ $cozmU.createElement("svg", {
            width: "10",
            height: "2",
            viewBox: "0 0 10 2",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, t6, t11, t16);
        $[18] = t11;
        $[19] = t16;
        $[20] = t6;
        $[21] = t17;
    } else t17 = $[21];
    return t17;
} : ({ isAnimated: isAnimated = true })=>{
    return /*#__PURE__*/ $cozmU.createElement("svg", {
        width: "10",
        height: "2",
        viewBox: "0 0 10 2",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $cozmU.createElement("path" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $hekY6.default)([
            isAnimated && "",
            isAnimated && "_y44v1gpk",
            isAnimated && $942fc30d2b38e6cb$var$animatedOpacity
        ]),
        d: "M0.0800781 2V0.414062H1.67969V2H0.0800781Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ $cozmU.createElement("path" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $hekY6.default)([
            isAnimated && "",
            isAnimated && "_y44v18gg",
            isAnimated && $942fc30d2b38e6cb$var$animatedOpacity
        ]),
        d: "M3.83984 2V0.414062H5.43945V2H3.83984Z",
        fill: "#BF63F3"
    }), /*#__PURE__*/ $cozmU.createElement("path" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $hekY6.default)([
            isAnimated && "",
            isAnimated && "_y44voqx9",
            isAnimated && $942fc30d2b38e6cb$var$animatedOpacity
        ]),
        d: "M7.59961 2V0.414062H9.19922V2H7.59961Z",
        fill: "#FCA700"
    }));
};
module.exports["EllipsesAnimation"] = $942fc30d2b38e6cb$export$c0e6915bcce7d1d0;

});

parcelRegister("ikV3b", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lvJXz = parcelRequire("lvJXz");


var $iDrrr = parcelRequire("iDrrr");

var $a17eb0eea75a6ca4$exports = {};
$a17eb0eea75a6ca4$exports = JSON.parse("{\"v\":\"5.7.1\",\"fr\":30,\"ip\":0,\"op\":108,\"w\":100,\"h\":100,\"nm\":\"Shape Morph\",\"ddd\":0,\"assets\":[],\"layers\":[{\"ddd\":0,\"ind\":1,\"ty\":4,\"nm\":\"Morph Shape\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":1,\"k\":[{\"t\":0,\"s\":[0],\"o\":{\"x\":[0.25],\"y\":[0]},\"i\":{\"x\":[0.5],\"y\":[1]}},{\"t\":27,\"s\":[180],\"o\":{\"x\":[0.25],\"y\":[0]},\"i\":{\"x\":[0.5],\"y\":[1]}},{\"t\":54,\"s\":[240],\"o\":{\"x\":[0.25],\"y\":[0]},\"i\":{\"x\":[0.5],\"y\":[1]}},{\"t\":80,\"s\":[360],\"o\":{\"x\":[0.25],\"y\":[0]},\"i\":{\"x\":[0.5],\"y\":[1]}},{\"t\":107,\"s\":[450]}]},\"p\":{\"a\":0,\"k\":[50,50,0]},\"a\":{\"a\":0,\"k\":[0,0,0]},\"s\":{\"a\":0,\"k\":[100,100,100]}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":1,\"k\":[{\"t\":0,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,-50],[6.499999999999993,-49.6],[12.899999999999999,-48.3],[19.099999999999994,-46.2],[25,-43.3],[30.400000000000006,-39.7],[35.400000000000006,-35.4],[39.7,-30.4],[43.3,-25],[46.2,-19.1],[48.3,-12.899999999999999],[49.599999999999994,-6.5],[50,0],[49.599999999999994,6.499999999999993],[48.3,12.899999999999999],[46.2,19.099999999999994],[43.3,25],[39.7,30.400000000000006],[35.400000000000006,35.400000000000006],[30.400000000000006,39.7],[25,43.3],[19.099999999999994,46.2],[12.899999999999999,48.3],[6.499999999999993,49.599999999999994],[0,50],[-6.5,49.599999999999994],[-12.899999999999999,48.3],[-19.1,46.2],[-25,43.3],[-30.4,39.7],[-35.4,35.400000000000006],[-39.7,30.400000000000006],[-43.3,25],[-46.2,19.099999999999994],[-48.3,12.899999999999999],[-49.6,6.499999999999993],[-50,0],[-49.6,-6.5],[-48.3,-12.899999999999999],[-46.2,-19.1],[-43.3,-25],[-39.7,-30.4],[-35.4,-35.4],[-30.4,-39.7],[-25,-43.3],[-19.1,-46.2],[-12.899999999999999,-48.3],[-6.5,-49.6]],\"c\":true}],\"o\":{\"x\":[0.25],\"y\":[0]},\"i\":{\"x\":[0.5],\"y\":[1]}},{\"t\":27,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[-50,-50],[-41.7,-50],[-33.3,-50],[-25,-50],[-16.700000000000003,-50],[-8.299999999999997,-50],[0,-50],[8.299999999999997,-50],[16.700000000000003,-50],[25,-50],[33.3,-50],[41.7,-50],[50,-50],[50,-41.7],[50,-33.3],[50,-25],[50,-16.700000000000003],[50,-8.299999999999997],[50,0],[50,8.299999999999997],[50,16.700000000000003],[50,25],[50,33.3],[50,41.7],[50,50],[41.7,50],[33.3,50],[25,50],[16.700000000000003,50],[8.299999999999997,50],[0,50],[-8.299999999999997,50],[-16.700000000000003,50],[-25,50],[-33.3,50],[-41.7,50],[-50,50],[-50,41.7],[-50,33.3],[-50,25],[-50,16.700000000000003],[-50,8.299999999999997],[-50,0],[-50,-8.299999999999997],[-50,-16.700000000000003],[-50,-25],[-50,-33.3],[-50,-41.7]],\"c\":true}],\"o\":{\"x\":[0.25],\"y\":[0]},\"i\":{\"x\":[0.5],\"y\":[1]}},{\"t\":54,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,-50],[5.3999999999999915,-46.9],[10.799999999999997,-43.7],[16.200000000000003,-40.6],[21.700000000000003,-37.5],[27.099999999999994,-34.4],[32.5,-31.2],[37.900000000000006,-28.1],[43.3,-25],[43.3,-18.7],[43.3,-12.5],[43.3,-6.200000000000003],[43.3,0],[43.3,6.299999999999997],[43.3,12.5],[43.3,18.799999999999997],[43.3,25],[37.900000000000006,28.099999999999994],[32.5,31.299999999999997],[27.099999999999994,34.400000000000006],[21.700000000000003,37.5],[16.200000000000003,40.599999999999994],[10.799999999999997,43.8],[5.3999999999999915,46.900000000000006],[0,50],[-5.399999999999999,46.900000000000006],[-10.799999999999997,43.8],[-16.200000000000003,40.599999999999994],[-21.699999999999996,37.5],[-27.1,34.400000000000006],[-32.5,31.299999999999997],[-37.9,28.099999999999994],[-43.3,25],[-43.3,18.799999999999997],[-43.3,12.5],[-43.3,6.299999999999997],[-43.3,0],[-43.3,-6.200000000000003],[-43.3,-12.5],[-43.3,-18.8],[-43.3,-25],[-37.9,-28.1],[-32.5,-31.3],[-27.1,-34.4],[-21.699999999999996,-37.5],[-16.200000000000003,-40.6],[-10.799999999999997,-43.7],[-5.399999999999999,-46.9]],\"c\":true}],\"o\":{\"x\":[0.25],\"y\":[0]},\"i\":{\"x\":[0.5],\"y\":[1]}},{\"t\":80,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,-50],[3.1000000000000014,-43.7],[6.299999999999997,-37.5],[9.399999999999999,-31.2],[12.5,-25],[15.599999999999994,-18.7],[18.799999999999997,-12.5],[21.900000000000006,-6.200000000000003],[25,0],[28.099999999999994,6.299999999999997],[31.299999999999997,12.5],[34.400000000000006,18.799999999999997],[37.5,25],[40.599999999999994,31.299999999999997],[43.8,37.5],[46.900000000000006,43.8],[50,50],[43.8,50],[37.5,50],[31.299999999999997,50],[25,50],[18.799999999999997,50],[12.5,50],[6.299999999999997,50],[0,50],[-6.200000000000003,50],[-12.5,50],[-18.7,50],[-25,50],[-31.2,50],[-37.5,50],[-43.7,50],[-50,50],[-46.9,43.8],[-43.7,37.5],[-40.6,31.299999999999997],[-37.5,25],[-34.4,18.799999999999997],[-31.2,12.5],[-28.1,6.299999999999997],[-25,0],[-21.9,-6.200000000000003],[-18.7,-12.5],[-15.600000000000001,-18.7],[-12.5,-25],[-9.399999999999999,-31.2],[-6.200000000000003,-37.5],[-3.1000000000000014,-43.7]],\"c\":true}],\"o\":{\"x\":[0.25],\"y\":[0]},\"i\":{\"x\":[0.5],\"y\":[1]}},{\"t\":107,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,-50],[6.499999999999993,-49.6],[12.899999999999999,-48.3],[19.099999999999994,-46.2],[25,-43.3],[30.400000000000006,-39.7],[35.400000000000006,-35.4],[39.7,-30.4],[43.3,-25],[46.2,-19.1],[48.3,-12.899999999999999],[49.599999999999994,-6.5],[50,0],[49.599999999999994,6.499999999999993],[48.3,12.899999999999999],[46.2,19.099999999999994],[43.3,25],[39.7,30.400000000000006],[35.400000000000006,35.400000000000006],[30.400000000000006,39.7],[25,43.3],[19.099999999999994,46.2],[12.899999999999999,48.3],[6.499999999999993,49.599999999999994],[0,50],[-6.5,49.599999999999994],[-12.899999999999999,48.3],[-19.1,46.2],[-25,43.3],[-30.4,39.7],[-35.4,35.400000000000006],[-39.7,30.400000000000006],[-43.3,25],[-46.2,19.099999999999994],[-48.3,12.899999999999999],[-49.6,6.499999999999993],[-50,0],[-49.6,-6.5],[-48.3,-12.899999999999999],[-46.2,-19.1],[-43.3,-25],[-39.7,-30.4],[-35.4,-35.4],[-30.4,-39.7],[-25,-43.3],[-19.1,-46.2],[-12.899999999999999,-48.3],[-6.5,-49.6]],\"c\":true}]}]},\"nm\":\"Path\",\"mn\":\"ADBE Vector Shape - Group\"},{\"ty\":\"fl\",\"c\":{\"a\":1,\"k\":[{\"t\":0,\"s\":[0.9607843137254902,0.6509803921568628,0.13725490196078433],\"o\":{\"x\":[0.5],\"y\":[0.5]},\"i\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":5,\"s\":[0.9607843137254902,0.6509803921568628,0.13725490196078433],\"o\":{\"x\":[0.5],\"y\":[0.5]},\"i\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":11,\"s\":[0.5098039215686274,0.7098039215686275,0.21176470588235294],\"o\":{\"x\":[0.5],\"y\":[0.5]},\"i\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":32,\"s\":[0.5098039215686274,0.7098039215686275,0.21176470588235294],\"o\":{\"x\":[0.5],\"y\":[0.5]},\"i\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":37,\"s\":[0.09411764705882353,0.40784313725490196,0.8588235294117647],\"o\":{\"x\":[0.5],\"y\":[0.5]},\"i\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":59,\"s\":[0.09411764705882353,0.40784313725490196,0.8588235294117647],\"o\":{\"x\":[0.5],\"y\":[0.5]},\"i\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":64,\"s\":[0.7490196078431373,0.38823529411764707,0.9529411764705882],\"o\":{\"x\":[0.5],\"y\":[0.5]},\"i\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":86,\"s\":[0.7490196078431373,0.38823529411764707,0.9529411764705882],\"o\":{\"x\":[0.5],\"y\":[0.5]},\"i\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":91,\"s\":[0.9607843137254902,0.6509803921568628,0.13725490196078433],\"o\":{\"x\":[0.5],\"y\":[0.5]},\"i\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":107,\"s\":[0.9607843137254902,0.6509803921568628,0.13725490196078433]}]},\"o\":{\"a\":0,\"k\":100},\"r\":1,\"nm\":\"Fill\"},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[0,0]},\"a\":{\"a\":0,\"k\":[0,0]},\"s\":{\"a\":0,\"k\":[100,100]},\"r\":{\"a\":0,\"k\":0},\"o\":{\"a\":0,\"k\":100}}],\"nm\":\"Shape Group\",\"np\":3}],\"ip\":0,\"op\":108,\"st\":0,\"bm\":0}]}");


// Module-level state — persists the current frame across remounts
// so the morphing animation continues smoothly without restarting.
let $922511a0939f4ef0$var$savedFrame = 0;
let $922511a0939f4ef0$var$hasPlayedBefore = false;
const $922511a0939f4ef0$var$getSafeFrame = (frame)=>Number.isFinite(frame) && frame >= 0 ? frame : 0;
const $922511a0939f4ef0$var$SIZE_MAP = {
    small: 16,
    medium: 24,
    large: 32
};
const $922511a0939f4ef0$export$c07a397cf5c24cd8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { testId: testId, size: t1 } = t0;
    const size = t1 === undefined ? "small" : t1;
    const containerRef = (0, $cozmU.useRef)(null);
    const lottieSize = (0, $iDrrr.fg)("rovo_morphing_shape_loader_size") ? $922511a0939f4ef0$var$SIZE_MAP[size] : 16;
    const containerSize = (0, $iDrrr.fg)("rovo_morphing_shape_loader_size") ? lottieSize + 8 : 24;
    let t2;
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            const currentRef = containerRef.current;
            if (!currentRef) return;
            const baseAnimationConfig = {
                container: currentRef,
                animationData: (0, (/*@__PURE__*/$parcel$interopDefault($a17eb0eea75a6ca4$exports))),
                renderer: "svg",
                loop: true
            };
            if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($lvJXz))).loadAnimation !== "function") return;
            const animationInstance = (0, (/*@__PURE__*/$parcel$interopDefault($lvJXz))).loadAnimation({
                ...baseAnimationConfig,
                autoplay: true
            });
            if ($922511a0939f4ef0$var$hasPlayedBefore) animationInstance.goToAndPlay($922511a0939f4ef0$var$getSafeFrame($922511a0939f4ef0$var$savedFrame), true);
            $922511a0939f4ef0$var$hasPlayedBefore = true;
            return ()=>{
                $922511a0939f4ef0$var$savedFrame = $922511a0939f4ef0$var$getSafeFrame(animationInstance.currentFrame);
                animationInstance.destroy();
            };
        };
        t3 = [];
        $[0] = t2;
        $[1] = t3;
    } else {
        t2 = $[0];
        t3 = $[1];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[2] !== containerSize) {
        t4 = {
            width: containerSize,
            height: containerSize,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "visible"
        };
        $[2] = containerSize;
        $[3] = t4;
    } else t4 = $[3];
    const containerStyle = t4;
    let t5;
    if ($[4] !== lottieSize) {
        t5 = {
            width: lottieSize,
            height: lottieSize
        };
        $[4] = lottieSize;
        $[5] = t5;
    } else t5 = $[5];
    const lottieWrapperStyle = t5;
    let t6;
    if ($[6] !== lottieWrapperStyle) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: lottieWrapperStyle,
            ref: containerRef
        });
        $[6] = lottieWrapperStyle;
        $[7] = t6;
    } else t6 = $[7];
    let t7;
    if ($[8] !== containerStyle || $[9] !== t6 || $[10] !== testId) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: containerStyle,
            "data-testid": testId
        }, t6);
        $[8] = containerStyle;
        $[9] = t6;
        $[10] = testId;
        $[11] = t7;
    } else t7 = $[11];
    return t7;
} : ({ testId: testId, size: size = 'small' })=>{
    const containerRef = (0, $cozmU.useRef)(null);
    const lottieSize = (0, $iDrrr.fg)('rovo_morphing_shape_loader_size') ? $922511a0939f4ef0$var$SIZE_MAP[size] : 16;
    const containerSize = (0, $iDrrr.fg)('rovo_morphing_shape_loader_size') ? lottieSize + 8 : 24;
    (0, $cozmU.useEffect)(()=>{
        const currentRef = containerRef.current;
        if (!currentRef) return;
        const baseAnimationConfig = {
            container: currentRef,
            animationData: (0, (/*@__PURE__*/$parcel$interopDefault($a17eb0eea75a6ca4$exports))),
            renderer: 'svg',
            loop: true
        };
        if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($lvJXz))).loadAnimation !== 'function') return;
        const animationInstance = (0, (/*@__PURE__*/$parcel$interopDefault($lvJXz))).loadAnimation({
            ...baseAnimationConfig,
            autoplay: true
        });
        if ($922511a0939f4ef0$var$hasPlayedBefore) // Remount — resume from saved frame, while still autoplaying as a visible fallback.
        animationInstance.goToAndPlay($922511a0939f4ef0$var$getSafeFrame($922511a0939f4ef0$var$savedFrame), true);
        $922511a0939f4ef0$var$hasPlayedBefore = true;
        return ()=>{
            // Save current frame before destroying
            $922511a0939f4ef0$var$savedFrame = $922511a0939f4ef0$var$getSafeFrame(animationInstance.currentFrame);
            animationInstance.destroy();
        };
    }, []);
    const containerStyle = {
        width: containerSize,
        height: containerSize,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'visible'
    };
    const lottieWrapperStyle = {
        width: lottieSize,
        height: lottieSize
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- static styles for lottie container
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        style: containerStyle,
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        style: lottieWrapperStyle,
        ref: containerRef
    })));
};
module.exports["MorphingShapeLoader"] = $922511a0939f4ef0$export$c07a397cf5c24cd8;

});

parcelRegister("k22Xw", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $91ZZN = parcelRequire("91ZZN");


const $e5a0bad3f68b70bd$var$LazyRovoLoadingGif = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("Bttch")));
const $e5a0bad3f68b70bd$export$7ea4e54699cd5224 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { alt: t1, testId: t2, width: t3, height: t4 } = t0;
    const alt = t1 === undefined ? "" : t1;
    const testId = t2 === undefined ? "" : t2;
    const width = t3 === undefined ? "" : t3;
    const height = t4 === undefined ? "" : t4;
    let t5;
    if ($[0] !== alt || $[1] !== height || $[2] !== testId || $[3] !== width) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
            interactionName: "rovo-platform-ui-animated-icon",
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e5a0bad3f68b70bd$var$LazyRovoLoadingGif, {
            alt: alt,
            testId: testId,
            width: width,
            height: height
        }));
        $[0] = alt;
        $[1] = height;
        $[2] = testId;
        $[3] = width;
        $[4] = t5;
    } else t5 = $[4];
    return t5;
} : ({ alt: alt = '', testId: testId = '', width: width = '', height: height = '' })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
        interactionName: "rovo-platform-ui-animated-icon",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e5a0bad3f68b70bd$var$LazyRovoLoadingGif, {
        alt: alt,
        testId: testId,
        width: width,
        height: height
    }));
});
module.exports["LazyAnimatedRovoIcon"] = $e5a0bad3f68b70bd$export$7ea4e54699cd5224;

});

parcelRegister("Bttch", function(module, exports) {

let $070a50ed8fa7d465$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $070a50ed8fa7d465$var$load("70zyE").then(()=>parcelRequire('hGjSS'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("8VrqA", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $kMkDS = parcelRequire("kMkDS");




const $12b4cc67f5ec0d6d$var$message = (0, $kSwu1.defineMessages)({
    highlightActionsPlaceholderPrompt: {
        id: "highlight-actions.rovo-chat.placeholder-prompt",
        defaultMessage: "Ask a question about this."
    }
});
var $12b4cc67f5ec0d6d$export$2e2bcd8739ae039 = $12b4cc67f5ec0d6d$var$message;


const $e14a5679e33f0f1b$var$state = (0, $8s9DV.createStore)({
    initialState: {
        highlightActionsEditorPlaceholder: null
    },
    actions: {
        setHighlightActionsEditorPlaceholder: (highlightActionsEditorPlaceholder)=>({ setState: setState })=>{
                setState({
                    highlightActionsEditorPlaceholder: highlightActionsEditorPlaceholder
                });
            }
    }
});
const $e14a5679e33f0f1b$export$e638cf26ae51308d = (0, $kBr4q.createHook)($e14a5679e33f0f1b$var$state);
const $e14a5679e33f0f1b$var$getHighlightActionPlaceholderData = (prompt, placeholderText)=>{
    const promptContent = (0, $kMkDS.appendADFContent)(prompt, placeholderText);
    return promptContent;
};
const $e14a5679e33f0f1b$export$21b2d5ca0689f678 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(9);
    const [t0, t1] = $e14a5679e33f0f1b$export$e638cf26ae51308d();
    const { highlightActionsEditorPlaceholder: highlightActionsEditorPlaceholder } = t0;
    const { setHighlightActionsEditorPlaceholder: setHighlightActionsEditorPlaceholder } = t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t2;
    if ($[0] !== formatMessage || $[1] !== setHighlightActionsEditorPlaceholder) {
        t2 = (prompt, options)=>{
            const placeholderData = options?.skipPlaceholderPrompt ? prompt : $e14a5679e33f0f1b$var$getHighlightActionPlaceholderData(prompt, formatMessage((0, $12b4cc67f5ec0d6d$export$2e2bcd8739ae039).highlightActionsPlaceholderPrompt));
            setHighlightActionsEditorPlaceholder(placeholderData);
        };
        $[0] = formatMessage;
        $[1] = setHighlightActionsEditorPlaceholder;
        $[2] = t2;
    } else t2 = $[2];
    const insertHighlightActionsEditorPlaceholder = t2;
    let t3;
    if ($[3] !== setHighlightActionsEditorPlaceholder) {
        t3 = ()=>{
            setHighlightActionsEditorPlaceholder(null);
        };
        $[3] = setHighlightActionsEditorPlaceholder;
        $[4] = t3;
    } else t3 = $[4];
    const clearHighlightActionsEditorPlaceholder = t3;
    let t4;
    if ($[5] !== clearHighlightActionsEditorPlaceholder || $[6] !== highlightActionsEditorPlaceholder || $[7] !== insertHighlightActionsEditorPlaceholder) {
        t4 = {
            highlightActionsEditorPlaceholder: highlightActionsEditorPlaceholder,
            insertHighlightActionsEditorPlaceholder: insertHighlightActionsEditorPlaceholder,
            clearHighlightActionsEditorPlaceholder: clearHighlightActionsEditorPlaceholder
        };
        $[5] = clearHighlightActionsEditorPlaceholder;
        $[6] = highlightActionsEditorPlaceholder;
        $[7] = insertHighlightActionsEditorPlaceholder;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
} : ()=>{
    const [{ highlightActionsEditorPlaceholder: highlightActionsEditorPlaceholder }, { setHighlightActionsEditorPlaceholder: setHighlightActionsEditorPlaceholder }] = $e14a5679e33f0f1b$export$e638cf26ae51308d();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const insertHighlightActionsEditorPlaceholder = (0, $cozmU.useCallback)((prompt, options)=>{
        // When `skipPlaceholderPrompt` is set, seed the editor with the prompt
        // exactly as provided instead of appending the highlight-action
        // "Ask a question about this." trailer. This lets non-highlight callers
        // (e.g. a prompt supplied via URL param) pre-fill the input as an
        // editable draft without injecting extra text.
        const placeholderData = options?.skipPlaceholderPrompt ? prompt : $e14a5679e33f0f1b$var$getHighlightActionPlaceholderData(prompt, formatMessage((0, $12b4cc67f5ec0d6d$export$2e2bcd8739ae039).highlightActionsPlaceholderPrompt));
        setHighlightActionsEditorPlaceholder(placeholderData);
    }, [
        setHighlightActionsEditorPlaceholder,
        formatMessage
    ]);
    const clearHighlightActionsEditorPlaceholder = (0, $cozmU.useCallback)(()=>{
        setHighlightActionsEditorPlaceholder(null);
    }, [
        setHighlightActionsEditorPlaceholder
    ]);
    return {
        highlightActionsEditorPlaceholder: highlightActionsEditorPlaceholder,
        insertHighlightActionsEditorPlaceholder: insertHighlightActionsEditorPlaceholder,
        clearHighlightActionsEditorPlaceholder: clearHighlightActionsEditorPlaceholder
    };
};
module.exports["useHighlightActionsEditorPlaceholder"] = $e14a5679e33f0f1b$export$21b2d5ca0689f678;

});

parcelRegister("banCF", function(module, exports) {

var $cozmU = parcelRequire("cozmU");




var $dc77ad8576485322$export$2e2bcd8739ae039 = (0, $cozmU.useLayoutEffect);


parcelRequire("cgKJK");
var $96dZ7 = parcelRequire("96dZ7");




var $aSzLn = parcelRequire("aSzLn");


var $6nvBr = parcelRequire("6nvBr");

const $021914730fb82814$var$forEachActor = (actorRef, callback)=>{
    callback(actorRef);
    const children = actorRef.getSnapshot().children;
    if (children) Object.values(children).forEach((child)=>{
        $021914730fb82814$var$forEachActor(child, callback);
    });
};
function $021914730fb82814$var$stopRootWithRehydration(actorRef) {
    // persist snapshot here in a custom way allows us to persist inline actors and to preserve actor references
    // we do it to avoid setState in useEffect when the effect gets "reconnected"
    // this currently only happens in Strict Effects but it simulates the Offscreen aka Activity API
    // it also just allows us to end up with a somewhat more predictable behavior for the users
    const persistedSnapshots = [];
    $021914730fb82814$var$forEachActor(actorRef, (ref)=>{
        persistedSnapshots.push([
            ref,
            ref.getSnapshot()
        ]);
        // muting observers allow us to avoid `useSelector` from being notified about the stopped snapshot
        // React reconnects its subscribers (from the useSyncExternalStore) on its own
        // and userland subscibers should basically always do the same anyway
        // as each subscription should have its own cleanup logic and that should be called each such reconnect
        ref.observers = new Set();
    });
    const systemSnapshot = actorRef.system.getSnapshot?.();
    actorRef.stop();
    actorRef.system._snapshot = systemSnapshot;
    persistedSnapshots.forEach(([ref, snapshot])=>{
        ref._processingStatus = 0;
        ref._snapshot = snapshot;
    });
}
function $021914730fb82814$var$useIdleActorRef(logic, ...[options]) {
    let [[currentConfig, actorRef], setCurrent] = (0, $cozmU.useState)(()=>{
        const actorRef = (0, $96dZ7.A)(logic, options);
        return [
            logic.config,
            actorRef
        ];
    });
    if (logic.config !== currentConfig) {
        const newActorRef = (0, $96dZ7.A)(logic, {
            ...options,
            snapshot: actorRef.getPersistedSnapshot({
                __unsafeAllowInlineActors: true
            })
        });
        setCurrent([
            logic.config,
            newActorRef
        ]);
        actorRef = newActorRef;
    }
    // TODO: consider using `useAsapEffect` that would do this in `useInsertionEffect` is that's available
    (0, $dc77ad8576485322$export$2e2bcd8739ae039)(()=>{
        actorRef.logic.implementations = logic.implementations;
    });
    return actorRef;
}
function $021914730fb82814$export$e92bd910f9c89ff6(machine, ...[options, observerOrListener]) {
    const actorRef = $021914730fb82814$var$useIdleActorRef(machine, options);
    (0, $cozmU.useEffect)(()=>{
        if (!observerOrListener) return;
        const sub = actorRef.subscribe((0, $96dZ7.L)(observerOrListener));
        return ()=>{
            sub.unsubscribe();
        };
    }, [
        observerOrListener
    ]);
    (0, $cozmU.useEffect)(()=>{
        actorRef.start();
        return ()=>{
            $021914730fb82814$var$stopRootWithRehydration(actorRef);
        };
    }, [
        actorRef
    ]);
    return actorRef;
}
function $021914730fb82814$var$defaultCompare(a, b) {
    return a === b;
}
function $021914730fb82814$export$2105062e25df4afe(actor, selector, compare = $021914730fb82814$var$defaultCompare) {
    const subscribe = (0, $cozmU.useCallback)((handleStoreChange)=>{
        if (!actor) return ()=>{};
        const { unsubscribe: unsubscribe } = actor.subscribe(handleStoreChange);
        return unsubscribe;
    }, [
        actor
    ]);
    const boundGetSnapshot = (0, $cozmU.useCallback)(()=>actor?.getSnapshot(), [
        actor
    ]);
    const selectedSnapshot = (0, $aSzLn.useSyncExternalStoreWithSelector)(subscribe, boundGetSnapshot, boundGetSnapshot, selector, compare);
    return selectedSnapshot;
}
function $021914730fb82814$export$72ba36f8308928ab(actorLogic, actorOptions) {
    const ReactContext = /*#__PURE__*/ $cozmU.createContext(null);
    const OriginalProvider = ReactContext.Provider;
    function Provider({ children: children, logic: providedLogic = actorLogic, machine: machine, options: providedOptions }) {
        if (machine) throw new Error(`The "machine" prop has been deprecated. Please use "logic" instead.`);
        const actor = $021914730fb82814$export$e92bd910f9c89ff6(providedLogic, {
            ...actorOptions,
            ...providedOptions
        });
        return /*#__PURE__*/ $cozmU.createElement(OriginalProvider, {
            value: actor,
            children: children
        });
    }
    // TODO: add properties to actor ref to make more descriptive
    Provider.displayName = `ActorProvider`;
    function useContext() {
        const actor = $cozmU.useContext(ReactContext);
        if (!actor) throw new Error(`You used a hook from "${Provider.displayName}" but it's not inside a <${Provider.displayName}> component.`);
        return actor;
    }
    function useSelector$1(selector, compare) {
        const actor = useContext();
        return $021914730fb82814$export$2105062e25df4afe(actor, selector, compare);
    }
    return {
        Provider: Provider,
        useActorRef: useContext,
        useSelector: useSelector$1
    };
}
// From https://github.com/reduxjs/react-redux/blob/720f0ba79236cdc3e1115f4ef9a7760a21784b48/src/utils/shallowEqual.ts
function $021914730fb82814$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $021914730fb82814$export$d36bdfa510afb180(objA, objB) {
    if ($021914730fb82814$var$is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$021914730fb82814$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
function $021914730fb82814$export$25c4ab29592aabd9(logic, ...[options]) {
    const actorRef = $021914730fb82814$var$useIdleActorRef(logic, options);
    const getSnapshot = (0, $cozmU.useCallback)(()=>{
        return actorRef.getSnapshot();
    }, [
        actorRef
    ]);
    const subscribe = (0, $cozmU.useCallback)((handleStoreChange)=>{
        const { unsubscribe: unsubscribe } = actorRef.subscribe(handleStoreChange);
        return unsubscribe;
    }, [
        actorRef
    ]);
    const actorSnapshot = (0, $6nvBr.useSyncExternalStore)(subscribe, getSnapshot, getSnapshot);
    (0, $cozmU.useEffect)(()=>{
        actorRef.start();
        return ()=>{
            $021914730fb82814$var$stopRootWithRehydration(actorRef);
        };
    }, [
        actorRef
    ]);
    return [
        actorSnapshot,
        actorRef.send,
        actorRef
    ];
}
/** @alias useActor */ function $021914730fb82814$export$e0338c4153421160(machine, ...[options]) {
    return $021914730fb82814$export$25c4ab29592aabd9(machine, options);
}
module.exports["useActorRef"] = $021914730fb82814$export$e92bd910f9c89ff6;
module.exports["useSelector"] = $021914730fb82814$export$2105062e25df4afe;
module.exports["createActorContext"] = $021914730fb82814$export$72ba36f8308928ab;
module.exports["shallowEqual"] = $021914730fb82814$export$d36bdfa510afb180;
module.exports["useMachine"] = $021914730fb82814$export$e0338c4153421160;

});

parcelRegister("cgKJK", function(module, exports) {
$parcel$export(module.exports, "createActor", () => (parcelRequire("96dZ7")).A);
$parcel$export(module.exports, "assign", () => (parcelRequire("dpSRg")).a);

var $eXLWP = parcelRequire("eXLWP");


var $96dZ7 = parcelRequire("96dZ7");


var $dpSRg = parcelRequire("dpSRg");

parcelRequire("e6Soq");

/**
 * Asserts that the given event object is of the specified type or types. Throws
 * an error if the event object is not of the specified types.
 *
 * @example
 *
 * ```ts
 * // ...
 * entry: ({ event }) => {
 *   assertEvent(event, 'doNothing');
 *   // event is { type: 'doNothing' }
 * },
 * // ...
 * exit: ({ event }) => {
 *   assertEvent(event, 'greet');
 *   // event is { type: 'greet'; message: string }
 *
 *   assertEvent(event, ['greet', 'notify']);
 *   // event is { type: 'greet'; message: string }
 *   // or { type: 'notify'; message: string; level: 'info' | 'error' }
 * },
 * ```
 */ function $8eeb3b9b9ffbca82$export$b3e112bfd3a4f448(event, type) {
    const types = (0, $96dZ7.t)(type);
    if (!types.includes(event.type)) {
        const typesText = types.length === 1 ? `type "${types[0]}"` : `one of types "${types.join('", "')}"`;
        throw new Error(`Expected event ${JSON.stringify(event)} to have ${typesText}`);
    }
}
const $8eeb3b9b9ffbca82$var$cache = new WeakMap();
function $8eeb3b9b9ffbca82$var$memo(object, key, fn) {
    let memoizedData = $8eeb3b9b9ffbca82$var$cache.get(object);
    if (!memoizedData) {
        memoizedData = {
            [key]: fn()
        };
        $8eeb3b9b9ffbca82$var$cache.set(object, memoizedData);
    } else if (!(key in memoizedData)) memoizedData[key] = fn();
    return memoizedData[key];
}
const $8eeb3b9b9ffbca82$var$EMPTY_OBJECT = {};
const $8eeb3b9b9ffbca82$var$toSerializableAction = (action)=>{
    if (typeof action === 'string') return {
        type: action
    };
    if (typeof action === 'function') {
        if ('resolve' in action) return {
            type: action.type
        };
        return {
            type: action.name
        };
    }
    return action;
};
class $8eeb3b9b9ffbca82$export$342f24f5edd47b1 {
    /** @internal */ _initialize() {
        this.transitions = (0, $96dZ7.f)(this);
        if (this.config.always) this.always = (0, $96dZ7.a)(this.config.always).map((t)=>(0, $96dZ7.b)(this, (0, $96dZ7.N), t));
        Object.keys(this.states).forEach((key)=>{
            this.states[key]._initialize();
        });
    }
    /** The well-structured state node definition. */ get definition() {
        return {
            id: this.id,
            key: this.key,
            version: this.machine.version,
            type: this.type,
            initial: this.initial ? {
                target: this.initial.target,
                source: this,
                actions: this.initial.actions.map($8eeb3b9b9ffbca82$var$toSerializableAction),
                eventType: null,
                reenter: false,
                toJSON: ()=>({
                        target: this.initial.target.map((t)=>`#${t.id}`),
                        source: `#${this.id}`,
                        actions: this.initial.actions.map($8eeb3b9b9ffbca82$var$toSerializableAction),
                        eventType: null
                    })
            } : undefined,
            history: this.history,
            states: (0, $96dZ7.m)(this.states, (state)=>{
                return state.definition;
            }),
            on: this.on,
            transitions: [
                ...this.transitions.values()
            ].flat().map((t)=>({
                    ...t,
                    actions: t.actions.map($8eeb3b9b9ffbca82$var$toSerializableAction)
                })),
            entry: this.entry.map($8eeb3b9b9ffbca82$var$toSerializableAction),
            exit: this.exit.map($8eeb3b9b9ffbca82$var$toSerializableAction),
            meta: this.meta,
            order: this.order || -1,
            output: this.output,
            invoke: this.invoke,
            description: this.description,
            tags: this.tags
        };
    }
    /** @internal */ toJSON() {
        return this.definition;
    }
    /** The logic invoked as actors by this state node. */ get invoke() {
        return $8eeb3b9b9ffbca82$var$memo(this, 'invoke', ()=>(0, $96dZ7.t)(this.config.invoke).map((invokeConfig, i)=>{
                const { src: src, systemId: systemId } = invokeConfig;
                const resolvedId = invokeConfig.id ?? (0, $96dZ7.c)(this.id, i);
                const sourceName = typeof src === 'string' ? src : `xstate.invoke.${(0, $96dZ7.c)(this.id, i)}`;
                return {
                    ...invokeConfig,
                    src: sourceName,
                    id: resolvedId,
                    systemId: systemId,
                    toJSON () {
                        const { onDone: onDone, onError: onError, ...invokeDefValues } = invokeConfig;
                        return {
                            ...invokeDefValues,
                            type: 'xstate.invoke',
                            src: sourceName,
                            id: resolvedId
                        };
                    }
                };
            }));
    }
    /** The mapping of events to transitions. */ get on() {
        return $8eeb3b9b9ffbca82$var$memo(this, 'on', ()=>{
            const transitions = this.transitions;
            return [
                ...transitions
            ].flatMap(([descriptor, t])=>t.map((t)=>[
                        descriptor,
                        t
                    ])).reduce((map, [descriptor, transition])=>{
                map[descriptor] = map[descriptor] || [];
                map[descriptor].push(transition);
                return map;
            }, {});
        });
    }
    get after() {
        return $8eeb3b9b9ffbca82$var$memo(this, 'delayedTransitions', ()=>(0, $96dZ7.g)(this));
    }
    get initial() {
        return $8eeb3b9b9ffbca82$var$memo(this, 'initial', ()=>(0, $96dZ7.d)(this, this.config.initial));
    }
    /** @internal */ next(snapshot, event) {
        const eventType = event.type;
        const actions = [];
        let selectedTransition;
        const candidates = $8eeb3b9b9ffbca82$var$memo(this, `candidates-${eventType}`, ()=>(0, $96dZ7.h)(this, eventType));
        for (const candidate of candidates){
            const { guard: guard } = candidate;
            const resolvedContext = snapshot.context;
            let guardPassed = false;
            try {
                guardPassed = !guard || (0, $96dZ7.e)(guard, resolvedContext, event, snapshot);
            } catch (err) {
                const guardType = typeof guard === 'string' ? guard : typeof guard === 'object' ? guard.type : undefined;
                throw new Error(`Unable to evaluate guard ${guardType ? `'${guardType}' ` : ''}in transition for event '${eventType}' in state node '${this.id}':\n${err.message}`);
            }
            if (guardPassed) {
                actions.push(...candidate.actions);
                selectedTransition = candidate;
                break;
            }
        }
        return selectedTransition ? [
            selectedTransition
        ] : undefined;
    }
    /** All the event types accepted by this state node and its descendants. */ get events() {
        return $8eeb3b9b9ffbca82$var$memo(this, 'events', ()=>{
            const { states: states } = this;
            const events = new Set(this.ownEvents);
            if (states) for (const stateId of Object.keys(states)){
                const state = states[stateId];
                if (state.states) for (const event of state.events)events.add(`${event}`);
            }
            return Array.from(events);
        });
    }
    /**
   * All the events that have transitions directly from this state node.
   *
   * Excludes any inert events.
   */ get ownEvents() {
        const events = new Set([
            ...this.transitions.keys()
        ].filter((descriptor)=>{
            return this.transitions.get(descriptor).some((transition)=>!(!transition.target && !transition.actions.length && !transition.reenter));
        }));
        return Array.from(events);
    }
    constructor(/** The raw config used to create the machine. */ config, options){
        this.config = config;
        /**
     * The relative key of the state node, which represents its location in the
     * overall state value.
     */ this.key = void 0;
        /** The unique ID of the state node. */ this.id = void 0;
        /**
     * The type of this state node:
     *
     * - `'atomic'` - no child state nodes
     * - `'compound'` - nested child state nodes (XOR)
     * - `'parallel'` - orthogonal nested child state nodes (AND)
     * - `'history'` - history state node
     * - `'final'` - final state node
     */ this.type = void 0;
        /** The string path from the root machine node to this node. */ this.path = void 0;
        /** The child state nodes. */ this.states = void 0;
        /**
     * The type of history on this state node. Can be:
     *
     * - `'shallow'` - recalls only top-level historical state value
     * - `'deep'` - recalls historical state value at all levels
     */ this.history = void 0;
        /** The action(s) to be executed upon entering the state node. */ this.entry = void 0;
        /** The action(s) to be executed upon exiting the state node. */ this.exit = void 0;
        /** The parent state node. */ this.parent = void 0;
        /** The root machine node. */ this.machine = void 0;
        /**
     * The meta data associated with this state node, which will be returned in
     * State instances.
     */ this.meta = void 0;
        /**
     * The output data sent with the "xstate.done.state._id_" event if this is a
     * final state node.
     */ this.output = void 0;
        /**
     * The order this state node appears. Corresponds to the implicit document
     * order.
     */ this.order = -1;
        this.description = void 0;
        this.tags = [];
        this.transitions = void 0;
        this.always = void 0;
        this.parent = options._parent;
        this.key = options._key;
        this.machine = options._machine;
        this.path = this.parent ? this.parent.path.concat(this.key) : [];
        this.id = this.config.id || [
            this.machine.id,
            ...this.path
        ].join((0, $96dZ7.S));
        this.type = this.config.type || (this.config.states && Object.keys(this.config.states).length ? 'compound' : this.config.history ? 'history' : 'atomic');
        this.description = this.config.description;
        this.order = this.machine.idMap.size;
        this.machine.idMap.set(this.id, this);
        this.states = this.config.states ? (0, $96dZ7.m)(this.config.states, (stateConfig, key)=>{
            const stateNode = new $8eeb3b9b9ffbca82$export$342f24f5edd47b1(stateConfig, {
                _parent: this,
                _key: key,
                _machine: this.machine
            });
            return stateNode;
        }) : $8eeb3b9b9ffbca82$var$EMPTY_OBJECT;
        if (this.type === 'compound' && !this.config.initial) throw new Error(`No initial state specified for compound state node "#${this.id}". Try adding { initial: "${Object.keys(this.states)[0]}" } to the state config.`);
        // History config
        this.history = this.config.history === true ? 'shallow' : this.config.history || false;
        this.entry = (0, $96dZ7.t)(this.config.entry).slice();
        this.exit = (0, $96dZ7.t)(this.config.exit).slice();
        this.meta = this.config.meta;
        this.output = this.type === 'final' || !this.parent ? this.config.output : undefined;
        this.tags = (0, $96dZ7.t)(config.tags).slice();
    }
}
const $8eeb3b9b9ffbca82$var$STATE_IDENTIFIER = '#';
class $8eeb3b9b9ffbca82$export$cbf2d83d1eab018a {
    /**
   * Clones this state machine with the provided implementations and merges the
   * `context` (if provided).
   *
   * @param implementations Options (`actions`, `guards`, `actors`, `delays`,
   *   `context`) to recursively merge with the existing options.
   * @returns A new `StateMachine` instance with the provided implementations.
   */ provide(implementations) {
        const { actions: actions, guards: guards, actors: actors, delays: delays } = this.implementations;
        return new $8eeb3b9b9ffbca82$export$cbf2d83d1eab018a(this.config, {
            actions: {
                ...actions,
                ...implementations.actions
            },
            guards: {
                ...guards,
                ...implementations.guards
            },
            actors: {
                ...actors,
                ...implementations.actors
            },
            delays: {
                ...delays,
                ...implementations.delays
            }
        });
    }
    resolveState(config) {
        const resolvedStateValue = (0, $96dZ7.r)(this.root, config.value);
        const nodeSet = (0, $96dZ7.i)((0, $96dZ7.j)(this.root, resolvedStateValue));
        return (0, $96dZ7.k)({
            _nodes: [
                ...nodeSet
            ],
            context: config.context || {},
            children: {},
            status: (0, $96dZ7.l)(nodeSet, this.root) ? 'done' : config.status || 'active',
            output: config.output,
            error: config.error,
            historyValue: config.historyValue
        }, this);
    }
    /**
   * Determines the next snapshot given the current `snapshot` and received
   * `event`. Calculates a full macrostep from all microsteps.
   *
   * @param snapshot The current snapshot
   * @param event The received event
   */ transition(snapshot, event, actorScope) {
        return (0, $96dZ7.n)(snapshot, event, actorScope, []).snapshot;
    }
    /**
   * Determines the next state given the current `state` and `event`. Calculates
   * a microstep.
   *
   * @param state The current state
   * @param event The received event
   */ microstep(snapshot, event, actorScope) {
        return (0, $96dZ7.n)(snapshot, event, actorScope, []).microstates;
    }
    getTransitionData(snapshot, event) {
        return (0, $96dZ7.o)(this.root, snapshot.value, snapshot, event) || [];
    }
    /**
   * The initial state _before_ evaluating any microsteps. This "pre-initial"
   * state is provided to initial actions executed in the initial state.
   */ getPreInitialState(actorScope, initEvent, internalQueue) {
        const { context: context } = this.config;
        const preInitial = (0, $96dZ7.k)({
            context: typeof context !== 'function' && context ? context : {},
            _nodes: [
                this.root
            ],
            children: {},
            status: 'active'
        }, this);
        if (typeof context === 'function') {
            const assignment = ({ spawn: spawn, event: event, self: self })=>context({
                    spawn: spawn,
                    input: event.input,
                    self: self
                });
            return (0, $96dZ7.p)(preInitial, initEvent, actorScope, [
                (0, $dpSRg.a)(assignment)
            ], internalQueue, undefined);
        }
        return preInitial;
    }
    /**
   * Returns the initial `State` instance, with reference to `self` as an
   * `ActorRef`.
   */ getInitialSnapshot(actorScope, input) {
        const initEvent = (0, $96dZ7.q)(input); // TODO: fix;
        const internalQueue = [];
        const preInitialState = this.getPreInitialState(actorScope, initEvent, internalQueue);
        const nextState = (0, $96dZ7.s)([
            {
                target: [
                    ...(0, $96dZ7.u)(this.root)
                ],
                source: this.root,
                reenter: true,
                actions: [],
                eventType: null,
                toJSON: null // TODO: fix
            }
        ], preInitialState, actorScope, initEvent, true, internalQueue);
        const { snapshot: macroState } = (0, $96dZ7.n)(nextState, initEvent, actorScope, internalQueue);
        return macroState;
    }
    start(snapshot) {
        Object.values(snapshot.children).forEach((child)=>{
            if (child.getSnapshot().status === 'active') child.start();
        });
    }
    getStateNodeById(stateId) {
        const fullPath = (0, $96dZ7.v)(stateId);
        const relativePath = fullPath.slice(1);
        const resolvedStateId = (0, $96dZ7.w)(fullPath[0]) ? fullPath[0].slice($8eeb3b9b9ffbca82$var$STATE_IDENTIFIER.length) : fullPath[0];
        const stateNode = this.idMap.get(resolvedStateId);
        if (!stateNode) throw new Error(`Child state node '#${resolvedStateId}' does not exist on machine '${this.id}'`);
        return (0, $96dZ7.x)(stateNode, relativePath);
    }
    get definition() {
        return this.root.definition;
    }
    toJSON() {
        return this.definition;
    }
    getPersistedSnapshot(snapshot, options) {
        return (0, $96dZ7.y)(snapshot, options);
    }
    restoreSnapshot(snapshot, _actorScope) {
        const children = {};
        const snapshotChildren = snapshot.children;
        Object.keys(snapshotChildren).forEach((actorId)=>{
            const actorData = snapshotChildren[actorId];
            const childState = actorData.snapshot;
            const src = actorData.src;
            const logic = typeof src === 'string' ? (0, $96dZ7.z)(this, src) : src;
            if (!logic) return;
            const actorRef = (0, $96dZ7.A)(logic, {
                id: actorId,
                parent: _actorScope.self,
                syncSnapshot: actorData.syncSnapshot,
                snapshot: childState,
                src: src,
                systemId: actorData.systemId
            });
            children[actorId] = actorRef;
        });
        const restoredSnapshot = (0, $96dZ7.k)({
            ...snapshot,
            children: children,
            _nodes: Array.from((0, $96dZ7.i)((0, $96dZ7.j)(this.root, snapshot.value)))
        }, this);
        const seen = new Set();
        function reviveContext(contextPart, children) {
            if (seen.has(contextPart)) return;
            seen.add(contextPart);
            for(const key in contextPart){
                const value = contextPart[key];
                if (value && typeof value === 'object') {
                    if ('xstate$$type' in value && value.xstate$$type === (0, $96dZ7.$)) {
                        contextPart[key] = children[value.id];
                        continue;
                    }
                    reviveContext(value, children);
                }
            }
        }
        reviveContext(restoredSnapshot.context, children);
        return restoredSnapshot;
    }
    constructor(/** The raw config used to create the machine. */ config, implementations){
        this.config = config;
        /** The machine's own version. */ this.version = void 0;
        this.schemas = void 0;
        this.implementations = void 0;
        /** @internal */ this.__xstatenode = true;
        /** @internal */ this.idMap = new Map();
        this.root = void 0;
        this.id = void 0;
        this.states = void 0;
        this.events = void 0;
        this.id = config.id || '(machine)';
        this.implementations = {
            actors: implementations?.actors ?? {},
            actions: implementations?.actions ?? {},
            delays: implementations?.delays ?? {},
            guards: implementations?.guards ?? {}
        };
        this.version = this.config.version;
        this.schemas = this.config.schemas;
        this.transition = this.transition.bind(this);
        this.getInitialSnapshot = this.getInitialSnapshot.bind(this);
        this.getPersistedSnapshot = this.getPersistedSnapshot.bind(this);
        this.restoreSnapshot = this.restoreSnapshot.bind(this);
        this.start = this.start.bind(this);
        this.root = new $8eeb3b9b9ffbca82$export$342f24f5edd47b1(config, {
            _key: this.id,
            _machine: this
        });
        this.root._initialize();
        this.states = this.root.states; // TODO: remove!
        this.events = this.root.events;
    }
}
/**
 * Creates a state machine (statechart) with the given configuration.
 *
 * The state machine represents the pure logic of a state machine actor.
 *
 * @example
 *
 * ```ts
 * import { createMachine } from 'xstate';
 *
 * const lightMachine = createMachine({
 *   id: 'light',
 *   initial: 'green',
 *   states: {
 *     green: {
 *       on: {
 *         TIMER: { target: 'yellow' }
 *       }
 *     },
 *     yellow: {
 *       on: {
 *         TIMER: { target: 'red' }
 *       }
 *     },
 *     red: {
 *       on: {
 *         TIMER: { target: 'green' }
 *       }
 *     }
 *   }
 * });
 *
 * const lightActor = createActor(lightMachine);
 * lightActor.start();
 *
 * lightActor.send({ type: 'TIMER' });
 * ```
 *
 * @param config The state machine configuration.
 * @param options DEPRECATED: use `setup({ ... })` or `machine.provide({ ... })`
 *   to provide machine implementations instead.
 */ function $8eeb3b9b9ffbca82$export$aaa7fa18f8e9b2e8(config, implementations) {
    return new $8eeb3b9b9ffbca82$export$cbf2d83d1eab018a(config, implementations);
}
/** @internal */ function $8eeb3b9b9ffbca82$var$createInertActorScope(actorLogic) {
    const self = (0, $96dZ7.A)(actorLogic);
    const inertActorScope = {
        self: self,
        defer: ()=>{},
        id: '',
        logger: ()=>{},
        sessionId: '',
        stopChild: ()=>{},
        system: self.system,
        emit: ()=>{},
        actionExecutor: ()=>{}
    };
    return inertActorScope;
}
/** @deprecated Use `initialTransition(…)` instead. */ function $8eeb3b9b9ffbca82$export$e1c3f9a97f5088ae(actorLogic, ...[input]) {
    const actorScope = $8eeb3b9b9ffbca82$var$createInertActorScope(actorLogic);
    return actorLogic.getInitialSnapshot(actorScope, input);
}
/**
 * Determines the next snapshot for the given `actorLogic` based on the given
 * `snapshot` and `event`.
 *
 * If the `snapshot` is `undefined`, the initial snapshot of the `actorLogic` is
 * used.
 *
 * @deprecated Use `transition(…)` instead.
 * @example
 *
 * ```ts
 * import { getNextSnapshot } from 'xstate';
 * import { trafficLightMachine } from './trafficLightMachine.ts';
 *
 * const nextSnapshot = getNextSnapshot(
 *   trafficLightMachine, // actor logic
 *   undefined, // snapshot (or initial state if undefined)
 *   { type: 'TIMER' }
 * ); // event object
 *
 * console.log(nextSnapshot.value);
 * // => 'yellow'
 *
 * const nextSnapshot2 = getNextSnapshot(
 *   trafficLightMachine, // actor logic
 *   nextSnapshot, // snapshot
 *   { type: 'TIMER' }
 * ); // event object
 *
 * console.log(nextSnapshot2.value);
 * // =>'red'
 * ```
 */ function $8eeb3b9b9ffbca82$export$3629c64713e6dfd7(actorLogic, snapshot, event) {
    const inertActorScope = $8eeb3b9b9ffbca82$var$createInertActorScope(actorLogic);
    inertActorScope.self._snapshot = snapshot;
    return actorLogic.transition(snapshot, event, inertActorScope);
}
// at the moment we allow extra actors - ones that are not specified by `children`
// this could be reconsidered in the future
function $8eeb3b9b9ffbca82$export$de27182ff8187d6c({ schemas: schemas, actors: actors, actions: actions, guards: guards, delays: delays }) {
    return {
        createMachine: (config)=>$8eeb3b9b9ffbca82$export$aaa7fa18f8e9b2e8({
                ...config,
                schemas: schemas
            }, {
                actors: actors,
                actions: actions,
                guards: guards,
                delays: delays
            })
    };
}
// eslint-disable-next-line @typescript-eslint/no-unsafe-declaration-merging
// eslint-disable-next-line @typescript-eslint/no-unsafe-declaration-merging
class $8eeb3b9b9ffbca82$export$7413adad607e2cdf {
    now() {
        return this._now;
    }
    getId() {
        return this._id++;
    }
    setTimeout(fn, timeout) {
        this._flushingInvalidated = this._flushing;
        const id = this.getId();
        this.timeouts.set(id, {
            start: this.now(),
            timeout: timeout,
            fn: fn
        });
        return id;
    }
    clearTimeout(id) {
        this._flushingInvalidated = this._flushing;
        this.timeouts.delete(id);
    }
    set(time) {
        if (this._now > time) throw new Error('Unable to travel back in time');
        this._now = time;
        this.flushTimeouts();
    }
    flushTimeouts() {
        if (this._flushing) {
            this._flushingInvalidated = true;
            return;
        }
        this._flushing = true;
        const sorted = [
            ...this.timeouts
        ].sort(([_idA, timeoutA], [_idB, timeoutB])=>{
            const endA = timeoutA.start + timeoutA.timeout;
            const endB = timeoutB.start + timeoutB.timeout;
            return endB > endA ? -1 : 1;
        });
        for (const [id, timeout] of sorted){
            if (this._flushingInvalidated) {
                this._flushingInvalidated = false;
                this._flushing = false;
                this.flushTimeouts();
                return;
            }
            if (this.now() - timeout.start >= timeout.timeout) {
                this.timeouts.delete(id);
                timeout.fn.call(null);
            }
        }
        this._flushing = false;
    }
    increment(ms) {
        this._now += ms;
        this.flushTimeouts();
    }
    constructor(){
        this.timeouts = new Map();
        this._now = 0;
        this._id = 0;
        this._flushing = false;
        this._flushingInvalidated = false;
    }
}
/**
 * Returns a promise that resolves to the `output` of the actor when it is done.
 *
 * @example
 *
 * ```ts
 * const machine = createMachine({
 *   // ...
 *   output: {
 *     count: 42
 *   }
 * });
 *
 * const actor = createActor(machine);
 *
 * actor.start();
 *
 * const output = await toPromise(actor);
 *
 * console.log(output);
 * // logs { count: 42 }
 * ```
 */ function $8eeb3b9b9ffbca82$export$4dbaaf6c79705e6c(actor) {
    return new Promise((resolve, reject)=>{
        actor.subscribe({
            complete: ()=>{
                resolve(actor.getSnapshot().output);
            },
            error: reject
        });
    });
}
/**
 * Given actor `logic`, a `snapshot`, and an `event`, returns a tuple of the
 * `nextSnapshot` and `actions` to execute.
 *
 * This is a pure function that does not execute `actions`.
 */ function $8eeb3b9b9ffbca82$export$66bb15e2994e6a26(logic, snapshot, event) {
    const executableActions = [];
    const actorScope = $8eeb3b9b9ffbca82$var$createInertActorScope(logic);
    actorScope.actionExecutor = (action)=>{
        executableActions.push(action);
    };
    const nextSnapshot = logic.transition(snapshot, event, actorScope);
    return [
        nextSnapshot,
        executableActions
    ];
}
/**
 * Given actor `logic` and optional `input`, returns a tuple of the
 * `nextSnapshot` and `actions` to execute from the initial transition (no
 * previous state).
 *
 * This is a pure function that does not execute `actions`.
 */ function $8eeb3b9b9ffbca82$export$5f4d25c77127242(logic, ...[input]) {
    const executableActions = [];
    const actorScope = $8eeb3b9b9ffbca82$var$createInertActorScope(logic);
    actorScope.actionExecutor = (action)=>{
        executableActions.push(action);
    };
    const nextSnapshot = logic.getInitialSnapshot(actorScope, input);
    return [
        nextSnapshot,
        executableActions
    ];
}
const $8eeb3b9b9ffbca82$var$defaultWaitForOptions = {
    timeout: Infinity // much more than 10 seconds
};
/**
 * Subscribes to an actor ref and waits for its emitted value to satisfy a
 * predicate, and then resolves with that value. Will throw if the desired state
 * is not reached after an optional timeout. (defaults to Infinity).
 *
 * @example
 *
 * ```js
 * const state = await waitFor(someService, (state) => {
 *   return state.hasTag('loaded');
 * });
 *
 * state.hasTag('loaded'); // true
 * ```
 *
 * @param actorRef The actor ref to subscribe to
 * @param predicate Determines if a value matches the condition to wait for
 * @param options
 * @returns A promise that eventually resolves to the emitted value that matches
 *   the condition
 */ function $8eeb3b9b9ffbca82$export$9bbfceb27f687c1b(actorRef, predicate, options) {
    const resolvedOptions = {
        ...$8eeb3b9b9ffbca82$var$defaultWaitForOptions,
        ...options
    };
    return new Promise((res, rej)=>{
        const { signal: signal } = resolvedOptions;
        if (signal?.aborted) {
            // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors
            rej(signal.reason);
            return;
        }
        let done = false;
        const handle = resolvedOptions.timeout === Infinity ? undefined : setTimeout(()=>{
            dispose();
            rej(new Error(`Timeout of ${resolvedOptions.timeout} ms exceeded`));
        }, resolvedOptions.timeout);
        const dispose = ()=>{
            clearTimeout(handle);
            done = true;
            sub?.unsubscribe();
            if (abortListener) signal.removeEventListener('abort', abortListener);
        };
        function checkEmitted(emitted) {
            if (predicate(emitted)) {
                dispose();
                res(emitted);
            }
        }
        /**
     * If the `signal` option is provided, this will be the listener for its
     * `abort` event
     */ let abortListener;
        // eslint-disable-next-line prefer-const
        let sub; // avoid TDZ when disposing synchronously
        // See if the current snapshot already matches the predicate
        checkEmitted(actorRef.getSnapshot());
        if (done) return;
        // only define the `abortListener` if the `signal` option is provided
        if (signal) {
            abortListener = ()=>{
                dispose();
                // XState does not "own" the signal, so we should reject with its reason (if any)
                // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors
                rej(signal.reason);
            };
            signal.addEventListener('abort', abortListener);
        }
        sub = actorRef.subscribe({
            next: checkEmitted,
            error: (err)=>{
                dispose();
                // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors
                rej(err);
            },
            complete: ()=>{
                dispose();
                rej(new Error(`Actor terminated without satisfying predicate`));
            }
        });
        if (done) sub.unsubscribe();
    });
}
module.exports["createMachine"] = $8eeb3b9b9ffbca82$export$aaa7fa18f8e9b2e8;
module.exports["setup"] = $8eeb3b9b9ffbca82$export$de27182ff8187d6c;

});

parcelRegister("eXLWP", function(module, exports) {

var $96dZ7 = parcelRequire("96dZ7");

parcelRequire("e6Soq");

/**
 * Represents an actor created by `fromTransition`.
 *
 * The type of `self` within the actor's logic.
 *
 * @example
 *
 * ```ts
 * import {
 *   fromTransition,
 *   createActor,
 *   type AnyActorSystem
 * } from 'xstate';
 *
 * //* The actor's stored context.
 * type Context = {
 *   // The current count.
 *   count: number;
 *   // The amount to increase `count` by.
 *   step: number;
 * };
 * // The events the actor receives.
 * type Event = { type: 'increment' };
 * // The actor's input.
 * type Input = { step?: number };
 *
 * // Actor logic that increments `count` by `step` when it receives an event of
 * // type `increment`.
 * const logic = fromTransition<Context, Event, AnyActorSystem, Input>(
 *   (state, event, actorScope) => {
 *     actorScope.self;
 *     //         ^? TransitionActorRef<Context, Event>
 *
 *     if (event.type === 'increment') {
 *       return {
 *         ...state,
 *         count: state.count + state.step
 *       };
 *     }
 *     return state;
 *   },
 *   ({ input, self }) => {
 *     self;
 *     // ^? TransitionActorRef<Context, Event>
 *
 *     return {
 *       count: 0,
 *       step: input.step ?? 1
 *     };
 *   }
 * );
 *
 * const actor = createActor(logic, { input: { step: 10 } });
 * //    ^? TransitionActorRef<Context, Event>
 * ```
 *
 * @see {@link fromTransition}
 */ /**
 * Returns actor logic given a transition function and its initial state.
 *
 * A “transition function” is a function that takes the current `state` and
 * received `event` object as arguments, and returns the next state, similar to
 * a reducer.
 *
 * Actors created from transition logic (“transition actors”) can:
 *
 * - Receive events
 * - Emit snapshots of its state
 *
 * The transition function’s `state` is used as its transition actor’s
 * `context`.
 *
 * Note that the "state" for a transition function is provided by the initial
 * state argument, and is not the same as the State object of an actor or a
 * state within a machine configuration.
 *
 * @example
 *
 * ```ts
 * const transitionLogic = fromTransition(
 *   (state, event) => {
 *     if (event.type === 'increment') {
 *       return {
 *         ...state,
 *         count: state.count + 1
 *       };
 *     }
 *     return state;
 *   },
 *   { count: 0 }
 * );
 *
 * const transitionActor = createActor(transitionLogic);
 * transitionActor.subscribe((snapshot) => {
 *   console.log(snapshot);
 * });
 * transitionActor.start();
 * // => {
 * //   status: 'active',
 * //   context: { count: 0 },
 * //   ...
 * // }
 *
 * transitionActor.send({ type: 'increment' });
 * // => {
 * //   status: 'active',
 * //   context: { count: 1 },
 * //   ...
 * // }
 * ```
 *
 * @param transition The transition function used to describe the transition
 *   logic. It should return the next state given the current state and event.
 *   It receives the following arguments:
 *
 *   - `state` - the current state.
 *   - `event` - the received event.
 *   - `actorScope` - the actor scope object, with properties like `self` and
 *       `system`.
 *
 * @param initialContext The initial state of the transition function, either an
 *   object representing the state, or a function which returns a state object.
 *   If a function, it will receive as its only argument an object with the
 *   following properties:
 *
 *   - `input` - the `input` provided to its parent transition actor.
 *   - `self` - a reference to its parent transition actor.
 *
 * @returns Actor logic
 * @see {@link https://stately.ai/docs/input | Input docs} for more information about how input is passed
 */ function $ae4bc4d1d8af478f$export$439a4be7208a15ca(transition, initialContext) {
    return {
        config: transition,
        transition: (snapshot, event, actorScope)=>{
            return {
                ...snapshot,
                context: transition(snapshot.context, event, actorScope)
            };
        },
        getInitialSnapshot: (_, input)=>{
            return {
                status: 'active',
                output: undefined,
                error: undefined,
                context: typeof initialContext === 'function' ? initialContext({
                    input: input
                }) : initialContext
            };
        },
        getPersistedSnapshot: (snapshot)=>snapshot,
        restoreSnapshot: (snapshot)=>snapshot
    };
}
const $ae4bc4d1d8af478f$var$instanceStates = /* #__PURE__ */ new WeakMap();
/**
 * Represents an actor created by `fromCallback`.
 *
 * The type of `self` within the actor's logic.
 *
 * @example
 *
 * ```ts
 * import { fromCallback, createActor } from 'xstate';
 *
 * // The events the actor receives.
 * type Event = { type: 'someEvent' };
 * // The actor's input.
 * type Input = { name: string };
 *
 * // Actor logic that logs whenever it receives an event of type `someEvent`.
 * const logic = fromCallback<Event, Input>(({ self, input, receive }) => {
 *   self;
 *   // ^? CallbackActorRef<Event, Input>
 *
 *   receive((event) => {
 *     if (event.type === 'someEvent') {
 *       console.log(`${input.name}: received "someEvent" event`);
 *       // logs 'myActor: received "someEvent" event'
 *     }
 *   });
 * });
 *
 * const actor = createActor(logic, { input: { name: 'myActor' } });
 * //    ^? CallbackActorRef<Event, Input>
 * ```
 *
 * @see {@link fromCallback}
 */ /**
 * An actor logic creator which returns callback logic as defined by a callback
 * function.
 *
 * @remarks
 * Useful for subscription-based or other free-form logic that can send events
 * back to the parent actor.
 *
 * Actors created from callback logic (“callback actors”) can:
 *
 * - Receive events via the `receive` function
 * - Send events to the parent actor via the `sendBack` function
 *
 * Callback actors are a bit different from other actors in that they:
 *
 * - Do not work with `onDone`
 * - Do not produce a snapshot using `.getSnapshot()`
 * - Do not emit values when used with `.subscribe()`
 * - Can not be stopped with `.stop()`
 *
 * @example
 *
 * ```typescript
 * const callbackLogic = fromCallback(({ sendBack, receive }) => {
 *   let lockStatus = 'unlocked';
 *
 *   const handler = (event) => {
 *     if (lockStatus === 'locked') {
 *       return;
 *     }
 *     sendBack(event);
 *   };
 *
 *   receive((event) => {
 *     if (event.type === 'lock') {
 *       lockStatus = 'locked';
 *     } else if (event.type === 'unlock') {
 *       lockStatus = 'unlocked';
 *     }
 *   });
 *
 *   document.body.addEventListener('click', handler);
 *
 *   return () => {
 *     document.body.removeEventListener('click', handler);
 *   };
 * });
 * ```
 *
 * @param callback - The callback function used to describe the callback logic
 *   The callback function is passed an object with the following properties:
 *
 *   - `receive` - A function that can send events back to the parent actor; the
 *       listener is then called whenever events are received by the callback
 *       actor
 *   - `sendBack` - A function that can send events back to the parent actor
 *   - `input` - Data that was provided to the callback actor
 *   - `self` - The parent actor of the callback actor
 *   - `system` - The actor system to which the callback actor belongs The callback
 *       function can (optionally) return a cleanup function, which is called
 *       when the actor is stopped.
 *
 * @returns Callback logic
 * @see {@link CallbackLogicFunction} for more information about the callback function and its object argument
 * @see {@link https://stately.ai/docs/input | Input docs} for more information about how input is passed
 */ function $ae4bc4d1d8af478f$export$d0deb4828877173(callback) {
    const logic = {
        config: callback,
        start: (state, actorScope)=>{
            const { self: self, system: system, emit: emit } = actorScope;
            const callbackState = {
                receivers: undefined,
                dispose: undefined
            };
            $ae4bc4d1d8af478f$var$instanceStates.set(self, callbackState);
            callbackState.dispose = callback({
                input: state.input,
                system: system,
                self: self,
                sendBack: (event)=>{
                    if (self.getSnapshot().status === 'stopped') return;
                    if (self._parent) system._relay(self, self._parent, event);
                },
                receive: (listener)=>{
                    var _callbackState;
                    (_callbackState = callbackState).receivers ?? (_callbackState.receivers = new Set());
                    callbackState.receivers.add(listener);
                },
                emit: emit
            });
        },
        transition: (state, event, actorScope)=>{
            const callbackState = $ae4bc4d1d8af478f$var$instanceStates.get(actorScope.self);
            if (event.type === (0, $96dZ7.X)) {
                state = {
                    ...state,
                    status: 'stopped',
                    error: undefined
                };
                callbackState.dispose?.();
                return state;
            }
            callbackState.receivers?.forEach((receiver)=>receiver(event));
            return state;
        },
        getInitialSnapshot: (_, input)=>{
            return {
                status: 'active',
                output: undefined,
                error: undefined,
                input: input
            };
        },
        getPersistedSnapshot: (snapshot)=>snapshot,
        restoreSnapshot: (snapshot)=>snapshot
    };
    return logic;
}
const $ae4bc4d1d8af478f$var$XSTATE_OBSERVABLE_NEXT = 'xstate.observable.next';
const $ae4bc4d1d8af478f$var$XSTATE_OBSERVABLE_ERROR = 'xstate.observable.error';
const $ae4bc4d1d8af478f$var$XSTATE_OBSERVABLE_COMPLETE = 'xstate.observable.complete';
/**
 * Represents an actor created by `fromObservable` or `fromEventObservable`.
 *
 * The type of `self` within the actor's logic.
 *
 * @example
 *
 * ```ts
 * import { fromObservable, createActor } from 'xstate';
 * import { interval } from 'rxjs';
 *
 * // The type of the value observed by the actor's logic.
 * type Context = number;
 * // The actor's input.
 * type Input = { period?: number };
 *
 * // Actor logic that observes a number incremented every `input.period`
 * // milliseconds (default: 1_000).
 * const logic = fromObservable<Context, Input>(({ input, self }) => {
 *   self;
 *   // ^? ObservableActorRef<Event, Input>
 *
 *   return interval(input.period ?? 1_000);
 * });
 *
 * const actor = createActor(logic, { input: { period: 2_000 } });
 * //    ^? ObservableActorRef<Event, Input>
 * ```
 *
 * @see {@link fromObservable}
 * @see {@link fromEventObservable}
 */ /**
 * Observable actor logic is described by an observable stream of values. Actors
 * created from observable logic (“observable actors”) can:
 *
 * - Emit snapshots of the observable’s emitted value
 *
 * The observable’s emitted value is used as its observable actor’s `context`.
 *
 * Sending events to observable actors will have no effect.
 *
 * @example
 *
 * ```ts
 * import { fromObservable, createActor } from 'xstate';
 * import { interval } from 'rxjs';
 *
 * const logic = fromObservable((obj) => interval(1000));
 *
 * const actor = createActor(logic);
 *
 * actor.subscribe((snapshot) => {
 *   console.log(snapshot.context);
 * });
 *
 * actor.start();
 * // At every second:
 * // Logs 0
 * // Logs 1
 * // Logs 2
 * // ...
 * ```
 *
 * @param observableCreator A function that creates an observable. It receives
 *   one argument, an object with the following properties:
 *
 *   - `input` - Data that was provided to the observable actor
 *   - `self` - The parent actor
 *   - `system` - The actor system to which the observable actor belongs
 *
 *   It should return a {@link Subscribable}, which is compatible with an RxJS
 *   Observable, although RxJS is not required to create them.
 * @see {@link https://rxjs.dev} for documentation on RxJS Observable and observable creators.
 * @see {@link Subscribable} interface in XState, which is based on and compatible with RxJS Observable.
 */ function $ae4bc4d1d8af478f$export$4b2432e2d8723823(observableCreator) {
    // TODO: add event types
    const logic = {
        config: observableCreator,
        transition: (snapshot, event)=>{
            if (snapshot.status !== 'active') return snapshot;
            switch(event.type){
                case $ae4bc4d1d8af478f$var$XSTATE_OBSERVABLE_NEXT:
                    {
                        const newSnapshot = {
                            ...snapshot,
                            context: event.data
                        };
                        return newSnapshot;
                    }
                case $ae4bc4d1d8af478f$var$XSTATE_OBSERVABLE_ERROR:
                    return {
                        ...snapshot,
                        status: 'error',
                        error: event.data,
                        input: undefined,
                        _subscription: undefined
                    };
                case $ae4bc4d1d8af478f$var$XSTATE_OBSERVABLE_COMPLETE:
                    return {
                        ...snapshot,
                        status: 'done',
                        input: undefined,
                        _subscription: undefined
                    };
                case 0, $96dZ7.X:
                    snapshot._subscription.unsubscribe();
                    return {
                        ...snapshot,
                        status: 'stopped',
                        input: undefined,
                        _subscription: undefined
                    };
                default:
                    return snapshot;
            }
        },
        getInitialSnapshot: (_, input)=>{
            return {
                status: 'active',
                output: undefined,
                error: undefined,
                context: undefined,
                input: input,
                _subscription: undefined
            };
        },
        start: (state, { self: self, system: system, emit: emit })=>{
            if (state.status === 'done') // Do not restart a completed observable
            return;
            state._subscription = observableCreator({
                input: state.input,
                system: system,
                self: self,
                emit: emit
            }).subscribe({
                next: (value)=>{
                    system._relay(self, self, {
                        type: $ae4bc4d1d8af478f$var$XSTATE_OBSERVABLE_NEXT,
                        data: value
                    });
                },
                error: (err)=>{
                    system._relay(self, self, {
                        type: $ae4bc4d1d8af478f$var$XSTATE_OBSERVABLE_ERROR,
                        data: err
                    });
                },
                complete: ()=>{
                    system._relay(self, self, {
                        type: $ae4bc4d1d8af478f$var$XSTATE_OBSERVABLE_COMPLETE
                    });
                }
            });
        },
        getPersistedSnapshot: ({ _subscription: _subscription, ...state })=>state,
        restoreSnapshot: (state)=>({
                ...state,
                _subscription: undefined
            })
    };
    return logic;
}
/**
 * Creates event observable logic that listens to an observable that delivers
 * event objects.
 *
 * Event observable actor logic is described by an observable stream of
 * {@link https://stately.ai/docs/transitions#event-objects | event objects}.
 * Actors created from event observable logic (“event observable actors”) can:
 *
 * - Implicitly send events to its parent actor
 * - Emit snapshots of its emitted event objects
 *
 * Sending events to event observable actors will have no effect.
 *
 * @example
 *
 * ```ts
 * import {
 *   fromEventObservable,
 *   Subscribable,
 *   EventObject,
 *   createMachine,
 *   createActor
 * } from 'xstate';
 * import { fromEvent } from 'rxjs';
 *
 * const mouseClickLogic = fromEventObservable(
 *   () => fromEvent(document.body, 'click') as Subscribable<EventObject>
 * );
 *
 * const canvasMachine = createMachine({
 *   invoke: {
 *     // Will send mouse `click` events to the canvas actor
 *     src: mouseClickLogic
 *   }
 * });
 *
 * const canvasActor = createActor(canvasMachine);
 * canvasActor.start();
 * ```
 *
 * @param lazyObservable A function that creates an observable that delivers
 *   event objects. It receives one argument, an object with the following
 *   properties:
 *
 *   - `input` - Data that was provided to the event observable actor
 *   - `self` - The parent actor
 *   - `system` - The actor system to which the event observable actor belongs.
 *
 *   It should return a {@link Subscribable}, which is compatible with an RxJS
 *   Observable, although RxJS is not required to create them.
 */ function $ae4bc4d1d8af478f$export$32b16bdebc365919(lazyObservable) {
    // TODO: event types
    const logic = {
        config: lazyObservable,
        transition: (state, event)=>{
            if (state.status !== 'active') return state;
            switch(event.type){
                case $ae4bc4d1d8af478f$var$XSTATE_OBSERVABLE_ERROR:
                    return {
                        ...state,
                        status: 'error',
                        error: event.data,
                        input: undefined,
                        _subscription: undefined
                    };
                case $ae4bc4d1d8af478f$var$XSTATE_OBSERVABLE_COMPLETE:
                    return {
                        ...state,
                        status: 'done',
                        input: undefined,
                        _subscription: undefined
                    };
                case 0, $96dZ7.X:
                    state._subscription.unsubscribe();
                    return {
                        ...state,
                        status: 'stopped',
                        input: undefined,
                        _subscription: undefined
                    };
                default:
                    return state;
            }
        },
        getInitialSnapshot: (_, input)=>{
            return {
                status: 'active',
                output: undefined,
                error: undefined,
                context: undefined,
                input: input,
                _subscription: undefined
            };
        },
        start: (state, { self: self, system: system, emit: emit })=>{
            if (state.status === 'done') // Do not restart a completed observable
            return;
            state._subscription = lazyObservable({
                input: state.input,
                system: system,
                self: self,
                emit: emit
            }).subscribe({
                next: (value)=>{
                    if (self._parent) system._relay(self, self._parent, value);
                },
                error: (err)=>{
                    system._relay(self, self, {
                        type: $ae4bc4d1d8af478f$var$XSTATE_OBSERVABLE_ERROR,
                        data: err
                    });
                },
                complete: ()=>{
                    system._relay(self, self, {
                        type: $ae4bc4d1d8af478f$var$XSTATE_OBSERVABLE_COMPLETE
                    });
                }
            });
        },
        getPersistedSnapshot: ({ _subscription: _subscription, ...snapshot })=>snapshot,
        restoreSnapshot: (snapshot)=>({
                ...snapshot,
                _subscription: undefined
            })
    };
    return logic;
}
const $ae4bc4d1d8af478f$var$XSTATE_PROMISE_RESOLVE = 'xstate.promise.resolve';
const $ae4bc4d1d8af478f$var$XSTATE_PROMISE_REJECT = 'xstate.promise.reject';
/**
 * Represents an actor created by `fromPromise`.
 *
 * The type of `self` within the actor's logic.
 *
 * @example
 *
 * ```ts
 * import { fromPromise, createActor } from 'xstate';
 *
 * // The actor's resolved output
 * type Output = string;
 * // The actor's input.
 * type Input = { message: string };
 *
 * // Actor logic that fetches the url of an image of a cat saying `input.message`.
 * const logic = fromPromise<Output, Input>(async ({ input, self }) => {
 *   self;
 *   // ^? PromiseActorRef<Output, Input>
 *
 *   const data = await fetch(
 *     `https://cataas.com/cat/says/${input.message}`
 *   );
 *   const url = await data.json();
 *   return url;
 * });
 *
 * const actor = createActor(logic, { input: { message: 'hello world' } });
 * //    ^? PromiseActorRef<Output, Input>
 * ```
 *
 * @see {@link fromPromise}
 */ const $ae4bc4d1d8af478f$var$controllerMap = new WeakMap();
/**
 * An actor logic creator which returns promise logic as defined by an async
 * process that resolves or rejects after some time.
 *
 * Actors created from promise actor logic (“promise actors”) can:
 *
 * - Emit the resolved value of the promise
 * - Output the resolved value of the promise
 *
 * Sending events to promise actors will have no effect.
 *
 * @example
 *
 * ```ts
 * const promiseLogic = fromPromise(async () => {
 *   const result = await fetch('https://example.com/...').then((data) =>
 *     data.json()
 *   );
 *
 *   return result;
 * });
 *
 * const promiseActor = createActor(promiseLogic);
 * promiseActor.subscribe((snapshot) => {
 *   console.log(snapshot);
 * });
 * promiseActor.start();
 * // => {
 * //   output: undefined,
 * //   status: 'active'
 * //   ...
 * // }
 *
 * // After promise resolves
 * // => {
 * //   output: { ... },
 * //   status: 'done',
 * //   ...
 * // }
 * ```
 *
 * @param promiseCreator A function which returns a Promise, and accepts an
 *   object with the following properties:
 *
 *   - `input` - Data that was provided to the promise actor
 *   - `self` - The parent actor of the promise actor
 *   - `system` - The actor system to which the promise actor belongs
 *
 * @see {@link https://stately.ai/docs/input | Input docs} for more information about how input is passed
 */ function $ae4bc4d1d8af478f$export$60f45028237c39d1(promiseCreator) {
    const logic = {
        config: promiseCreator,
        transition: (state, event, scope)=>{
            if (state.status !== 'active') return state;
            switch(event.type){
                case $ae4bc4d1d8af478f$var$XSTATE_PROMISE_RESOLVE:
                    {
                        const resolvedValue = event.data;
                        return {
                            ...state,
                            status: 'done',
                            output: resolvedValue,
                            input: undefined
                        };
                    }
                case $ae4bc4d1d8af478f$var$XSTATE_PROMISE_REJECT:
                    return {
                        ...state,
                        status: 'error',
                        error: event.data,
                        input: undefined
                    };
                case 0, $96dZ7.X:
                    $ae4bc4d1d8af478f$var$controllerMap.get(scope.self)?.abort();
                    return {
                        ...state,
                        status: 'stopped',
                        input: undefined
                    };
                default:
                    return state;
            }
        },
        start: (state, { self: self, system: system, emit: emit })=>{
            // TODO: determine how to allow customizing this so that promises
            // can be restarted if necessary
            if (state.status !== 'active') return;
            const controller = new AbortController();
            $ae4bc4d1d8af478f$var$controllerMap.set(self, controller);
            const resolvedPromise = Promise.resolve(promiseCreator({
                input: state.input,
                system: system,
                self: self,
                signal: controller.signal,
                emit: emit
            }));
            resolvedPromise.then((response)=>{
                if (self.getSnapshot().status !== 'active') return;
                $ae4bc4d1d8af478f$var$controllerMap.delete(self);
                system._relay(self, self, {
                    type: $ae4bc4d1d8af478f$var$XSTATE_PROMISE_RESOLVE,
                    data: response
                });
            }, (errorData)=>{
                if (self.getSnapshot().status !== 'active') return;
                $ae4bc4d1d8af478f$var$controllerMap.delete(self);
                system._relay(self, self, {
                    type: $ae4bc4d1d8af478f$var$XSTATE_PROMISE_REJECT,
                    data: errorData
                });
            });
        },
        getInitialSnapshot: (_, input)=>{
            return {
                status: 'active',
                output: undefined,
                error: undefined,
                input: input
            };
        },
        getPersistedSnapshot: (snapshot)=>snapshot,
        restoreSnapshot: (snapshot)=>snapshot
    };
    return logic;
}
const $ae4bc4d1d8af478f$var$emptyLogic = $ae4bc4d1d8af478f$export$439a4be7208a15ca((_)=>undefined, undefined);
function $ae4bc4d1d8af478f$export$302970cd5518279b() {
    return (0, $96dZ7.A)($ae4bc4d1d8af478f$var$emptyLogic);
}
module.exports["fromCallback"] = $ae4bc4d1d8af478f$export$d0deb4828877173;
module.exports["fromObservable"] = $ae4bc4d1d8af478f$export$4b2432e2d8723823;
module.exports["fromPromise"] = $ae4bc4d1d8af478f$export$60f45028237c39d1;

});

parcelRegister("dpSRg", function(module, exports) {

var $96dZ7 = parcelRequire("96dZ7");

function $9c4829d96c0398b3$var$createSpawner(actorScope, { machine: machine, context: context }, event, spawnedChildren) {
    const spawn = (src, options = {})=>{
        const { systemId: systemId, input: input } = options;
        if (typeof src === 'string') {
            const logic = (0, $96dZ7.z)(machine, src);
            if (!logic) throw new Error(`Actor logic '${src}' not implemented in machine '${machine.id}'`);
            const actorRef = (0, $96dZ7.A)(logic, {
                id: options.id,
                parent: actorScope.self,
                syncSnapshot: options.syncSnapshot,
                input: typeof input === 'function' ? input({
                    context: context,
                    event: event,
                    self: actorScope.self
                }) : input,
                src: src,
                systemId: systemId
            });
            spawnedChildren[actorRef.id] = actorRef;
            return actorRef;
        } else {
            const actorRef = (0, $96dZ7.A)(src, {
                id: options.id,
                parent: actorScope.self,
                syncSnapshot: options.syncSnapshot,
                input: options.input,
                src: src,
                systemId: systemId
            });
            return actorRef;
        }
    };
    return (src, options)=>{
        const actorRef = spawn(src, options); // TODO: fix types
        spawnedChildren[actorRef.id] = actorRef;
        actorScope.defer(()=>{
            if (actorRef._processingStatus === (0, $96dZ7.T).Stopped) return;
            actorRef.start();
        });
        return actorRef;
    };
}
function $9c4829d96c0398b3$var$resolveAssign(actorScope, snapshot, actionArgs, actionParams, { assignment: assignment }) {
    if (!snapshot.context) throw new Error('Cannot assign to undefined `context`. Ensure that `context` is defined in the machine config.');
    const spawnedChildren = {};
    const assignArgs = {
        context: snapshot.context,
        event: actionArgs.event,
        spawn: $9c4829d96c0398b3$var$createSpawner(actorScope, snapshot, actionArgs.event, spawnedChildren),
        self: actorScope.self,
        system: actorScope.system
    };
    let partialUpdate = {};
    if (typeof assignment === 'function') partialUpdate = assignment(assignArgs, actionParams);
    else for (const key of Object.keys(assignment)){
        const propAssignment = assignment[key];
        partialUpdate[key] = typeof propAssignment === 'function' ? propAssignment(assignArgs, actionParams) : propAssignment;
    }
    const updatedContext = Object.assign({}, snapshot.context, partialUpdate);
    return [
        (0, $96dZ7.U)(snapshot, {
            context: updatedContext,
            children: Object.keys(spawnedChildren).length ? {
                ...snapshot.children,
                ...spawnedChildren
            } : snapshot.children
        }),
        undefined,
        undefined
    ];
}
/**
 * Updates the current context of the machine.
 *
 * @example
 *
 * ```ts
 * import { createMachine, assign } from 'xstate';
 *
 * const countMachine = createMachine({
 *   context: {
 *     count: 0,
 *     message: ''
 *   },
 *   on: {
 *     inc: {
 *       actions: assign({
 *         count: ({ context }) => context.count + 1
 *       })
 *     },
 *     updateMessage: {
 *       actions: assign(({ context, event }) => {
 *         return {
 *           message: event.message.trim()
 *         };
 *       })
 *     }
 *   }
 * });
 * ```
 *
 * @param assignment An object that represents the partial context to update, or
 *   a function that returns an object that represents the partial context to
 *   update.
 */ function $9c4829d96c0398b3$export$407448d2b89b1813(assignment) {
    function assign(_args, _params) {}
    assign.type = 'xstate.assign';
    assign.assignment = assignment;
    assign.resolve = $9c4829d96c0398b3$var$resolveAssign;
    return assign;
}
function $9c4829d96c0398b3$var$resolveEmit(_, snapshot, args, actionParams, { event: eventOrExpr }) {
    const resolvedEvent = typeof eventOrExpr === 'function' ? eventOrExpr(args, actionParams) : eventOrExpr;
    return [
        snapshot,
        {
            event: resolvedEvent
        },
        undefined
    ];
}
function $9c4829d96c0398b3$var$executeEmit(actorScope, { event: event }) {
    actorScope.defer(()=>actorScope.emit(event));
}
/**
 * Emits an event to event handlers registered on the actor via `actor.on(event,
 * handler)`.
 *
 * @example
 *
 * ```ts
 * import { emit } from 'xstate';
 *
 * const machine = createMachine({
 *   // ...
 *   on: {
 *     something: {
 *       actions: emit({
 *         type: 'emitted',
 *         some: 'data'
 *       })
 *     }
 *   }
 *   // ...
 * });
 *
 * const actor = createActor(machine).start();
 *
 * actor.on('emitted', (event) => {
 *   console.log(event);
 * });
 *
 * actor.send({ type: 'something' });
 * // logs:
 * // {
 * //   type: 'emitted',
 * //   some: 'data'
 * // }
 * ```
 */ function $9c4829d96c0398b3$export$f1e1789686576879(/** The event to emit, or an expression that returns an event to emit. */ eventOrExpr) {
    function emit(_args, _params) {}
    emit.type = 'xstate.emit';
    emit.event = eventOrExpr;
    emit.resolve = $9c4829d96c0398b3$var$resolveEmit;
    emit.execute = $9c4829d96c0398b3$var$executeEmit;
    return emit;
}
/**
 * @remarks
 * `T | unknown` reduces to `unknown` and that can be problematic when it comes
 * to contextual typing. It especially is a problem when the union has a
 * function member, like here:
 *
 * ```ts
 * declare function test(
 *   cbOrVal: ((arg: number) => unknown) | unknown
 * ): void;
 * test((arg) => {}); // oops, implicit any
 * ```
 *
 * This type can be used to avoid this problem. This union represents the same
 * value space as `unknown`.
 */ // https://github.com/microsoft/TypeScript/issues/23182#issuecomment-379091887
// @TODO: Replace with native `NoInfer` when TS issue gets fixed:
// https://github.com/microsoft/TypeScript/pull/57673
/** @deprecated Use the built-in `NoInfer` type instead */ /** The full definition of an event, with a string `type`. */ /**
 * The string or object representing the state value relative to the parent
 * state node.
 *
 * @remarks
 * - For a child atomic state node, this is a string, e.g., `"pending"`.
 * - For complex state nodes, this is an object, e.g., `{ success:
 *   "someChildState" }`.
 */ /** @deprecated Use `AnyMachineSnapshot` instead */ // TODO: possibly refactor this somehow, use even a simpler type, and maybe even make `machine.options` private or something
/** @ignore */ let $9c4829d96c0398b3$export$25ce5a424b770e84 = /*#__PURE__*/ function(SpecialTargets) {
    SpecialTargets["Parent"] = "#_parent";
    SpecialTargets["Internal"] = "#_internal";
    return SpecialTargets;
}({});
/** @deprecated Use `AnyActor` instead. */ // Based on RxJS types
// TODO: in v6, this should only accept AnyActorLogic, like ActorRefFromLogic
/** @deprecated Use `Actor<T>` instead. */ /**
 * Represents logic which can be used by an actor.
 *
 * @template TSnapshot - The type of the snapshot.
 * @template TEvent - The type of the event object.
 * @template TInput - The type of the input.
 * @template TSystem - The type of the actor system.
 */ /** @deprecated */ // TODO: cover all that can be actually returned
function $9c4829d96c0398b3$var$resolveSendTo(actorScope, snapshot, args, actionParams, { to: to, event: eventOrExpr, id: id, delay: delay }, extra) {
    const delaysMap = snapshot.machine.implementations.delays;
    if (typeof eventOrExpr === 'string') throw new Error(// eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    `Only event objects may be used with sendTo; use sendTo({ type: "${eventOrExpr}" }) instead`);
    const resolvedEvent = typeof eventOrExpr === 'function' ? eventOrExpr(args, actionParams) : eventOrExpr;
    let resolvedDelay;
    if (typeof delay === 'string') {
        const configDelay = delaysMap && delaysMap[delay];
        resolvedDelay = typeof configDelay === 'function' ? configDelay(args, actionParams) : configDelay;
    } else resolvedDelay = typeof delay === 'function' ? delay(args, actionParams) : delay;
    const resolvedTarget = typeof to === 'function' ? to(args, actionParams) : to;
    let targetActorRef;
    if (typeof resolvedTarget === 'string') {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison
        if (resolvedTarget === $9c4829d96c0398b3$export$25ce5a424b770e84.Parent) targetActorRef = actorScope.self._parent;
        else if (resolvedTarget === $9c4829d96c0398b3$export$25ce5a424b770e84.Internal) targetActorRef = actorScope.self;
        else if (resolvedTarget.startsWith('#_')) // SCXML compatibility: https://www.w3.org/TR/scxml/#SCXMLEventProcessor
        // #_invokeid. If the target is the special term '#_invokeid', where invokeid is the invokeid of an SCXML session that the sending session has created by <invoke>, the Processor must add the event to the external queue of that session.
        targetActorRef = snapshot.children[resolvedTarget.slice(2)];
        else targetActorRef = extra.deferredActorIds?.includes(resolvedTarget) ? resolvedTarget : snapshot.children[resolvedTarget];
        if (!targetActorRef) throw new Error(`Unable to send event to actor '${resolvedTarget}' from machine '${snapshot.machine.id}'.`);
    } else targetActorRef = resolvedTarget || actorScope.self;
    return [
        snapshot,
        {
            to: targetActorRef,
            targetId: typeof resolvedTarget === 'string' ? resolvedTarget : undefined,
            event: resolvedEvent,
            id: id,
            delay: resolvedDelay
        },
        undefined
    ];
}
function $9c4829d96c0398b3$var$retryResolveSendTo(_, snapshot, params) {
    if (typeof params.to === 'string') params.to = snapshot.children[params.to];
}
function $9c4829d96c0398b3$var$executeSendTo(actorScope, params) {
    // this forms an outgoing events queue
    // thanks to that the recipient actors are able to read the *updated* snapshot value of the sender
    actorScope.defer(()=>{
        const { to: to, event: event, delay: delay, id: id } = params;
        if (typeof delay === 'number') {
            actorScope.system.scheduler.schedule(actorScope.self, to, event, delay, id);
            return;
        }
        actorScope.system._relay(actorScope.self, // at this point, in a deferred task, it should already be mutated by retryResolveSendTo
        // if it initially started as a string
        to, event.type === (0, $96dZ7.V) ? (0, $96dZ7.W)(actorScope.self.id, event.data) : event);
    });
}
/**
 * Sends an event to an actor.
 *
 * @param actor The `ActorRef` to send the event to.
 * @param event The event to send, or an expression that evaluates to the event
 *   to send
 * @param options Send action options
 *
 *   - `id` - The unique send event identifier (used with `cancel()`).
 *   - `delay` - The number of milliseconds to delay the sending of the event.
 */ function $9c4829d96c0398b3$export$db3b6bfb95261072(to, eventOrExpr, options) {
    function sendTo(_args, _params) {}
    sendTo.type = 'xstate.sendTo';
    sendTo.to = to;
    sendTo.event = eventOrExpr;
    sendTo.id = options?.id;
    sendTo.delay = options?.delay;
    sendTo.resolve = $9c4829d96c0398b3$var$resolveSendTo;
    sendTo.retryResolve = $9c4829d96c0398b3$var$retryResolveSendTo;
    sendTo.execute = $9c4829d96c0398b3$var$executeSendTo;
    return sendTo;
}
/**
 * Sends an event to this machine's parent.
 *
 * @param event The event to send to the parent machine.
 * @param options Options to pass into the send event.
 */ function $9c4829d96c0398b3$export$2408f22a0fab9ae5(event, options) {
    return $9c4829d96c0398b3$export$db3b6bfb95261072($9c4829d96c0398b3$export$25ce5a424b770e84.Parent, event, options);
}
/**
 * Forwards (sends) an event to the `target` actor.
 *
 * @param target The target actor to forward the event to.
 * @param options Options to pass into the send action creator.
 */ function $9c4829d96c0398b3$export$2d1720544b23b823(target, options) {
    return $9c4829d96c0398b3$export$db3b6bfb95261072(target, ({ event: event })=>event, options);
}
function $9c4829d96c0398b3$var$resolveEnqueueActions(actorScope, snapshot, args, actionParams, { collect: collect }) {
    const actions = [];
    const enqueue = function enqueue(action) {
        actions.push(action);
    };
    enqueue.assign = (...args)=>{
        actions.push($9c4829d96c0398b3$export$407448d2b89b1813(...args));
    };
    enqueue.cancel = (...args)=>{
        actions.push((0, $96dZ7.M)(...args));
    };
    enqueue.raise = (...args)=>{
        // for some reason it fails to infer `TDelay` from `...args` here and picks its default (`never`)
        // then it fails to typecheck that because `...args` use `string` in place of `TDelay`
        actions.push((0, $96dZ7.O)(...args));
    };
    enqueue.sendTo = (...args)=>{
        // for some reason it fails to infer `TDelay` from `...args` here and picks its default (`never`)
        // then it fails to typecheck that because `...args` use `string` in place of `TDelay
        actions.push($9c4829d96c0398b3$export$db3b6bfb95261072(...args));
    };
    enqueue.sendParent = (...args)=>{
        actions.push($9c4829d96c0398b3$export$2408f22a0fab9ae5(...args));
    };
    enqueue.spawnChild = (...args)=>{
        actions.push((0, $96dZ7.P)(...args));
    };
    enqueue.stopChild = (...args)=>{
        actions.push((0, $96dZ7.R)(...args));
    };
    enqueue.emit = (...args)=>{
        actions.push($9c4829d96c0398b3$export$f1e1789686576879(...args));
    };
    collect({
        context: args.context,
        event: args.event,
        enqueue: enqueue,
        check: (guard)=>(0, $96dZ7.e)(guard, snapshot.context, args.event, snapshot),
        self: actorScope.self,
        system: actorScope.system
    }, actionParams);
    return [
        snapshot,
        undefined,
        actions
    ];
}
/**
 * Creates an action object that will execute actions that are queued by the
 * `enqueue(action)` function.
 *
 * @example
 *
 * ```ts
 * import { createMachine, enqueueActions } from 'xstate';
 *
 * const machine = createMachine({
 *   entry: enqueueActions(({ enqueue, check }) => {
 *     enqueue.assign({ count: 0 });
 *
 *     if (check('someGuard')) {
 *       enqueue.assign({ count: 1 });
 *     }
 *
 *     enqueue('someAction');
 *   })
 * });
 * ```
 */ function $9c4829d96c0398b3$export$8b22cf2602fb60ce(collect) {
    function enqueueActions(_args, _params) {}
    enqueueActions.type = 'xstate.enqueueActions';
    enqueueActions.collect = collect;
    enqueueActions.resolve = $9c4829d96c0398b3$var$resolveEnqueueActions;
    return enqueueActions;
}
function $9c4829d96c0398b3$var$resolveLog(_, snapshot, actionArgs, actionParams, { value: value, label: label }) {
    return [
        snapshot,
        {
            value: typeof value === 'function' ? value(actionArgs, actionParams) : value,
            label: label
        },
        undefined
    ];
}
function $9c4829d96c0398b3$var$executeLog({ logger: logger }, { value: value, label: label }) {
    if (label) logger(label, value);
    else logger(value);
}
/**
 * @param expr The expression function to evaluate which will be logged. Takes
 *   in 2 arguments:
 *
 *   - `ctx` - the current state context
 *   - `event` - the event that caused this action to be executed.
 *
 * @param label The label to give to the logged expression.
 */ function $9c4829d96c0398b3$export$882b5998b3b9117c(value = ({ context: context, event: event })=>({
        context: context,
        event: event
    }), label) {
    function log1(_args, _params) {}
    log1.type = 'xstate.log';
    log1.value = value;
    log1.label = label;
    log1.resolve = $9c4829d96c0398b3$var$resolveLog;
    log1.execute = $9c4829d96c0398b3$var$executeLog;
    return log1;
}
module.exports["a"] = $9c4829d96c0398b3$export$407448d2b89b1813;
module.exports["e"] = $9c4829d96c0398b3$export$f1e1789686576879;
module.exports["c"] = $9c4829d96c0398b3$export$db3b6bfb95261072;
module.exports["b"] = $9c4829d96c0398b3$export$8b22cf2602fb60ce;

});

parcelRegister("5VSNw", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $a59ec0f880a08336$var$styles = {
    container: "_1e0c1txw _4cvr1h6o _1bah1h6o _4t3i1crf _1bsb1crf"
};
const $a59ec0f880a08336$var$ROVO_SVG_PATH = `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M5.38007 0.169224C5.79665 -0.0605531 6.30508 -0.0563317 6.71827 0.181888L9.96761 2.05659L10.7381 2.50115C11.1589 2.7437 11.4193 3.1937 11.4193 3.67848V8.31707C11.4193 8.80377 11.1604 9.25178 10.7385 9.4942L7.71671 11.2376C7.72332 11.219 7.72963 11.2003 7.73565 11.1815C7.79172 11.0077 7.82146 10.8241 7.82146 10.6363V5.99777C7.82146 5.36053 7.4823 4.7729 6.92908 4.45501L6.37094 4.13313L4.67654 3.15598V1.35919C4.67654 1.21761 4.69845 1.0793 4.7399 0.948371C4.8418 0.631497 5.05854 0.357177 5.35505 0.185934L5.35594 0.185415C5.36443 0.180511 5.37252 0.175072 5.38007 0.169224Z" fill="#FCA700"/>
		<path d="M4.35709 0.762451L1.33533 2.50585C0.91337 2.74828 0.654541 3.19629 0.654541 3.68299V8.32158C0.654541 8.80636 0.914895 9.25633 1.33561 9.49887L2.05206 9.91223L5.35553 11.8182C5.76872 12.0563 6.27717 12.0606 6.69373 11.8308C6.70128 11.825 6.7093 11.8196 6.71781 11.8147C7.01463 11.6435 7.2317 11.3691 7.33376 11.0521C7.3753 10.9211 7.39725 10.7826 7.39725 10.6409V8.84408L5.64872 7.83569L5.14485 7.54513C4.59174 7.22722 4.25234 6.63946 4.25234 6.00228V1.3637C4.25234 1.17625 4.28199 0.992849 4.33793 0.81927C4.344 0.800208 4.35039 0.781265 4.35709 0.762451Z" fill="#FCA700"/>
		<path fill-rule="evenodd" clip-rule="evenodd" d="M5.64872 7.83569L2.05206 9.91223L1.33561 9.49887C0.914895 9.25633 0.654541 8.80636 0.654541 8.32158V3.68299C0.654541 3.19629 0.91337 2.74828 1.33533 2.50585L4.35709 0.762451C4.35039 0.781265 4.344 0.800208 4.33793 0.81927C4.28199 0.992849 4.25234 1.17625 4.25234 1.3637V6.00228C4.25234 6.63946 4.59174 7.22722 5.14485 7.54513L5.64872 7.83569Z" fill="#1868DB"/>
		<path fill-rule="evenodd" clip-rule="evenodd" d="M6.37094 4.13313L4.67654 3.15598V1.35919C4.67654 1.21761 4.69845 1.0793 4.7399 0.948371C4.8418 0.631497 5.05854 0.357177 5.35505 0.185934L5.35594 0.185415C5.36443 0.180511 5.37252 0.175072 5.38007 0.169224C5.79665 -0.0605531 6.30508 -0.0563317 6.71827 0.181888L9.96761 2.05659L6.37094 4.13313Z" fill="#FCA700"/>
		<path fill-rule="evenodd" clip-rule="evenodd" d="M10.7381 2.5012L9.9676 2.05664L6.37094 4.13318L6.92907 4.45507C7.48229 4.77296 7.82146 5.36059 7.82146 5.99783V10.6364C7.82146 10.8241 7.79172 11.0078 7.73565 11.1816C7.72963 11.2004 7.72332 11.2191 7.71671 11.2377L10.7385 9.49426C11.1604 9.25184 11.4193 8.80382 11.4193 8.31712V3.67853C11.4193 3.19376 11.1589 2.74376 10.7381 2.5012Z" fill="#AF59E0"/>
		<path fill-rule="evenodd" clip-rule="evenodd" d="M5.64873 7.83569L2.05206 9.91224L5.35553 11.8182C5.76873 12.0564 6.27718 12.0606 6.69373 11.8308C6.70128 11.825 6.70931 11.8196 6.71782 11.8147C7.01463 11.6436 7.2317 11.3691 7.33377 11.0521C7.37531 10.9211 7.39726 10.7826 7.39726 10.6409V8.84409L5.64873 7.83569Z" fill="#6A9A23"/>
	</svg>`;
const $a59ec0f880a08336$var$RovoLogoSVG = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { label: label, testId: testId } = t0;
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            __html: $a59ec0f880a08336$var$ROVO_SVG_PATH
        };
        t2 = (0, $hekY6.default)([
            $a59ec0f880a08336$var$styles.container
        ]);
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    let t3;
    if ($[2] !== label || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            role: "img",
            "aria-label": label,
            "data-testid": testId,
            dangerouslySetInnerHTML: t1,
            className: t2
        });
        $[2] = label;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : ({ label: label, testId: testId })=>/*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        role: "img",
        "aria-label": label,
        "data-testid": testId,
        dangerouslySetInnerHTML: {
            __html: $a59ec0f880a08336$var$ROVO_SVG_PATH
        },
        className: (0, $hekY6.default)([
            $a59ec0f880a08336$var$styles.container
        ])
    });
const $a59ec0f880a08336$export$4476d508de061a72 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { label: label, testId: testId } = t0;
    let t1;
    if ($[0] !== label || $[1] !== testId) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)($a59ec0f880a08336$var$RovoLogoSVG, {
            label: label,
            testId: testId
        });
        $[0] = label;
        $[1] = testId;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ label: label, testId: testId })=>/*#__PURE__*/ (0, $8aG6j.jsx)($a59ec0f880a08336$var$RovoLogoSVG, {
        label: label,
        testId: testId
    });
module.exports["AIChatIcon"] = $a59ec0f880a08336$export$4476d508de061a72;

});

parcelRegister("3N2DH", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $ad7Ou = parcelRequire("ad7Ou");

var $1sCHt = parcelRequire("1sCHt");


var $5VSNw = parcelRequire("5VSNw");

var $6t3CY = parcelRequire("6t3CY");

var $lslMH = parcelRequire("lslMH");


var $cXtTj = parcelRequire("cXtTj");


var $dTHYM = parcelRequire("dTHYM");

var $dUI0h = parcelRequire("dUI0h");


var $7sJoX = parcelRequire("7sJoX");


var $blZUD = parcelRequire("blZUD");


var $bltJZ = parcelRequire("bltJZ");


var $iDrrr = parcelRequire("iDrrr");


var $5wHqn = parcelRequire("5wHqn");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $jPaq9 = parcelRequire("jPaq9");


var $hdBxM = parcelRequire("hdBxM");


var $4yg9g = parcelRequire("4yg9g");


var $fqVYq = parcelRequire("fqVYq");


var $lpNn5 = parcelRequire("lpNn5");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $kMkDS = parcelRequire("kMkDS");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $7fb521c50b890daa$var$store = (0, $8s9DV.createStore)({
    name: 'RovoChatHighlightActionsStore',
    initialState: {
        isMoreOptionsPopupOpen: false
    },
    actions: {
        setIsMoreOptionsPopupOpen: (isOpen)=>({ setState: setState })=>{
                setState({
                    isMoreOptionsPopupOpen: isOpen
                });
            }
    }
});
const $7fb521c50b890daa$export$6c9cf98a64763bb1 = (0, $kBr4q.createHook)($7fb521c50b890daa$var$store);
const $7fb521c50b890daa$export$f1e33ed2d48967b4 = (0, $kBr4q.createActionsHook)($7fb521c50b890daa$var$store);



var $8VrqA = parcelRequire("8VrqA");




const $47e267cfc6e317db$var$message = (0, $kSwu1.defineMessages)({
    rovoChatAskInChatButtonText: {
        id: "highlight-actions.rovo-chat.ask-in-chat-button-text",
        defaultMessage: "Ask in Chat"
    },
    rovoChatAskRovoButtonText: {
        id: "highlight-actions.rovo-chat.ask-rovo-button-text",
        defaultMessage: "Ask Rovo"
    },
    rovoChatOpenChatTooltip: {
        id: "highlight-actions.rovo-chat-open-chat.tooltip",
        defaultMessage: "Open Chat"
    },
    rovoChatMoreOptionsTooltip: {
        id: "highlight-actions.rovo-chat-more-options.tooltip",
        defaultMessage: "Chat recommendations"
    },
    rovoChatSummarizeOptionText: {
        id: "highlight-actions.rovo-chat-summarize-option.text",
        defaultMessage: "Summarize"
    },
    rovoChatExplainOptionText: {
        id: "highlight-actions.rovo-chat-explain-option.text",
        defaultMessage: "Explain"
    },
    rovoChatFindResourcesOptionText: {
        id: "highlight-actions.rovo-chat-find-resources-option.text",
        defaultMessage: "Find resources"
    },
    rovoChatGiveFeedbackOptionText: {
        id: "highlight-actions.rovo-chat-give-feedback-option.text",
        defaultMessage: "Give feedback"
    },
    rovoChatGiveExamplesOptionText: {
        id: "highlight-actions.rovo-chat-give-examples-option.text",
        defaultMessage: "Give examples"
    },
    rovoChatSummarizePrompt: {
        id: "highlight-actions.rovo-chat-summarize-prompt",
        defaultMessage: "Highlight the key points from this. Focus on essential information and exclude unnecessary details. Provide a concise overview in a single paragraph."
    },
    rovoChatExplainPrompt: {
        id: "highlight-actions.rovo-chat-explain-prompt",
        defaultMessage: "Explain this by rephrasing it and adding additional detail, but use very simple language, short sentences, and provide examples or definitions to any technical terminology used in the original phrasing."
    },
    rovoChatFindResourcesPrompt: {
        id: "highlight-actions.rovo-chat-find-resources-prompt",
        defaultMessage: "Find resources within organizational knowledge only that supports the statements made."
    },
    rovoChatGiveFeedbackPrompt: {
        id: "highlight-actions.rovo-chat-give-feedback-prompt",
        defaultMessage: "Give feedback by reviewing the phrasing of this. Provide commentary on word choice, grammar, punctuation. Be positive and enthusiastic but always provide at least one thing to improve or change."
    },
    rovoChatGiveExamplesPrompt: {
        id: "highlight-actions.rovo-chat-give-examples-prompt",
        defaultMessage: "Give examples of this from organizational resources or public knowledge. If there are no resources to provide attempt to give a metaphorical example that may help someone understand this more."
    },
    rovoChatCustomPromptPlaceholder: {
        id: "highlight-actions.rovo-chat-custom-prompt.placeholder",
        defaultMessage: "Ask AI about this"
    },
    rovoChatCustomPromptSubmitButtonText: {
        id: "highlight-actions.rovo-chat-custom-prompt-submit-button.text",
        defaultMessage: "Send"
    }
});
var $47e267cfc6e317db$export$2e2bcd8739ae039 = $47e267cfc6e317db$var$message;


const $c1b3e570a8bf3f0c$var$styles = {
    popupContainer: "_ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb",
    formWrapper: "_1pfhx0bf",
    sendIconWrapper: "_y4tiutpp",
    rovoChatMoreOptionsButtonContainer: "_ahbqx0bf",
    rovoChatOpenChatIcon: "_bozgv77o"
};
const $c1b3e570a8bf3f0c$export$1ccbc9113b239d47 = ({ selectedContent: selectedContent, product: product, onClickChat: onClickChat, onClickPromptOverride: onClickPromptOverride, onSubmitCustomPromptOverride: onSubmitCustomPromptOverride })=>{
    (0, $6cFsl.di)((0, $cXtTj.default), (0, $7fb521c50b890daa$export$6c9cf98a64763bb1));
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    const { setIsMoreOptionsPopupOpen: setIsMoreOptionsPopupOpen } = (0, $7fb521c50b890daa$export$f1e33ed2d48967b4)();
    const [{ isMoreOptionsPopupOpen: isMoreOptionsPopupOpen }] = (0, $7fb521c50b890daa$export$6c9cf98a64763bb1)();
    const { insertHighlightActionsEditorPlaceholder: insertHighlightActionsEditorPlaceholder } = (0, $8VrqA.useHighlightActionsEditorPlaceholder)();
    (0, $cozmU.useEffect)(()=>{
        sendAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'contextualMenuItem',
            actionSubjectId: 'rovoChatHighlightActions',
            attributes: {
                product: product
            }
        });
    }, [
        sendAnalyticsEvent,
        product
    ]);
    const onClose = (0, $cozmU.useCallback)(()=>{
        setIsMoreOptionsPopupOpen(false);
    }, [
        setIsMoreOptionsPopupOpen
    ]);
    const handleClickChat = (0, $cozmU.useCallback)(async ()=>{
        onClickChat();
        insertHighlightActionsEditorPlaceholder(selectedContent);
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'highlightActionsMenuRovoChatButton',
            attributes: {
                product: product
            }
        });
    }, [
        onClickChat,
        insertHighlightActionsEditorPlaceholder,
        selectedContent,
        sendAnalyticsEvent,
        product
    ]);
    const handlePromptSubmit = (0, $cozmU.useCallback)((values, form)=>{
        const formattedPrompt = (0, $kMkDS.appendADFContent)(selectedContent, values.prompt);
        if (onSubmitCustomPromptOverride) {
            onSubmitCustomPromptOverride(formattedPrompt);
            form.reset();
            sendAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'highlightActionsMenuSubmitPromptButton',
                attributes: {
                    product: product
                }
            });
            return;
        }
        publish({
            type: 'chat-new',
            source: `${product}-context-menu`,
            data: {
                name: values.prompt.substring(0, 30),
                dialogues: [],
                prompt: formattedPrompt
            }
        });
        form.reset();
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'highlightActionsMenuSubmitPromptButton',
            attributes: {
                product: product
            }
        });
    }, [
        publish,
        sendAnalyticsEvent,
        product,
        onSubmitCustomPromptOverride,
        selectedContent
    ]);
    const rovoChatPromptOptions = [
        {
            id: 'context-menu-rovo-chat-summarize-option',
            actionType: 'summarize',
            prompt: formatMessage((0, $47e267cfc6e317db$export$2e2bcd8739ae039).rovoChatSummarizePrompt),
            optionText: formatMessage((0, $47e267cfc6e317db$export$2e2bcd8739ae039).rovoChatSummarizeOptionText)
        },
        {
            id: 'context-menu-rovo-chat-explain-option',
            actionType: 'explain',
            prompt: formatMessage((0, $47e267cfc6e317db$export$2e2bcd8739ae039).rovoChatExplainPrompt),
            optionText: formatMessage((0, $47e267cfc6e317db$export$2e2bcd8739ae039).rovoChatExplainOptionText)
        },
        {
            id: 'context-menu-rovo-chat-find-resources-option',
            actionType: 'find-resources',
            prompt: formatMessage((0, $47e267cfc6e317db$export$2e2bcd8739ae039).rovoChatFindResourcesPrompt),
            optionText: formatMessage((0, $47e267cfc6e317db$export$2e2bcd8739ae039).rovoChatFindResourcesOptionText)
        },
        {
            id: 'context-menu-rovo-chat-give-feedback-option',
            actionType: 'give-feedback',
            prompt: formatMessage((0, $47e267cfc6e317db$export$2e2bcd8739ae039).rovoChatGiveFeedbackPrompt),
            optionText: formatMessage((0, $47e267cfc6e317db$export$2e2bcd8739ae039).rovoChatGiveFeedbackOptionText)
        },
        {
            id: 'context-menu-rovo-chat-give-examples-option',
            actionType: 'give-examples',
            prompt: formatMessage((0, $47e267cfc6e317db$export$2e2bcd8739ae039).rovoChatGiveExamplesPrompt),
            optionText: formatMessage((0, $47e267cfc6e317db$export$2e2bcd8739ae039).rovoChatGiveExamplesOptionText)
        }
    ];
    const renderPopupContent = ()=>{
        return /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            testId: "context-menu-rovo-chat-popup",
            xcss: $c1b3e570a8bf3f0c$var$styles.popupContainer,
            space: "space.150"
        }, rovoChatPromptOptions.map((option)=>{
            return /*#__PURE__*/ $cozmU.createElement((0, $jPaq9.ChatPill), {
                key: option.id,
                testId: option.id,
                onClick: ()=>{
                    const formattedPrompt_0 = (0, $kMkDS.appendADFContent)(selectedContent, option.prompt);
                    if (onClickPromptOverride) {
                        onClickPromptOverride(formattedPrompt_0);
                        sendAnalyticsEvent({
                            action: 'clicked',
                            actionSubject: 'button',
                            actionSubjectId: 'highlightActionsMenuConvoStarterButton',
                            attributes: {
                                actionType: option.actionType,
                                product: product
                            }
                        });
                        return;
                    }
                    publish({
                        type: 'chat-new',
                        source: `${product}-context-menu`,
                        data: {
                            name: option.prompt.substring(0, 30),
                            dialogues: [],
                            prompt: formattedPrompt_0
                        }
                    });
                    sendAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'highlightActionsMenuConvoStarterButton',
                        attributes: {
                            actionType: option.actionType,
                            product: product
                        }
                    });
                }
            }, option.optionText);
        }), (0, $iDrrr.fg)('platform-design_system_team-form_conversion') ? /*#__PURE__*/ $cozmU.createElement((0, $dTHYM.default), {
            onSubmit: handlePromptSubmit
        }, /*#__PURE__*/ $cozmU.createElement((0, $dUI0h.default), {
            name: "prompt"
        }, ({ fieldProps: { value: value, ...fieldPropsRest }, meta: { dirty: dirty } })=>/*#__PURE__*/ $cozmU.createElement((0, $4yg9g.default // this prevents the highlight actions popup from closing when clicking on the input
            ), {
                onClick: (e)=>e.stopPropagation(),
                ...fieldPropsRest,
                testId: "context-menu-rovo-chat-custom-prompt",
                id: "context-menu-rovo-chat-custom-prompt",
                autoComplete: "off",
                elemAfterInput: /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                    xcss: $c1b3e570a8bf3f0c$var$styles.sendIconWrapper
                }, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
                    testId: "context-menu-rovo-chat-custom-prompt-submit",
                    isDisabled: !dirty || !value,
                    label: formatMessage((0, $47e267cfc6e317db$export$2e2bcd8739ae039).rovoChatCustomPromptSubmitButtonText),
                    type: "submit",
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($blZUD))),
                    spacing: "compact"
                })),
                placeholder: formatMessage((0, $47e267cfc6e317db$export$2e2bcd8739ae039).rovoChatCustomPromptPlaceholder),
                "aria-label": formatMessage((0, $47e267cfc6e317db$export$2e2bcd8739ae039).rovoChatCustomPromptPlaceholder)
            }))) : /*#__PURE__*/ $cozmU.createElement((0, $dTHYM.default), {
            onSubmit: handlePromptSubmit
        }, ({ formProps: formProps })=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                xcss: $c1b3e570a8bf3f0c$var$styles.formWrapper
            }, /*#__PURE__*/ $cozmU.createElement("form", formProps, /*#__PURE__*/ $cozmU.createElement((0, $dUI0h.default), {
                name: "prompt"
            }, ({ fieldProps: { value: value_0, ...fieldPropsRest_0 }, meta: { dirty: dirty_0 } })=>/*#__PURE__*/ $cozmU.createElement((0, $4yg9g.default // this prevents the highlight actions popup from closing when clicking on the input
                ), {
                    onClick: (e_0)=>e_0.stopPropagation(),
                    ...fieldPropsRest_0,
                    testId: "context-menu-rovo-chat-custom-prompt",
                    id: "context-menu-rovo-chat-custom-prompt",
                    autoComplete: "off",
                    elemAfterInput: /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                        xcss: $c1b3e570a8bf3f0c$var$styles.sendIconWrapper
                    }, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
                        testId: "context-menu-rovo-chat-custom-prompt-submit",
                        isDisabled: !dirty_0 || !value_0,
                        label: formatMessage((0, $47e267cfc6e317db$export$2e2bcd8739ae039).rovoChatCustomPromptSubmitButtonText),
                        type: "submit",
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($blZUD))),
                        spacing: "compact"
                    })),
                    placeholder: formatMessage((0, $47e267cfc6e317db$export$2e2bcd8739ae039).rovoChatCustomPromptPlaceholder),
                    "aria-label": formatMessage((0, $47e267cfc6e317db$export$2e2bcd8739ae039).rovoChatCustomPromptPlaceholder)
                }))))));
    };
    const isToolbarAIFCEnabled = (0, $fqVYq.editorExperiment)('platform_editor_toolbar_aifc', true);
    if (product === 'confluence' && isToolbarAIFCEnabled) return /*#__PURE__*/ $cozmU.createElement((0, $lslMH.ToolbarTooltip), {
        content: formatMessage((0, $47e267cfc6e317db$export$2e2bcd8739ae039).rovoChatOpenChatTooltip)
    }, /*#__PURE__*/ $cozmU.createElement((0, $6t3CY.ToolbarButton), {
        iconBefore: /*#__PURE__*/ $cozmU.createElement((0, $5VSNw.AIChatIcon), {
            label: ""
        }),
        onClick: handleClickChat,
        testId: "context-menu-rovo-chat-button"
    }, formatMessage((0, $47e267cfc6e317db$export$2e2bcd8739ae039).rovoChatAskRovoButtonText)));
    return /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), null, /*#__PURE__*/ $cozmU.createElement((0, $lpNn5.default), {
        content: formatMessage((0, $47e267cfc6e317db$export$2e2bcd8739ae039).rovoChatOpenChatTooltip)
    }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        iconBefore: ()=>/*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
                xcss: $c1b3e570a8bf3f0c$var$styles.rovoChatOpenChatIcon
            }, /*#__PURE__*/ $cozmU.createElement((0, $bltJZ.RovoIcon), {
                size: "xsmall"
            })),
        onClick: handleClickChat,
        testId: "context-menu-rovo-chat-button"
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        weight: "medium"
    }, formatMessage((0, $47e267cfc6e317db$export$2e2bcd8739ae039).rovoChatAskRovoButtonText)))), /*#__PURE__*/ $cozmU.createElement((0, $5wHqn.default), {
        placement: "bottom-start",
        isOpen: isMoreOptionsPopupOpen,
        onClose: onClose,
        content: renderPopupContent,
        zIndex: 600,
        trigger: (triggerProps)=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                xcss: $c1b3e570a8bf3f0c$var$styles.rovoChatMoreOptionsButtonContainer
            }, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
                ...triggerProps,
                appearance: "subtle",
                id: "context-menu-rovo-chat-more-options",
                testId: "context-menu-rovo-chat-more-options",
                isTooltipDisabled: false,
                icon: (props)=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                        ...props,
                        label: formatMessage((0, $47e267cfc6e317db$export$2e2bcd8739ae039).rovoChatMoreOptionsTooltip),
                        size: "small"
                    }),
                label: formatMessage((0, $47e267cfc6e317db$export$2e2bcd8739ae039).rovoChatMoreOptionsTooltip),
                onClick: ()=>{
                    setIsMoreOptionsPopupOpen(!isMoreOptionsPopupOpen);
                    sendAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'highlightActionsMenuRovoChatMoreOptionsButton',
                        attributes: {
                            product: product
                        }
                    });
                }
            }))
    }));
};
module.exports["RovoChatHighlightActions"] = $c1b3e570a8bf3f0c$export$1ccbc9113b239d47;

});

parcelRegister("96dZ7", function(module, exports) {

var $e6Soq = parcelRequire("e6Soq");

class $69ff85b27d828958$var$Mailbox {
    start() {
        this._active = true;
        this.flush();
    }
    clear() {
        // we can't set _current to null because we might be currently processing
        // and enqueue following clear shouldnt start processing the enqueued item immediately
        if (this._current) {
            this._current.next = null;
            this._last = this._current;
        }
    }
    enqueue(event) {
        const enqueued = {
            value: event,
            next: null
        };
        if (this._current) {
            this._last.next = enqueued;
            this._last = enqueued;
            return;
        }
        this._current = enqueued;
        this._last = enqueued;
        if (this._active) this.flush();
    }
    flush() {
        while(this._current){
            // atm the given _process is responsible for implementing proper try/catch handling
            // we assume here that this won't throw in a way that can affect this mailbox
            const consumed = this._current;
            this._process(consumed.value);
            this._current = consumed.next;
        }
        this._last = null;
    }
    constructor(_process){
        this._process = _process;
        this._active = false;
        this._current = null;
        this._last = null;
    }
}
const $69ff85b27d828958$export$25ce5a424b770e84 = '.';
const $69ff85b27d828958$var$TARGETLESS_KEY = '';
const $69ff85b27d828958$export$a07804094c3ecf2d = '';
const $69ff85b27d828958$var$STATE_IDENTIFIER = '#';
const $69ff85b27d828958$var$WILDCARD = '*';
const $69ff85b27d828958$var$XSTATE_INIT = 'xstate.init';
const $69ff85b27d828958$export$e7c866399fa523f5 = 'xstate.error';
const $69ff85b27d828958$export$78acf4525d8a74c4 = 'xstate.stop';
/**
 * Returns an event that represents an implicit event that is sent after the
 * specified `delay`.
 *
 * @param delayRef The delay in milliseconds
 * @param id The state node ID where this event is handled
 */ function $69ff85b27d828958$var$createAfterEvent(delayRef, id) {
    return {
        type: `xstate.after.${delayRef}.${id}`
    };
}
/**
 * Returns an event that represents that a final state node has been reached in
 * the parent state node.
 *
 * @param id The final state node's parent state node `id`
 * @param output The data to pass into the event
 */ function $69ff85b27d828958$var$createDoneStateEvent(id, output) {
    return {
        type: `xstate.done.state.${id}`,
        output: output
    };
}
/**
 * Returns an event that represents that an invoked service has terminated.
 *
 * An invoked service is terminated when it has reached a top-level final state
 * node, but not when it is canceled.
 *
 * @param invokeId The invoked service ID
 * @param output The data to pass into the event
 */ function $69ff85b27d828958$var$createDoneActorEvent(invokeId, output) {
    return {
        type: `xstate.done.actor.${invokeId}`,
        output: output,
        actorId: invokeId
    };
}
function $69ff85b27d828958$export$71cec2538cb2c617(id, error) {
    return {
        type: `xstate.error.actor.${id}`,
        error: error,
        actorId: id
    };
}
function $69ff85b27d828958$export$9e5f44173e64f162(input) {
    return {
        type: $69ff85b27d828958$var$XSTATE_INIT,
        input: input
    };
}
/**
 * This function makes sure that unhandled errors are thrown in a separate
 * macrotask. It allows those errors to be detected by global error handlers and
 * reported to bug tracking services without interrupting our own stack of
 * execution.
 *
 * @param err Error to be thrown
 */ function $69ff85b27d828958$var$reportUnhandledError(err) {
    setTimeout(()=>{
        throw err;
    });
}
const $69ff85b27d828958$var$symbolObservable = (()=>typeof Symbol === 'function' && Symbol.observable || '@@observable')();
function $69ff85b27d828958$export$b4171a6734a65d42(parentStateId, childStateId) {
    const parentStateValue = $69ff85b27d828958$var$toStateValue(parentStateId);
    const childStateValue = $69ff85b27d828958$var$toStateValue(childStateId);
    if (typeof childStateValue === 'string') {
        if (typeof parentStateValue === 'string') return childStateValue === parentStateValue;
        // Parent more specific than child
        return false;
    }
    if (typeof parentStateValue === 'string') return parentStateValue in childStateValue;
    return Object.keys(parentStateValue).every((key)=>{
        if (!(key in childStateValue)) return false;
        return $69ff85b27d828958$export$b4171a6734a65d42(parentStateValue[key], childStateValue[key]);
    });
}
function $69ff85b27d828958$export$90a7f3efeed30595(stateId) {
    if ($69ff85b27d828958$var$isArray(stateId)) return stateId;
    const result = [];
    let segment = '';
    for(let i = 0; i < stateId.length; i++){
        const char = stateId.charCodeAt(i);
        switch(char){
            // \
            case 92:
                // consume the next character
                segment += stateId[i + 1];
                // and skip over it
                i++;
                continue;
            // .
            case 46:
                result.push(segment);
                segment = '';
                continue;
        }
        segment += stateId[i];
    }
    result.push(segment);
    return result;
}
function $69ff85b27d828958$var$toStateValue(stateValue) {
    if ($69ff85b27d828958$export$7f8ddf7c7c20b3cd(stateValue)) return stateValue.value;
    if (typeof stateValue !== 'string') return stateValue;
    const statePath = $69ff85b27d828958$export$90a7f3efeed30595(stateValue);
    return $69ff85b27d828958$export$3466f893ebf79586(statePath);
}
function $69ff85b27d828958$export$3466f893ebf79586(statePath) {
    if (statePath.length === 1) return statePath[0];
    const value = {};
    let marker = value;
    for(let i = 0; i < statePath.length - 1; i++)if (i === statePath.length - 2) marker[statePath[i]] = statePath[i + 1];
    else {
        const previous = marker;
        marker = {};
        previous[statePath[i]] = marker;
    }
    return value;
}
function $69ff85b27d828958$export$953cecd6e717a553(collection, iteratee) {
    const result = {};
    const collectionKeys = Object.keys(collection);
    for(let i = 0; i < collectionKeys.length; i++){
        const key = collectionKeys[i];
        result[key] = iteratee(collection[key], key, collection, i);
    }
    return result;
}
function $69ff85b27d828958$var$toArrayStrict(value) {
    if ($69ff85b27d828958$var$isArray(value)) return value;
    return [
        value
    ];
}
function $69ff85b27d828958$export$625550452a3fa3ec(value) {
    if (value === undefined) return [];
    return $69ff85b27d828958$var$toArrayStrict(value);
}
function $69ff85b27d828958$var$resolveOutput(mapper, context, event, self) {
    if (typeof mapper === 'function') return mapper({
        context: context,
        event: event,
        self: self
    });
    return mapper;
}
function $69ff85b27d828958$var$isArray(value) {
    return Array.isArray(value);
}
function $69ff85b27d828958$var$isErrorActorEvent(event) {
    return event.type.startsWith('xstate.error.actor');
}
function $69ff85b27d828958$export$407448d2b89b1813(configLike) {
    return $69ff85b27d828958$var$toArrayStrict(configLike).map((transitionLike)=>{
        if (typeof transitionLike === 'undefined' || typeof transitionLike === 'string') return {
            target: transitionLike
        };
        return transitionLike;
    });
}
function $69ff85b27d828958$var$normalizeTarget(target) {
    if (target === undefined || target === $69ff85b27d828958$var$TARGETLESS_KEY) return undefined;
    return $69ff85b27d828958$export$625550452a3fa3ec(target);
}
function $69ff85b27d828958$export$61196ced6d74a310(nextHandler, errorHandler, completionHandler) {
    const isObserver = typeof nextHandler === 'object';
    const self = isObserver ? nextHandler : undefined;
    return {
        next: (isObserver ? nextHandler.next : nextHandler)?.bind(self),
        error: (isObserver ? nextHandler.error : errorHandler)?.bind(self),
        complete: (isObserver ? nextHandler.complete : completionHandler)?.bind(self)
    };
}
function $69ff85b27d828958$export$db3b6bfb95261072(stateNodeId, index) {
    return `${index}.${stateNodeId}`;
}
function $69ff85b27d828958$export$df995fae86a55f06(machine, src) {
    const match = src.match(/^xstate\.invoke\.(\d+)\.(.*)/);
    if (!match) return machine.implementations.actors[src];
    const [, indexStr, nodeId] = match;
    const node = machine.getStateNodeById(nodeId);
    const invokeConfig = node.config.invoke;
    return (Array.isArray(invokeConfig) ? invokeConfig[indexStr] : invokeConfig).src;
}
function $69ff85b27d828958$export$9bb611d729802a56(snapshot) {
    return [
        ...new Set([
            ...snapshot._nodes.flatMap((sn)=>sn.ownEvents)
        ])
    ];
}
function $69ff85b27d828958$var$createScheduledEventId(actorRef, id) {
    return `${actorRef.sessionId}.${id}`;
}
let $69ff85b27d828958$var$idCounter = 0;
function $69ff85b27d828958$var$createSystem(rootActor, options) {
    const children = new Map();
    const keyedActors = new Map();
    const reverseKeyedActors = new WeakMap();
    const inspectionObservers = new Set();
    const timerMap = {};
    const { clock: clock, logger: logger } = options;
    const scheduler = {
        schedule: (source, target, event, delay, id = Math.random().toString(36).slice(2))=>{
            const scheduledEvent = {
                source: source,
                target: target,
                event: event,
                delay: delay,
                id: id,
                startedAt: Date.now()
            };
            const scheduledEventId = $69ff85b27d828958$var$createScheduledEventId(source, id);
            system._snapshot._scheduledEvents[scheduledEventId] = scheduledEvent;
            const timeout = clock.setTimeout(()=>{
                delete timerMap[scheduledEventId];
                delete system._snapshot._scheduledEvents[scheduledEventId];
                system._relay(source, target, event);
            }, delay);
            timerMap[scheduledEventId] = timeout;
        },
        cancel: (source, id)=>{
            const scheduledEventId = $69ff85b27d828958$var$createScheduledEventId(source, id);
            const timeout = timerMap[scheduledEventId];
            delete timerMap[scheduledEventId];
            delete system._snapshot._scheduledEvents[scheduledEventId];
            if (timeout !== undefined) clock.clearTimeout(timeout);
        },
        cancelAll: (actorRef)=>{
            for(const scheduledEventId in system._snapshot._scheduledEvents){
                const scheduledEvent = system._snapshot._scheduledEvents[scheduledEventId];
                if (scheduledEvent.source === actorRef) scheduler.cancel(actorRef, scheduledEvent.id);
            }
        }
    };
    const sendInspectionEvent = (event)=>{
        if (!inspectionObservers.size) return;
        const resolvedInspectionEvent = {
            ...event,
            rootId: rootActor.sessionId
        };
        inspectionObservers.forEach((observer)=>observer.next?.(resolvedInspectionEvent));
    };
    const system = {
        _snapshot: {
            _scheduledEvents: (options?.snapshot && options.snapshot.scheduler) ?? {}
        },
        _bookId: ()=>`x:${$69ff85b27d828958$var$idCounter++}`,
        _register: (sessionId, actorRef)=>{
            children.set(sessionId, actorRef);
            return sessionId;
        },
        _unregister: (actorRef)=>{
            children.delete(actorRef.sessionId);
            const systemId = reverseKeyedActors.get(actorRef);
            if (systemId !== undefined) {
                keyedActors.delete(systemId);
                reverseKeyedActors.delete(actorRef);
            }
        },
        get: (systemId)=>{
            return keyedActors.get(systemId);
        },
        _set: (systemId, actorRef)=>{
            const existing = keyedActors.get(systemId);
            if (existing && existing !== actorRef) throw new Error(`Actor with system ID '${systemId}' already exists.`);
            keyedActors.set(systemId, actorRef);
            reverseKeyedActors.set(actorRef, systemId);
        },
        inspect: (observerOrFn)=>{
            const observer = $69ff85b27d828958$export$61196ced6d74a310(observerOrFn);
            inspectionObservers.add(observer);
            return {
                unsubscribe () {
                    inspectionObservers.delete(observer);
                }
            };
        },
        _sendInspectionEvent: sendInspectionEvent,
        _relay: (source, target, event)=>{
            system._sendInspectionEvent({
                type: '@xstate.event',
                sourceRef: source,
                actorRef: target,
                event: event
            });
            target._send(event);
        },
        scheduler: scheduler,
        getSnapshot: ()=>{
            return {
                _scheduledEvents: {
                    ...system._snapshot._scheduledEvents
                }
            };
        },
        start: ()=>{
            const scheduledEvents = system._snapshot._scheduledEvents;
            system._snapshot._scheduledEvents = {};
            for(const scheduledId in scheduledEvents){
                const { source: source, target: target, event: event, delay: delay, id: id } = scheduledEvents[scheduledId];
                scheduler.schedule(source, target, event, delay, id);
            }
        },
        _clock: clock,
        _logger: logger
    };
    return system;
}
let $69ff85b27d828958$var$executingCustomAction = false;
const $69ff85b27d828958$export$3d8c2f653ac9d0b9 = 1;
// those values are currently used by @xstate/react directly so it's important to keep the assigned values in sync
let $69ff85b27d828958$export$971d5caa766a69d7 = /*#__PURE__*/ function(ProcessingStatus) {
    ProcessingStatus[ProcessingStatus["NotStarted"] = 0] = "NotStarted";
    ProcessingStatus[ProcessingStatus["Running"] = 1] = "Running";
    ProcessingStatus[ProcessingStatus["Stopped"] = 2] = "Stopped";
    return ProcessingStatus;
}({});
const $69ff85b27d828958$var$defaultOptions = {
    clock: {
        setTimeout: (fn, ms)=>{
            return setTimeout(fn, ms);
        },
        clearTimeout: (id)=>{
            return clearTimeout(id);
        }
    },
    logger: console.log.bind(console),
    devTools: false
};
/**
 * An Actor is a running process that can receive events, send events and change
 * its behavior based on the events it receives, which can cause effects outside
 * of the actor. When you run a state machine, it becomes an actor.
 */ class $69ff85b27d828958$export$ef35774e6d314e91 {
    _initState(persistedState) {
        try {
            this._snapshot = persistedState ? this.logic.restoreSnapshot ? this.logic.restoreSnapshot(persistedState, this._actorScope) : persistedState : this.logic.getInitialSnapshot(this._actorScope, this.options?.input);
        } catch (err) {
            // if we get here then it means that we assign a value to this._snapshot that is not of the correct type
            // we can't get the true `TSnapshot & { status: 'error'; }`, it's impossible
            // so right now this is a lie of sorts
            this._snapshot = {
                status: 'error',
                output: undefined,
                error: err
            };
        }
    }
    update(snapshot, event) {
        // Update state
        this._snapshot = snapshot;
        // Execute deferred effects
        let deferredFn;
        while(deferredFn = this._deferred.shift())try {
            deferredFn();
        } catch (err) {
            // this error can only be caught when executing *initial* actions
            // it's the only time when we call actions provided by the user through those deferreds
            // when the actor is already running we always execute them synchronously while transitioning
            // no "builtin deferred" should actually throw an error since they are either safe
            // or the control flow is passed through the mailbox and errors should be caught by the `_process` used by the mailbox
            this._deferred.length = 0;
            this._snapshot = {
                ...snapshot,
                status: 'error',
                error: err
            };
        }
        switch(this._snapshot.status){
            case 'active':
                for (const observer of this.observers)try {
                    observer.next?.(snapshot);
                } catch (err) {
                    $69ff85b27d828958$var$reportUnhandledError(err);
                }
                break;
            case 'done':
                // next observers are meant to be notified about done snapshots
                // this can be seen as something that is different from how observable work
                // but with observables `complete` callback is called without any arguments
                // it's more ergonomic for XState to treat a done snapshot as a "next" value
                // and the completion event as something that is separate,
                // something that merely follows emitting that done snapshot
                for (const observer of this.observers)try {
                    observer.next?.(snapshot);
                } catch (err) {
                    $69ff85b27d828958$var$reportUnhandledError(err);
                }
                this._stopProcedure();
                this._complete();
                this._doneEvent = $69ff85b27d828958$var$createDoneActorEvent(this.id, this._snapshot.output);
                if (this._parent) this.system._relay(this, this._parent, this._doneEvent);
                break;
            case 'error':
                this._error(this._snapshot.error);
                break;
        }
        this.system._sendInspectionEvent({
            type: '@xstate.snapshot',
            actorRef: this,
            event: event,
            snapshot: snapshot
        });
    }
    /**
   * Subscribe an observer to an actor’s snapshot values.
   *
   * @remarks
   * The observer will receive the actor’s snapshot value when it is emitted.
   * The observer can be:
   *
   * - A plain function that receives the latest snapshot, or
   * - An observer object whose `.next(snapshot)` method receives the latest
   *   snapshot
   *
   * @example
   *
   * ```ts
   * // Observer as a plain function
   * const subscription = actor.subscribe((snapshot) => {
   *   console.log(snapshot);
   * });
   * ```
   *
   * @example
   *
   * ```ts
   * // Observer as an object
   * const subscription = actor.subscribe({
   *   next(snapshot) {
   *     console.log(snapshot);
   *   },
   *   error(err) {
   *     // ...
   *   },
   *   complete() {
   *     // ...
   *   }
   * });
   * ```
   *
   * The return value of `actor.subscribe(observer)` is a subscription object
   * that has an `.unsubscribe()` method. You can call
   * `subscription.unsubscribe()` to unsubscribe the observer:
   *
   * @example
   *
   * ```ts
   * const subscription = actor.subscribe((snapshot) => {
   *   // ...
   * });
   *
   * // Unsubscribe the observer
   * subscription.unsubscribe();
   * ```
   *
   * When the actor is stopped, all of its observers will automatically be
   * unsubscribed.
   *
   * @param observer - Either a plain function that receives the latest
   *   snapshot, or an observer object whose `.next(snapshot)` method receives
   *   the latest snapshot
   */ subscribe(nextListenerOrObserver, errorListener, completeListener) {
        const observer = $69ff85b27d828958$export$61196ced6d74a310(nextListenerOrObserver, errorListener, completeListener);
        if (this._processingStatus !== $69ff85b27d828958$export$971d5caa766a69d7.Stopped) this.observers.add(observer);
        else switch(this._snapshot.status){
            case 'done':
                try {
                    observer.complete?.();
                } catch (err) {
                    $69ff85b27d828958$var$reportUnhandledError(err);
                }
                break;
            case 'error':
                {
                    const err = this._snapshot.error;
                    if (!observer.error) $69ff85b27d828958$var$reportUnhandledError(err);
                    else try {
                        observer.error(err);
                    } catch (err) {
                        $69ff85b27d828958$var$reportUnhandledError(err);
                    }
                    break;
                }
        }
        return {
            unsubscribe: ()=>{
                this.observers.delete(observer);
            }
        };
    }
    on(type, handler) {
        let listeners = this.eventListeners.get(type);
        if (!listeners) {
            listeners = new Set();
            this.eventListeners.set(type, listeners);
        }
        const wrappedHandler = handler.bind(undefined);
        listeners.add(wrappedHandler);
        return {
            unsubscribe: ()=>{
                listeners.delete(wrappedHandler);
            }
        };
    }
    /** Starts the Actor from the initial state */ start() {
        if (this._processingStatus === $69ff85b27d828958$export$971d5caa766a69d7.Running) // Do not restart the service if it is already started
        return this;
        if (this._syncSnapshot) this.subscribe({
            next: (snapshot)=>{
                if (snapshot.status === 'active') this.system._relay(this, this._parent, {
                    type: `xstate.snapshot.${this.id}`,
                    snapshot: snapshot
                });
            },
            error: ()=>{}
        });
        this.system._register(this.sessionId, this);
        if (this._systemId) this.system._set(this._systemId, this);
        this._processingStatus = $69ff85b27d828958$export$971d5caa766a69d7.Running;
        // TODO: this isn't correct when rehydrating
        const initEvent = $69ff85b27d828958$export$9e5f44173e64f162(this.options.input);
        this.system._sendInspectionEvent({
            type: '@xstate.event',
            sourceRef: this._parent,
            actorRef: this,
            event: initEvent
        });
        const status = this._snapshot.status;
        switch(status){
            case 'done':
                // a state machine can be "done" upon initialization (it could reach a final state using initial microsteps)
                // we still need to complete observers, flush deferreds etc
                this.update(this._snapshot, initEvent);
                // TODO: rethink cleanup of observers, mailbox, etc
                return this;
            case 'error':
                this._error(this._snapshot.error);
                return this;
        }
        if (!this._parent) this.system.start();
        if (this.logic.start) try {
            this.logic.start(this._snapshot, this._actorScope);
        } catch (err) {
            this._snapshot = {
                ...this._snapshot,
                status: 'error',
                error: err
            };
            this._error(err);
            return this;
        }
        // TODO: this notifies all subscribers but usually this is redundant
        // there is no real change happening here
        // we need to rethink if this needs to be refactored
        this.update(this._snapshot, initEvent);
        if (this.options.devTools) this.attachDevTools();
        this.mailbox.start();
        return this;
    }
    _process(event) {
        let nextState;
        let caughtError;
        try {
            nextState = this.logic.transition(this._snapshot, event, this._actorScope);
        } catch (err) {
            // we wrap it in a box so we can rethrow it later even if falsy value gets caught here
            caughtError = {
                err: err
            };
        }
        if (caughtError) {
            const { err: err } = caughtError;
            this._snapshot = {
                ...this._snapshot,
                status: 'error',
                error: err
            };
            this._error(err);
            return;
        }
        this.update(nextState, event);
        if (event.type === $69ff85b27d828958$export$78acf4525d8a74c4) {
            this._stopProcedure();
            this._complete();
        }
    }
    _stop() {
        if (this._processingStatus === $69ff85b27d828958$export$971d5caa766a69d7.Stopped) return this;
        this.mailbox.clear();
        if (this._processingStatus === $69ff85b27d828958$export$971d5caa766a69d7.NotStarted) {
            this._processingStatus = $69ff85b27d828958$export$971d5caa766a69d7.Stopped;
            return this;
        }
        this.mailbox.enqueue({
            type: $69ff85b27d828958$export$78acf4525d8a74c4
        });
        return this;
    }
    /** Stops the Actor and unsubscribe all listeners. */ stop() {
        if (this._parent) throw new Error('A non-root actor cannot be stopped directly.');
        return this._stop();
    }
    _complete() {
        for (const observer of this.observers)try {
            observer.complete?.();
        } catch (err) {
            $69ff85b27d828958$var$reportUnhandledError(err);
        }
        this.observers.clear();
    }
    _reportError(err) {
        if (!this.observers.size) {
            if (!this._parent) $69ff85b27d828958$var$reportUnhandledError(err);
            return;
        }
        let reportError = false;
        for (const observer of this.observers){
            const errorListener = observer.error;
            reportError || (reportError = !errorListener);
            try {
                errorListener?.(err);
            } catch (err2) {
                $69ff85b27d828958$var$reportUnhandledError(err2);
            }
        }
        this.observers.clear();
        if (reportError) $69ff85b27d828958$var$reportUnhandledError(err);
    }
    _error(err) {
        this._stopProcedure();
        this._reportError(err);
        if (this._parent) this.system._relay(this, this._parent, $69ff85b27d828958$export$71cec2538cb2c617(this.id, err));
    }
    // TODO: atm children don't belong entirely to the actor so
    // in a way - it's not even super aware of them
    // so we can't stop them from here but we really should!
    // right now, they are being stopped within the machine's transition
    // but that could throw and leave us with "orphaned" active actors
    _stopProcedure() {
        if (this._processingStatus !== $69ff85b27d828958$export$971d5caa766a69d7.Running) // Actor already stopped; do nothing
        return this;
        // Cancel all delayed events
        this.system.scheduler.cancelAll(this);
        // TODO: mailbox.reset
        this.mailbox.clear();
        // TODO: after `stop` we must prepare ourselves for receiving events again
        // events sent *after* stop signal must be queued
        // it seems like this should be the common behavior for all of our consumers
        // so perhaps this should be unified somehow for all of them
        this.mailbox = new $69ff85b27d828958$var$Mailbox(this._process.bind(this));
        this._processingStatus = $69ff85b27d828958$export$971d5caa766a69d7.Stopped;
        this.system._unregister(this);
        return this;
    }
    /** @internal */ _send(event) {
        if (this._processingStatus === $69ff85b27d828958$export$971d5caa766a69d7.Stopped) return;
        this.mailbox.enqueue(event);
    }
    /**
   * Sends an event to the running Actor to trigger a transition.
   *
   * @param event The event to send
   */ send(event) {
        this.system._relay(undefined, this, event);
    }
    attachDevTools() {
        const { devTools: devTools } = this.options;
        if (devTools) {
            const resolvedDevToolsAdapter = typeof devTools === 'function' ? devTools : (0, $e6Soq.devToolsAdapter);
            resolvedDevToolsAdapter(this);
        }
    }
    toJSON() {
        return {
            xstate$$type: $69ff85b27d828958$export$3d8c2f653ac9d0b9,
            id: this.id
        };
    }
    /**
   * Obtain the internal state of the actor, which can be persisted.
   *
   * @remarks
   * The internal state can be persisted from any actor, not only machines.
   *
   * Note that the persisted state is not the same as the snapshot from
   * {@link Actor.getSnapshot}. Persisted state represents the internal state of
   * the actor, while snapshots represent the actor's last emitted value.
   *
   * Can be restored with {@link ActorOptions.state}
   * @see https://stately.ai/docs/persistence
   */ getPersistedSnapshot(options) {
        return this.logic.getPersistedSnapshot(this._snapshot, options);
    }
    [$69ff85b27d828958$var$symbolObservable]() {
        return this;
    }
    /**
   * Read an actor’s snapshot synchronously.
   *
   * @remarks
   * The snapshot represent an actor's last emitted value.
   *
   * When an actor receives an event, its internal state may change. An actor
   * may emit a snapshot when a state transition occurs.
   *
   * Note that some actors, such as callback actors generated with
   * `fromCallback`, will not emit snapshots.
   * @see {@link Actor.subscribe} to subscribe to an actor’s snapshot values.
   * @see {@link Actor.getPersistedSnapshot} to persist the internal state of an actor (which is more than just a snapshot).
   */ getSnapshot() {
        return this._snapshot;
    }
    /**
   * Creates a new actor instance for the given logic with the provided options,
   * if any.
   *
   * @param logic The logic to create an actor from
   * @param options Actor options
   */ constructor(logic, options){
        this.logic = logic;
        /** The current internal state of the actor. */ this._snapshot = void 0;
        /**
     * The clock that is responsible for setting and clearing timeouts, such as
     * delayed events and transitions.
     */ this.clock = void 0;
        this.options = void 0;
        /** The unique identifier for this actor relative to its parent. */ this.id = void 0;
        this.mailbox = new $69ff85b27d828958$var$Mailbox(this._process.bind(this));
        this.observers = new Set();
        this.eventListeners = new Map();
        this.logger = void 0;
        /** @internal */ this._processingStatus = $69ff85b27d828958$export$971d5caa766a69d7.NotStarted;
        // Actor Ref
        this._parent = void 0;
        /** @internal */ this._syncSnapshot = void 0;
        this.ref = void 0;
        // TODO: add typings for system
        this._actorScope = void 0;
        this._systemId = void 0;
        /** The globally unique process ID for this invocation. */ this.sessionId = void 0;
        /** The system to which this actor belongs. */ this.system = void 0;
        this._doneEvent = void 0;
        this.src = void 0;
        // array of functions to defer
        this._deferred = [];
        const resolvedOptions = {
            ...$69ff85b27d828958$var$defaultOptions,
            ...options
        };
        const { clock: clock, logger: logger, parent: parent, syncSnapshot: syncSnapshot, id: id, systemId: systemId, inspect: inspect } = resolvedOptions;
        this.system = parent ? parent.system : $69ff85b27d828958$var$createSystem(this, {
            clock: clock,
            logger: logger
        });
        if (inspect && !parent) // Always inspect at the system-level
        this.system.inspect($69ff85b27d828958$export$61196ced6d74a310(inspect));
        this.sessionId = this.system._bookId();
        this.id = id ?? this.sessionId;
        this.logger = options?.logger ?? this.system._logger;
        this.clock = options?.clock ?? this.system._clock;
        this._parent = parent;
        this._syncSnapshot = syncSnapshot;
        this.options = resolvedOptions;
        this.src = resolvedOptions.src ?? logic;
        this.ref = this;
        this._actorScope = {
            self: this,
            id: this.id,
            sessionId: this.sessionId,
            logger: this.logger,
            defer: (fn)=>{
                this._deferred.push(fn);
            },
            system: this.system,
            stopChild: (child)=>{
                if (child._parent !== this) throw new Error(`Cannot stop child actor ${child.id} of ${this.id} because it is not a child`);
                child._stop();
            },
            emit: (emittedEvent)=>{
                const listeners = this.eventListeners.get(emittedEvent.type);
                const wildcardListener = this.eventListeners.get('*');
                if (!listeners && !wildcardListener) return;
                const allListeners = [
                    ...listeners ? listeners.values() : [],
                    ...wildcardListener ? wildcardListener.values() : []
                ];
                for (const handler of allListeners)handler(emittedEvent);
            },
            actionExecutor: (action)=>{
                const exec = ()=>{
                    this._actorScope.system._sendInspectionEvent({
                        type: '@xstate.action',
                        actorRef: this,
                        action: {
                            type: action.type,
                            params: action.params
                        }
                    });
                    if (!action.exec) return;
                    const saveExecutingCustomAction = $69ff85b27d828958$var$executingCustomAction;
                    try {
                        $69ff85b27d828958$var$executingCustomAction = true;
                        action.exec(action.info, action.params);
                    } finally{
                        $69ff85b27d828958$var$executingCustomAction = saveExecutingCustomAction;
                    }
                };
                if (this._processingStatus === $69ff85b27d828958$export$971d5caa766a69d7.Running) exec();
                else this._deferred.push(exec);
            }
        };
        // Ensure that the send method is bound to this Actor instance
        // if destructured
        this.send = this.send.bind(this);
        this.system._sendInspectionEvent({
            type: '@xstate.actor',
            actorRef: this
        });
        if (systemId) {
            this._systemId = systemId;
            this.system._set(systemId, this);
        }
        this._initState(options?.snapshot ?? options?.state);
        if (systemId && this._snapshot.status !== 'active') this.system._unregister(this);
    }
}
/**
 * Creates a new actor instance for the given actor logic with the provided
 * options, if any.
 *
 * @remarks
 * When you create an actor from actor logic via `createActor(logic)`, you
 * implicitly create an actor system where the created actor is the root actor.
 * Any actors spawned from this root actor and its descendants are part of that
 * actor system.
 * @example
 *
 * ```ts
 * import { createActor } from 'xstate';
 * import { someActorLogic } from './someActorLogic.ts';
 *
 * // Creating the actor, which implicitly creates an actor system with itself as the root actor
 * const actor = createActor(someActorLogic);
 *
 * actor.subscribe((snapshot) => {
 *   console.log(snapshot);
 * });
 *
 * // Actors must be started by calling `actor.start()`, which will also start the actor system.
 * actor.start();
 *
 * // Actors can receive events
 * actor.send({ type: 'someEvent' });
 *
 * // You can stop root actors by calling `actor.stop()`, which will also stop the actor system and all actors in that system.
 * actor.stop();
 * ```
 *
 * @param logic - The actor logic to create an actor from. For a state machine
 *   actor logic creator, see {@link createMachine}. Other actor logic creators
 *   include {@link fromCallback}, {@link fromEventObservable},
 *   {@link fromObservable}, {@link fromPromise}, and {@link fromTransition}.
 * @param options - Actor options
 */ function $69ff85b27d828958$export$ebd11618f299a286(logic, ...[options]) {
    return new $69ff85b27d828958$export$ef35774e6d314e91(logic, options);
}
/**
 * Creates a new Interpreter instance for the given machine with the provided
 * options, if any.
 *
 * @deprecated Use `createActor` instead
 * @alias
 */ const $69ff85b27d828958$export$e7094788287c5e9b = $69ff85b27d828958$export$ebd11618f299a286;
/**
 * @deprecated Use `Actor` instead.
 * @alias
 */ function $69ff85b27d828958$var$resolveCancel(_, snapshot, actionArgs, actionParams, { sendId: sendId }) {
    const resolvedSendId = typeof sendId === 'function' ? sendId(actionArgs, actionParams) : sendId;
    return [
        snapshot,
        {
            sendId: resolvedSendId
        },
        undefined
    ];
}
function $69ff85b27d828958$var$executeCancel(actorScope, params) {
    actorScope.defer(()=>{
        actorScope.system.scheduler.cancel(actorScope.self, params.sendId);
    });
}
/**
 * Cancels a delayed `sendTo(...)` action that is waiting to be executed. The
 * canceled `sendTo(...)` action will not send its event or execute, unless the
 * `delay` has already elapsed before `cancel(...)` is called.
 *
 * @example
 *
 * ```ts
 * import { createMachine, sendTo, cancel } from 'xstate';
 *
 * const machine = createMachine({
 *   // ...
 *   on: {
 *     sendEvent: {
 *       actions: sendTo(
 *         'some-actor',
 *         { type: 'someEvent' },
 *         {
 *           id: 'some-id',
 *           delay: 1000
 *         }
 *       )
 *     },
 *     cancelEvent: {
 *       actions: cancel('some-id')
 *     }
 *   }
 * });
 * ```
 *
 * @param sendId The `id` of the `sendTo(...)` action to cancel.
 */ function $69ff85b27d828958$export$3a1a48c8f6ef640e(sendId) {
    function cancel(_args, _params) {}
    cancel.type = 'xstate.cancel';
    cancel.sendId = sendId;
    cancel.resolve = $69ff85b27d828958$var$resolveCancel;
    cancel.execute = $69ff85b27d828958$var$executeCancel;
    return cancel;
}
function $69ff85b27d828958$var$resolveSpawn(actorScope, snapshot, actionArgs, _actionParams, { id: id, systemId: systemId, src: src, input: input, syncSnapshot: syncSnapshot }) {
    const logic = typeof src === 'string' ? $69ff85b27d828958$export$df995fae86a55f06(snapshot.machine, src) : src;
    const resolvedId = typeof id === 'function' ? id(actionArgs) : id;
    let actorRef;
    let resolvedInput = undefined;
    if (logic) {
        resolvedInput = typeof input === 'function' ? input({
            context: snapshot.context,
            event: actionArgs.event,
            self: actorScope.self
        }) : input;
        actorRef = $69ff85b27d828958$export$ebd11618f299a286(logic, {
            id: resolvedId,
            src: src,
            parent: actorScope.self,
            syncSnapshot: syncSnapshot,
            systemId: systemId,
            input: resolvedInput
        });
    }
    return [
        $69ff85b27d828958$export$3a6d5c9ae78a2c08(snapshot, {
            children: {
                ...snapshot.children,
                [resolvedId]: actorRef
            }
        }),
        {
            id: id,
            systemId: systemId,
            actorRef: actorRef,
            src: src,
            input: resolvedInput
        },
        undefined
    ];
}
function $69ff85b27d828958$var$executeSpawn(actorScope, { actorRef: actorRef }) {
    if (!actorRef) return;
    actorScope.defer(()=>{
        if (actorRef._processingStatus === $69ff85b27d828958$export$971d5caa766a69d7.Stopped) return;
        actorRef.start();
    });
}
function $69ff85b27d828958$export$56c0d5a1e737357d(...[src, { id: id, systemId: systemId, input: input, syncSnapshot: syncSnapshot = false } = {}]) {
    function spawnChild1(_args, _params) {}
    spawnChild1.type = 'xstate.spawnChild';
    spawnChild1.id = id;
    spawnChild1.systemId = systemId;
    spawnChild1.src = src;
    spawnChild1.input = input;
    spawnChild1.syncSnapshot = syncSnapshot;
    spawnChild1.resolve = $69ff85b27d828958$var$resolveSpawn;
    spawnChild1.execute = $69ff85b27d828958$var$executeSpawn;
    return spawnChild1;
}
function $69ff85b27d828958$var$resolveStop(_, snapshot, args, actionParams, { actorRef: actorRef }) {
    const actorRefOrString = typeof actorRef === 'function' ? actorRef(args, actionParams) : actorRef;
    const resolvedActorRef = typeof actorRefOrString === 'string' ? snapshot.children[actorRefOrString] : actorRefOrString;
    let children = snapshot.children;
    if (resolvedActorRef) {
        children = {
            ...children
        };
        delete children[resolvedActorRef.id];
    }
    return [
        $69ff85b27d828958$export$3a6d5c9ae78a2c08(snapshot, {
            children: children
        }),
        resolvedActorRef,
        undefined
    ];
}
function $69ff85b27d828958$var$executeStop(actorScope, actorRef) {
    if (!actorRef) return;
    // we need to eagerly unregister it here so a new actor with the same systemId can be registered immediately
    // since we defer actual stopping of the actor but we don't defer actor creations (and we can't do that)
    // this could throw on `systemId` collision, for example, when dealing with reentering transitions
    actorScope.system._unregister(actorRef);
    // this allows us to prevent an actor from being started if it gets stopped within the same macrostep
    // this can happen, for example, when the invoking state is being exited immediately by an always transition
    if (actorRef._processingStatus !== $69ff85b27d828958$export$971d5caa766a69d7.Running) {
        actorScope.stopChild(actorRef);
        return;
    }
    // stopping a child enqueues a stop event in the child actor's mailbox
    // we need for all of the already enqueued events to be processed before we stop the child
    // the parent itself might want to send some events to a child (for example from exit actions on the invoking state)
    // and we don't want to ignore those events
    actorScope.defer(()=>{
        actorScope.stopChild(actorRef);
    });
}
/**
 * Stops a child actor.
 *
 * @param actorRef The actor to stop.
 */ function $69ff85b27d828958$export$db202ddc8be9136(actorRef) {
    function stop(_args, _params) {}
    stop.type = 'xstate.stopChild';
    stop.actorRef = actorRef;
    stop.resolve = $69ff85b27d828958$var$resolveStop;
    stop.execute = $69ff85b27d828958$var$executeStop;
    return stop;
}
/**
 * Stops a child actor.
 *
 * @deprecated Use `stopChild(...)` instead
 * @alias
 */ const $69ff85b27d828958$export$3722cfe417b6ed86 = $69ff85b27d828958$export$db202ddc8be9136;
function $69ff85b27d828958$var$checkStateIn(snapshot, _, { stateValue: stateValue }) {
    if (typeof stateValue === 'string' && $69ff85b27d828958$export$efccba1c4a2ef57b(stateValue)) {
        const target = snapshot.machine.getStateNodeById(stateValue);
        return snapshot._nodes.some((sn)=>sn === target);
    }
    return snapshot.matches(stateValue);
}
function $69ff85b27d828958$export$2329c99376c9d0a4(stateValue) {
    function stateIn() {
        return false;
    }
    stateIn.check = $69ff85b27d828958$var$checkStateIn;
    stateIn.stateValue = stateValue;
    return stateIn;
}
function $69ff85b27d828958$var$checkNot(snapshot, { context: context, event: event }, { guards: guards }) {
    return !$69ff85b27d828958$export$f1e1789686576879(guards[0], context, event, snapshot);
}
/**
 * Higher-order guard that evaluates to `true` if the `guard` passed to it
 * evaluates to `false`.
 *
 * @category Guards
 * @example
 *
 * ```ts
 * import { setup, not } from 'xstate';
 *
 * const machine = setup({
 *   guards: {
 *     someNamedGuard: () => false
 *   }
 * }).createMachine({
 *   on: {
 *     someEvent: {
 *       guard: not('someNamedGuard'),
 *       actions: () => {
 *         // will be executed if guard in `not(...)`
 *         // evaluates to `false`
 *       }
 *     }
 *   }
 * });
 * ```
 *
 * @returns A guard
 */ function $69ff85b27d828958$export$a9c23c6ac3fc3eca(guard) {
    function not(_args, _params) {
        return false;
    }
    not.check = $69ff85b27d828958$var$checkNot;
    not.guards = [
        guard
    ];
    return not;
}
function $69ff85b27d828958$var$checkAnd(snapshot, { context: context, event: event }, { guards: guards }) {
    return guards.every((guard)=>$69ff85b27d828958$export$f1e1789686576879(guard, context, event, snapshot));
}
/**
 * Higher-order guard that evaluates to `true` if all `guards` passed to it
 * evaluate to `true`.
 *
 * @category Guards
 * @example
 *
 * ```ts
 * import { setup, and } from 'xstate';
 *
 * const machine = setup({
 *   guards: {
 *     someNamedGuard: () => true
 *   }
 * }).createMachine({
 *   on: {
 *     someEvent: {
 *       guard: and([({ context }) => context.value > 0, 'someNamedGuard']),
 *       actions: () => {
 *         // will be executed if all guards in `and(...)`
 *         // evaluate to true
 *       }
 *     }
 *   }
 * });
 * ```
 *
 * @returns A guard action object
 */ function $69ff85b27d828958$export$96f57966bedc81b4(guards) {
    function and(_args, _params) {
        return false;
    }
    and.check = $69ff85b27d828958$var$checkAnd;
    and.guards = guards;
    return and;
}
function $69ff85b27d828958$var$checkOr(snapshot, { context: context, event: event }, { guards: guards }) {
    return guards.some((guard)=>$69ff85b27d828958$export$f1e1789686576879(guard, context, event, snapshot));
}
/**
 * Higher-order guard that evaluates to `true` if any of the `guards` passed to
 * it evaluate to `true`.
 *
 * @category Guards
 * @example
 *
 * ```ts
 * import { setup, or } from 'xstate';
 *
 * const machine = setup({
 *   guards: {
 *     someNamedGuard: () => true
 *   }
 * }).createMachine({
 *   on: {
 *     someEvent: {
 *       guard: or([({ context }) => context.value > 0, 'someNamedGuard']),
 *       actions: () => {
 *         // will be executed if any of the guards in `or(...)`
 *         // evaluate to true
 *       }
 *     }
 *   }
 * });
 * ```
 *
 * @returns A guard action object
 */ function $69ff85b27d828958$export$d66501df72047452(guards) {
    function or(_args, _params) {
        return false;
    }
    or.check = $69ff85b27d828958$var$checkOr;
    or.guards = guards;
    return or;
}
// TODO: throw on cycles (depth check should be enough)
function $69ff85b27d828958$export$f1e1789686576879(guard, context, event, snapshot) {
    const { machine: machine } = snapshot;
    const isInline = typeof guard === 'function';
    const resolved = isInline ? guard : machine.implementations.guards[typeof guard === 'string' ? guard : guard.type];
    if (!isInline && !resolved) throw new Error(`Guard '${typeof guard === 'string' ? guard : guard.type}' is not implemented.'.`);
    if (typeof resolved !== 'function') return $69ff85b27d828958$export$f1e1789686576879(resolved, context, event, snapshot);
    const guardArgs = {
        context: context,
        event: event
    };
    const guardParams = isInline || typeof guard === 'string' ? undefined : 'params' in guard ? typeof guard.params === 'function' ? guard.params({
        context: context,
        event: event
    }) : guard.params : undefined;
    if (!('check' in resolved)) // the existing type of `.guards` assumes non-nullable `TExpressionGuard`
    // inline guards expect `TExpressionGuard` to be set to `undefined`
    // it's fine to cast this here, our logic makes sure that we call those 2 "variants" correctly
    return resolved(guardArgs, guardParams);
    const builtinGuard = resolved;
    return builtinGuard.check(snapshot, guardArgs, resolved // this holds all params
    );
}
const $69ff85b27d828958$var$isAtomicStateNode = (stateNode)=>stateNode.type === 'atomic' || stateNode.type === 'final';
function $69ff85b27d828958$var$getChildren(stateNode) {
    return Object.values(stateNode.states).filter((sn)=>sn.type !== 'history');
}
function $69ff85b27d828958$var$getProperAncestors(stateNode, toStateNode) {
    const ancestors = [];
    if (toStateNode === stateNode) return ancestors;
    // add all ancestors
    let m = stateNode.parent;
    while(m && m !== toStateNode){
        ancestors.push(m);
        m = m.parent;
    }
    return ancestors;
}
function $69ff85b27d828958$export$23f2a1d2818174ef(stateNodes) {
    const nodeSet = new Set(stateNodes);
    const adjList = $69ff85b27d828958$var$getAdjList(nodeSet);
    // add descendants
    for (const s of nodeSet)// if previously active, add existing child nodes
    if (s.type === 'compound' && (!adjList.get(s) || !adjList.get(s).length)) $69ff85b27d828958$var$getInitialStateNodesWithTheirAncestors(s).forEach((sn)=>nodeSet.add(sn));
    else {
        if (s.type === 'parallel') for (const child of $69ff85b27d828958$var$getChildren(s)){
            if (child.type === 'history') continue;
            if (!nodeSet.has(child)) {
                const initialStates = $69ff85b27d828958$var$getInitialStateNodesWithTheirAncestors(child);
                for (const initialStateNode of initialStates)nodeSet.add(initialStateNode);
            }
        }
    }
    // add all ancestors
    for (const s of nodeSet){
        let m = s.parent;
        while(m){
            nodeSet.add(m);
            m = m.parent;
        }
    }
    return nodeSet;
}
function $69ff85b27d828958$var$getValueFromAdj(baseNode, adjList) {
    const childStateNodes = adjList.get(baseNode);
    if (!childStateNodes) return {}; // todo: fix?
    if (baseNode.type === 'compound') {
        const childStateNode = childStateNodes[0];
        if (childStateNode) {
            if ($69ff85b27d828958$var$isAtomicStateNode(childStateNode)) return childStateNode.key;
        } else return {};
    }
    const stateValue = {};
    for (const childStateNode of childStateNodes)stateValue[childStateNode.key] = $69ff85b27d828958$var$getValueFromAdj(childStateNode, adjList);
    return stateValue;
}
function $69ff85b27d828958$var$getAdjList(stateNodes) {
    const adjList = new Map();
    for (const s of stateNodes){
        if (!adjList.has(s)) adjList.set(s, []);
        if (s.parent) {
            if (!adjList.has(s.parent)) adjList.set(s.parent, []);
            adjList.get(s.parent).push(s);
        }
    }
    return adjList;
}
function $69ff85b27d828958$var$getStateValue(rootNode, stateNodes) {
    const config = $69ff85b27d828958$export$23f2a1d2818174ef(stateNodes);
    return $69ff85b27d828958$var$getValueFromAdj(rootNode, $69ff85b27d828958$var$getAdjList(config));
}
function $69ff85b27d828958$export$882b5998b3b9117c(stateNodeSet, stateNode) {
    if (stateNode.type === 'compound') return $69ff85b27d828958$var$getChildren(stateNode).some((s)=>s.type === 'final' && stateNodeSet.has(s));
    if (stateNode.type === 'parallel') return $69ff85b27d828958$var$getChildren(stateNode).every((sn)=>$69ff85b27d828958$export$882b5998b3b9117c(stateNodeSet, sn));
    return stateNode.type === 'final';
}
const $69ff85b27d828958$export$efccba1c4a2ef57b = (str)=>str[0] === $69ff85b27d828958$var$STATE_IDENTIFIER;
function $69ff85b27d828958$export$dda1d9f60106f0e9(stateNode, receivedEventType) {
    const candidates = stateNode.transitions.get(receivedEventType) || [
        ...stateNode.transitions.keys()
    ].filter((eventDescriptor)=>{
        // check if transition is a wildcard transition,
        // which matches any non-transient events
        if (eventDescriptor === $69ff85b27d828958$var$WILDCARD) return true;
        if (!eventDescriptor.endsWith('.*')) return false;
        const partialEventTokens = eventDescriptor.split('.');
        const eventTokens = receivedEventType.split('.');
        for(let tokenIndex = 0; tokenIndex < partialEventTokens.length; tokenIndex++){
            const partialEventToken = partialEventTokens[tokenIndex];
            const eventToken = eventTokens[tokenIndex];
            if (partialEventToken === '*') {
                const isLastToken = tokenIndex === partialEventTokens.length - 1;
                return isLastToken;
            }
            if (partialEventToken !== eventToken) return false;
        }
        return true;
    }).sort((a, b)=>b.length - a.length).flatMap((key)=>stateNode.transitions.get(key));
    return candidates;
}
/** All delayed transitions from the config. */ function $69ff85b27d828958$export$39b482c5e57630a8(stateNode) {
    const afterConfig = stateNode.config.after;
    if (!afterConfig) return [];
    const mutateEntryExit = (delay)=>{
        const afterEvent = $69ff85b27d828958$var$createAfterEvent(delay, stateNode.id);
        const eventType = afterEvent.type;
        stateNode.entry.push($69ff85b27d828958$export$c4ce752e73470fba(afterEvent, {
            id: eventType,
            delay: delay
        }));
        stateNode.exit.push($69ff85b27d828958$export$3a1a48c8f6ef640e(eventType));
        return eventType;
    };
    const delayedTransitions = Object.keys(afterConfig).flatMap((delay)=>{
        const configTransition = afterConfig[delay];
        const resolvedTransition = typeof configTransition === 'string' ? {
            target: configTransition
        } : configTransition;
        const resolvedDelay = Number.isNaN(+delay) ? delay : +delay;
        const eventType = mutateEntryExit(resolvedDelay);
        return $69ff85b27d828958$export$625550452a3fa3ec(resolvedTransition).map((transition)=>({
                ...transition,
                event: eventType,
                delay: resolvedDelay
            }));
    });
    return delayedTransitions.map((delayedTransition)=>{
        const { delay: delay } = delayedTransition;
        return {
            ...$69ff85b27d828958$export$8b22cf2602fb60ce(stateNode, delayedTransition.event, delayedTransition),
            delay: delay
        };
    });
}
function $69ff85b27d828958$export$8b22cf2602fb60ce(stateNode, descriptor, transitionConfig) {
    const normalizedTarget = $69ff85b27d828958$var$normalizeTarget(transitionConfig.target);
    const reenter = transitionConfig.reenter ?? false;
    const target = $69ff85b27d828958$var$resolveTarget(stateNode, normalizedTarget);
    const transition = {
        ...transitionConfig,
        actions: $69ff85b27d828958$export$625550452a3fa3ec(transitionConfig.actions),
        guard: transitionConfig.guard,
        target: target,
        source: stateNode,
        reenter: reenter,
        eventType: descriptor,
        toJSON: ()=>({
                ...transition,
                source: `#${stateNode.id}`,
                target: target ? target.map((t)=>`#${t.id}`) : undefined
            })
    };
    return transition;
}
function $69ff85b27d828958$export$2d1720544b23b823(stateNode) {
    const transitions = new Map();
    if (stateNode.config.on) for (const descriptor of Object.keys(stateNode.config.on)){
        if (descriptor === $69ff85b27d828958$export$a07804094c3ecf2d) throw new Error('Null events ("") cannot be specified as a transition key. Use `always: { ... }` instead.');
        const transitionsConfig = stateNode.config.on[descriptor];
        transitions.set(descriptor, $69ff85b27d828958$export$407448d2b89b1813(transitionsConfig).map((t)=>$69ff85b27d828958$export$8b22cf2602fb60ce(stateNode, descriptor, t)));
    }
    if (stateNode.config.onDone) {
        const descriptor = `xstate.done.state.${stateNode.id}`;
        transitions.set(descriptor, $69ff85b27d828958$export$407448d2b89b1813(stateNode.config.onDone).map((t)=>$69ff85b27d828958$export$8b22cf2602fb60ce(stateNode, descriptor, t)));
    }
    for (const invokeDef of stateNode.invoke){
        if (invokeDef.onDone) {
            const descriptor = `xstate.done.actor.${invokeDef.id}`;
            transitions.set(descriptor, $69ff85b27d828958$export$407448d2b89b1813(invokeDef.onDone).map((t)=>$69ff85b27d828958$export$8b22cf2602fb60ce(stateNode, descriptor, t)));
        }
        if (invokeDef.onError) {
            const descriptor = `xstate.error.actor.${invokeDef.id}`;
            transitions.set(descriptor, $69ff85b27d828958$export$407448d2b89b1813(invokeDef.onError).map((t)=>$69ff85b27d828958$export$8b22cf2602fb60ce(stateNode, descriptor, t)));
        }
        if (invokeDef.onSnapshot) {
            const descriptor = `xstate.snapshot.${invokeDef.id}`;
            transitions.set(descriptor, $69ff85b27d828958$export$407448d2b89b1813(invokeDef.onSnapshot).map((t)=>$69ff85b27d828958$export$8b22cf2602fb60ce(stateNode, descriptor, t)));
        }
    }
    for (const delayedTransition of stateNode.after){
        let existing = transitions.get(delayedTransition.eventType);
        if (!existing) {
            existing = [];
            transitions.set(delayedTransition.eventType, existing);
        }
        existing.push(delayedTransition);
    }
    return transitions;
}
function $69ff85b27d828958$export$4368d992c4eafac0(stateNode, _target) {
    const resolvedTarget = typeof _target === 'string' ? stateNode.states[_target] : _target ? stateNode.states[_target.target] : undefined;
    if (!resolvedTarget && _target) throw new Error(// eslint-disable-next-line @typescript-eslint/restrict-template-expressions, @typescript-eslint/no-base-to-string
    `Initial state node "${_target}" not found on parent state node #${stateNode.id}`);
    const transition = {
        source: stateNode,
        actions: !_target || typeof _target === 'string' ? [] : $69ff85b27d828958$export$625550452a3fa3ec(_target.actions),
        eventType: null,
        reenter: false,
        target: resolvedTarget ? [
            resolvedTarget
        ] : [],
        toJSON: ()=>({
                ...transition,
                source: `#${stateNode.id}`,
                target: resolvedTarget ? [
                    `#${resolvedTarget.id}`
                ] : []
            })
    };
    return transition;
}
function $69ff85b27d828958$var$resolveTarget(stateNode, targets) {
    if (targets === undefined) // an undefined target signals that the state node should not transition from that state when receiving that event
    return undefined;
    return targets.map((target)=>{
        if (typeof target !== 'string') return target;
        if ($69ff85b27d828958$export$efccba1c4a2ef57b(target)) return stateNode.machine.getStateNodeById(target);
        const isInternalTarget = target[0] === $69ff85b27d828958$export$25ce5a424b770e84;
        // If internal target is defined on machine,
        // do not include machine key on target
        if (isInternalTarget && !stateNode.parent) return $69ff85b27d828958$export$d141bba7fdc215a3(stateNode, target.slice(1));
        const resolvedTarget = isInternalTarget ? stateNode.key + target : target;
        if (stateNode.parent) try {
            const targetStateNode = $69ff85b27d828958$export$d141bba7fdc215a3(stateNode.parent, resolvedTarget);
            return targetStateNode;
        } catch (err) {
            throw new Error(`Invalid transition definition for state node '${stateNode.id}':\n${err.message}`);
        }
        else throw new Error(`Invalid target: "${target}" is not a valid target from the root node. Did you mean ".${target}"?`);
    });
}
function $69ff85b27d828958$var$resolveHistoryDefaultTransition(stateNode) {
    const normalizedTarget = $69ff85b27d828958$var$normalizeTarget(stateNode.config.target);
    if (!normalizedTarget) return stateNode.parent.initial;
    return {
        target: normalizedTarget.map((t)=>typeof t === 'string' ? $69ff85b27d828958$export$d141bba7fdc215a3(stateNode.parent, t) : t)
    };
}
function $69ff85b27d828958$var$isHistoryNode(stateNode) {
    return stateNode.type === 'history';
}
function $69ff85b27d828958$var$getInitialStateNodesWithTheirAncestors(stateNode) {
    const states = $69ff85b27d828958$export$3b14a55fb2447963(stateNode);
    for (const initialState of states)for (const ancestor of $69ff85b27d828958$var$getProperAncestors(initialState, stateNode))states.add(ancestor);
    return states;
}
function $69ff85b27d828958$export$3b14a55fb2447963(stateNode) {
    const set = new Set();
    function iter(descStateNode) {
        if (set.has(descStateNode)) return;
        set.add(descStateNode);
        if (descStateNode.type === 'compound') iter(descStateNode.initial.target[0]);
        else if (descStateNode.type === 'parallel') for (const child of $69ff85b27d828958$var$getChildren(descStateNode))iter(child);
    }
    iter(stateNode);
    return set;
}
/** Returns the child state node from its relative `stateKey`, or throws. */ function $69ff85b27d828958$var$getStateNode(stateNode, stateKey) {
    if ($69ff85b27d828958$export$efccba1c4a2ef57b(stateKey)) return stateNode.machine.getStateNodeById(stateKey);
    if (!stateNode.states) throw new Error(`Unable to retrieve child state '${stateKey}' from '${stateNode.id}'; no child states exist.`);
    const result = stateNode.states[stateKey];
    if (!result) throw new Error(`Child state '${stateKey}' does not exist on '${stateNode.id}'`);
    return result;
}
/**
 * Returns the relative state node from the given `statePath`, or throws.
 *
 * @param statePath The string or string array relative path to the state node.
 */ function $69ff85b27d828958$export$d141bba7fdc215a3(stateNode, statePath) {
    if (typeof statePath === 'string' && $69ff85b27d828958$export$efccba1c4a2ef57b(statePath)) try {
        return stateNode.machine.getStateNodeById(statePath);
    } catch  {
    // try individual paths
    // throw e;
    }
    const arrayStatePath = $69ff85b27d828958$export$90a7f3efeed30595(statePath).slice();
    let currentStateNode = stateNode;
    while(arrayStatePath.length){
        const key = arrayStatePath.shift();
        if (!key.length) break;
        currentStateNode = $69ff85b27d828958$var$getStateNode(currentStateNode, key);
    }
    return currentStateNode;
}
/**
 * Returns the state nodes represented by the current state value.
 *
 * @param stateValue The state value or State instance
 */ function $69ff85b27d828958$export$35e795649ee09318(stateNode, stateValue) {
    if (typeof stateValue === 'string') {
        const childStateNode = stateNode.states[stateValue];
        if (!childStateNode) throw new Error(`State '${stateValue}' does not exist on '${stateNode.id}'`);
        return [
            stateNode,
            childStateNode
        ];
    }
    const childStateKeys = Object.keys(stateValue);
    const childStateNodes = childStateKeys.map((subStateKey)=>$69ff85b27d828958$var$getStateNode(stateNode, subStateKey)).filter(Boolean);
    return [
        stateNode.machine.root,
        stateNode
    ].concat(childStateNodes, childStateKeys.reduce((allSubStateNodes, subStateKey)=>{
        const subStateNode = $69ff85b27d828958$var$getStateNode(stateNode, subStateKey);
        if (!subStateNode) return allSubStateNodes;
        const subStateNodes = $69ff85b27d828958$export$35e795649ee09318(subStateNode, stateValue[subStateKey]);
        return allSubStateNodes.concat(subStateNodes);
    }, []));
}
function $69ff85b27d828958$var$transitionAtomicNode(stateNode, stateValue, snapshot, event) {
    const childStateNode = $69ff85b27d828958$var$getStateNode(stateNode, stateValue);
    const next = childStateNode.next(snapshot, event);
    if (!next || !next.length) return stateNode.next(snapshot, event);
    return next;
}
function $69ff85b27d828958$var$transitionCompoundNode(stateNode, stateValue, snapshot, event) {
    const subStateKeys = Object.keys(stateValue);
    const childStateNode = $69ff85b27d828958$var$getStateNode(stateNode, subStateKeys[0]);
    const next = $69ff85b27d828958$export$ae1af26003f05816(childStateNode, stateValue[subStateKeys[0]], snapshot, event);
    if (!next || !next.length) return stateNode.next(snapshot, event);
    return next;
}
function $69ff85b27d828958$var$transitionParallelNode(stateNode, stateValue, snapshot, event) {
    const allInnerTransitions = [];
    for (const subStateKey of Object.keys(stateValue)){
        const subStateValue = stateValue[subStateKey];
        if (!subStateValue) continue;
        const subStateNode = $69ff85b27d828958$var$getStateNode(stateNode, subStateKey);
        const innerTransitions = $69ff85b27d828958$export$ae1af26003f05816(subStateNode, subStateValue, snapshot, event);
        if (innerTransitions) allInnerTransitions.push(...innerTransitions);
    }
    if (!allInnerTransitions.length) return stateNode.next(snapshot, event);
    return allInnerTransitions;
}
function $69ff85b27d828958$export$ae1af26003f05816(stateNode, stateValue, snapshot, event) {
    // leaf node
    if (typeof stateValue === 'string') return $69ff85b27d828958$var$transitionAtomicNode(stateNode, stateValue, snapshot, event);
    // compound node
    if (Object.keys(stateValue).length === 1) return $69ff85b27d828958$var$transitionCompoundNode(stateNode, stateValue, snapshot, event);
    // parallel node
    return $69ff85b27d828958$var$transitionParallelNode(stateNode, stateValue, snapshot, event);
}
function $69ff85b27d828958$var$getHistoryNodes(stateNode) {
    return Object.keys(stateNode.states).map((key)=>stateNode.states[key]).filter((sn)=>sn.type === 'history');
}
function $69ff85b27d828958$var$isDescendant(childStateNode, parentStateNode) {
    let marker = childStateNode;
    while(marker.parent && marker.parent !== parentStateNode)marker = marker.parent;
    return marker.parent === parentStateNode;
}
function $69ff85b27d828958$var$hasIntersection(s1, s2) {
    const set1 = new Set(s1);
    const set2 = new Set(s2);
    for (const item of set1){
        if (set2.has(item)) return true;
    }
    for (const item of set2){
        if (set1.has(item)) return true;
    }
    return false;
}
function $69ff85b27d828958$var$removeConflictingTransitions(enabledTransitions, stateNodeSet, historyValue) {
    const filteredTransitions = new Set();
    for (const t1 of enabledTransitions){
        let t1Preempted = false;
        const transitionsToRemove = new Set();
        for (const t2 of filteredTransitions)if ($69ff85b27d828958$var$hasIntersection($69ff85b27d828958$var$computeExitSet([
            t1
        ], stateNodeSet, historyValue), $69ff85b27d828958$var$computeExitSet([
            t2
        ], stateNodeSet, historyValue))) {
            if ($69ff85b27d828958$var$isDescendant(t1.source, t2.source)) transitionsToRemove.add(t2);
            else {
                t1Preempted = true;
                break;
            }
        }
        if (!t1Preempted) {
            for (const t3 of transitionsToRemove)filteredTransitions.delete(t3);
            filteredTransitions.add(t1);
        }
    }
    return Array.from(filteredTransitions);
}
function $69ff85b27d828958$var$findLeastCommonAncestor(stateNodes) {
    const [head, ...tail] = stateNodes;
    for (const ancestor of $69ff85b27d828958$var$getProperAncestors(head, undefined)){
        if (tail.every((sn)=>$69ff85b27d828958$var$isDescendant(sn, ancestor))) return ancestor;
    }
}
function $69ff85b27d828958$var$getEffectiveTargetStates(transition, historyValue) {
    if (!transition.target) return [];
    const targets = new Set();
    for (const targetNode of transition.target)if ($69ff85b27d828958$var$isHistoryNode(targetNode)) {
        if (historyValue[targetNode.id]) for (const node of historyValue[targetNode.id])targets.add(node);
        else for (const node of $69ff85b27d828958$var$getEffectiveTargetStates($69ff85b27d828958$var$resolveHistoryDefaultTransition(targetNode), historyValue))targets.add(node);
    } else targets.add(targetNode);
    return [
        ...targets
    ];
}
function $69ff85b27d828958$var$getTransitionDomain(transition, historyValue) {
    const targetStates = $69ff85b27d828958$var$getEffectiveTargetStates(transition, historyValue);
    if (!targetStates) return;
    if (!transition.reenter && targetStates.every((target)=>target === transition.source || $69ff85b27d828958$var$isDescendant(target, transition.source))) return transition.source;
    const lca = $69ff85b27d828958$var$findLeastCommonAncestor(targetStates.concat(transition.source));
    if (lca) return lca;
    // at this point we know that it's a root transition since LCA couldn't be found
    if (transition.reenter) return;
    return transition.source.machine.root;
}
function $69ff85b27d828958$var$computeExitSet(transitions, stateNodeSet, historyValue) {
    const statesToExit = new Set();
    for (const t of transitions)if (t.target?.length) {
        const domain = $69ff85b27d828958$var$getTransitionDomain(t, historyValue);
        if (t.reenter && t.source === domain) statesToExit.add(domain);
        for (const stateNode of stateNodeSet)if ($69ff85b27d828958$var$isDescendant(stateNode, domain)) statesToExit.add(stateNode);
    }
    return [
        ...statesToExit
    ];
}
function $69ff85b27d828958$var$areStateNodeCollectionsEqual(prevStateNodes, nextStateNodeSet) {
    if (prevStateNodes.length !== nextStateNodeSet.size) return false;
    for (const node of prevStateNodes){
        if (!nextStateNodeSet.has(node)) return false;
    }
    return true;
}
/** https://www.w3.org/TR/scxml/#microstepProcedure */ function $69ff85b27d828958$export$2408f22a0fab9ae5(transitions, currentSnapshot, actorScope, event, isInitial, internalQueue) {
    if (!transitions.length) return currentSnapshot;
    const mutStateNodeSet = new Set(currentSnapshot._nodes);
    let historyValue = currentSnapshot.historyValue;
    const filteredTransitions = $69ff85b27d828958$var$removeConflictingTransitions(transitions, mutStateNodeSet, historyValue);
    let nextState = currentSnapshot;
    // Exit states
    if (!isInitial) [nextState, historyValue] = $69ff85b27d828958$var$exitStates(nextState, event, actorScope, filteredTransitions, mutStateNodeSet, historyValue, internalQueue, actorScope.actionExecutor);
    // Execute transition content
    nextState = $69ff85b27d828958$export$ffb5f4729a158638(nextState, event, actorScope, filteredTransitions.flatMap((t)=>t.actions), internalQueue, undefined);
    // Enter states
    nextState = $69ff85b27d828958$var$enterStates(nextState, event, actorScope, filteredTransitions, mutStateNodeSet, internalQueue, historyValue, isInitial);
    const nextStateNodes = [
        ...mutStateNodeSet
    ];
    if (nextState.status === 'done') nextState = $69ff85b27d828958$export$ffb5f4729a158638(nextState, event, actorScope, nextStateNodes.sort((a, b)=>b.order - a.order).flatMap((state)=>state.exit), internalQueue, undefined);
    // eslint-disable-next-line no-useless-catch
    try {
        if (historyValue === currentSnapshot.historyValue && $69ff85b27d828958$var$areStateNodeCollectionsEqual(currentSnapshot._nodes, mutStateNodeSet)) return nextState;
        return $69ff85b27d828958$export$3a6d5c9ae78a2c08(nextState, {
            _nodes: nextStateNodes,
            historyValue: historyValue
        });
    } catch (e) {
        // TODO: Refactor this once proper error handling is implemented.
        // See https://github.com/statelyai/rfcs/pull/4
        throw e;
    }
}
function $69ff85b27d828958$var$getMachineOutput(snapshot, event, actorScope, rootNode, rootCompletionNode) {
    if (rootNode.output === undefined) return;
    const doneStateEvent = $69ff85b27d828958$var$createDoneStateEvent(rootCompletionNode.id, rootCompletionNode.output !== undefined && rootCompletionNode.parent ? $69ff85b27d828958$var$resolveOutput(rootCompletionNode.output, snapshot.context, event, actorScope.self) : undefined);
    return $69ff85b27d828958$var$resolveOutput(rootNode.output, snapshot.context, doneStateEvent, actorScope.self);
}
function $69ff85b27d828958$var$enterStates(currentSnapshot, event, actorScope, filteredTransitions, mutStateNodeSet, internalQueue, historyValue, isInitial) {
    let nextSnapshot = currentSnapshot;
    const statesToEnter = new Set();
    // those are states that were directly targeted or indirectly targeted by the explicit target
    // in other words, those are states for which initial actions should be executed
    // when we target `#deep_child` initial actions of its ancestors shouldn't be executed
    const statesForDefaultEntry = new Set();
    $69ff85b27d828958$var$computeEntrySet(filteredTransitions, historyValue, statesForDefaultEntry, statesToEnter);
    // In the initial state, the root state node is "entered".
    if (isInitial) statesForDefaultEntry.add(currentSnapshot.machine.root);
    const completedNodes = new Set();
    for (const stateNodeToEnter of [
        ...statesToEnter
    ].sort((a, b)=>a.order - b.order)){
        mutStateNodeSet.add(stateNodeToEnter);
        const actions = [];
        // Add entry actions
        actions.push(...stateNodeToEnter.entry);
        for (const invokeDef of stateNodeToEnter.invoke)actions.push($69ff85b27d828958$export$56c0d5a1e737357d(invokeDef.src, {
            ...invokeDef,
            syncSnapshot: !!invokeDef.onSnapshot
        }));
        if (statesForDefaultEntry.has(stateNodeToEnter)) {
            const initialActions = stateNodeToEnter.initial.actions;
            actions.push(...initialActions);
        }
        nextSnapshot = $69ff85b27d828958$export$ffb5f4729a158638(nextSnapshot, event, actorScope, actions, internalQueue, stateNodeToEnter.invoke.map((invokeDef)=>invokeDef.id));
        if (stateNodeToEnter.type === 'final') {
            const parent = stateNodeToEnter.parent;
            let ancestorMarker = parent?.type === 'parallel' ? parent : parent?.parent;
            let rootCompletionNode = ancestorMarker || stateNodeToEnter;
            if (parent?.type === 'compound') internalQueue.push($69ff85b27d828958$var$createDoneStateEvent(parent.id, stateNodeToEnter.output !== undefined ? $69ff85b27d828958$var$resolveOutput(stateNodeToEnter.output, nextSnapshot.context, event, actorScope.self) : undefined));
            while(ancestorMarker?.type === 'parallel' && !completedNodes.has(ancestorMarker) && $69ff85b27d828958$export$882b5998b3b9117c(mutStateNodeSet, ancestorMarker)){
                completedNodes.add(ancestorMarker);
                internalQueue.push($69ff85b27d828958$var$createDoneStateEvent(ancestorMarker.id));
                rootCompletionNode = ancestorMarker;
                ancestorMarker = ancestorMarker.parent;
            }
            if (ancestorMarker) continue;
            nextSnapshot = $69ff85b27d828958$export$3a6d5c9ae78a2c08(nextSnapshot, {
                status: 'done',
                output: $69ff85b27d828958$var$getMachineOutput(nextSnapshot, event, actorScope, nextSnapshot.machine.root, rootCompletionNode)
            });
        }
    }
    return nextSnapshot;
}
function $69ff85b27d828958$var$computeEntrySet(transitions, historyValue, statesForDefaultEntry, statesToEnter) {
    for (const t of transitions){
        const domain = $69ff85b27d828958$var$getTransitionDomain(t, historyValue);
        for (const s of t.target || []){
            if (!$69ff85b27d828958$var$isHistoryNode(s) && // if the target is different than the source then it will *definitely* be entered
            (t.source !== s || // we know that the domain can't lie within the source
            // if it's different than the source then it's outside of it and it means that the target has to be entered as well
            t.source !== domain || // reentering transitions always enter the target, even if it's the source itself
            t.reenter)) {
                statesToEnter.add(s);
                statesForDefaultEntry.add(s);
            }
            $69ff85b27d828958$var$addDescendantStatesToEnter(s, historyValue, statesForDefaultEntry, statesToEnter);
        }
        const targetStates = $69ff85b27d828958$var$getEffectiveTargetStates(t, historyValue);
        for (const s of targetStates){
            const ancestors = $69ff85b27d828958$var$getProperAncestors(s, domain);
            if (domain?.type === 'parallel') ancestors.push(domain);
            $69ff85b27d828958$var$addAncestorStatesToEnter(statesToEnter, historyValue, statesForDefaultEntry, ancestors, !t.source.parent && t.reenter ? undefined : domain);
        }
    }
}
function $69ff85b27d828958$var$addDescendantStatesToEnter(stateNode, historyValue, statesForDefaultEntry, statesToEnter) {
    if ($69ff85b27d828958$var$isHistoryNode(stateNode)) {
        if (historyValue[stateNode.id]) {
            const historyStateNodes = historyValue[stateNode.id];
            for (const s of historyStateNodes){
                statesToEnter.add(s);
                $69ff85b27d828958$var$addDescendantStatesToEnter(s, historyValue, statesForDefaultEntry, statesToEnter);
            }
            for (const s of historyStateNodes)$69ff85b27d828958$var$addProperAncestorStatesToEnter(s, stateNode.parent, statesToEnter, historyValue, statesForDefaultEntry);
        } else {
            const historyDefaultTransition = $69ff85b27d828958$var$resolveHistoryDefaultTransition(stateNode);
            for (const s of historyDefaultTransition.target){
                statesToEnter.add(s);
                if (historyDefaultTransition === stateNode.parent?.initial) statesForDefaultEntry.add(stateNode.parent);
                $69ff85b27d828958$var$addDescendantStatesToEnter(s, historyValue, statesForDefaultEntry, statesToEnter);
            }
            for (const s of historyDefaultTransition.target)$69ff85b27d828958$var$addProperAncestorStatesToEnter(s, stateNode.parent, statesToEnter, historyValue, statesForDefaultEntry);
        }
    } else {
        if (stateNode.type === 'compound') {
            const [initialState] = stateNode.initial.target;
            if (!$69ff85b27d828958$var$isHistoryNode(initialState)) {
                statesToEnter.add(initialState);
                statesForDefaultEntry.add(initialState);
            }
            $69ff85b27d828958$var$addDescendantStatesToEnter(initialState, historyValue, statesForDefaultEntry, statesToEnter);
            $69ff85b27d828958$var$addProperAncestorStatesToEnter(initialState, stateNode, statesToEnter, historyValue, statesForDefaultEntry);
        } else if (stateNode.type === 'parallel') {
            for (const child of $69ff85b27d828958$var$getChildren(stateNode).filter((sn)=>!$69ff85b27d828958$var$isHistoryNode(sn)))if (![
                ...statesToEnter
            ].some((s)=>$69ff85b27d828958$var$isDescendant(s, child))) {
                if (!$69ff85b27d828958$var$isHistoryNode(child)) {
                    statesToEnter.add(child);
                    statesForDefaultEntry.add(child);
                }
                $69ff85b27d828958$var$addDescendantStatesToEnter(child, historyValue, statesForDefaultEntry, statesToEnter);
            }
        }
    }
}
function $69ff85b27d828958$var$addAncestorStatesToEnter(statesToEnter, historyValue, statesForDefaultEntry, ancestors, reentrancyDomain) {
    for (const anc of ancestors){
        if (!reentrancyDomain || $69ff85b27d828958$var$isDescendant(anc, reentrancyDomain)) statesToEnter.add(anc);
        if (anc.type === 'parallel') {
            for (const child of $69ff85b27d828958$var$getChildren(anc).filter((sn)=>!$69ff85b27d828958$var$isHistoryNode(sn)))if (![
                ...statesToEnter
            ].some((s)=>$69ff85b27d828958$var$isDescendant(s, child))) {
                statesToEnter.add(child);
                $69ff85b27d828958$var$addDescendantStatesToEnter(child, historyValue, statesForDefaultEntry, statesToEnter);
            }
        }
    }
}
function $69ff85b27d828958$var$addProperAncestorStatesToEnter(stateNode, toStateNode, statesToEnter, historyValue, statesForDefaultEntry) {
    $69ff85b27d828958$var$addAncestorStatesToEnter(statesToEnter, historyValue, statesForDefaultEntry, $69ff85b27d828958$var$getProperAncestors(stateNode, toStateNode));
}
function $69ff85b27d828958$var$exitStates(currentSnapshot, event, actorScope, transitions, mutStateNodeSet, historyValue, internalQueue, _actionExecutor) {
    let nextSnapshot = currentSnapshot;
    const statesToExit = $69ff85b27d828958$var$computeExitSet(transitions, mutStateNodeSet, historyValue);
    statesToExit.sort((a, b)=>b.order - a.order);
    let changedHistory;
    // From SCXML algorithm: https://www.w3.org/TR/scxml/#exitStates
    for (const exitStateNode of statesToExit)for (const historyNode of $69ff85b27d828958$var$getHistoryNodes(exitStateNode)){
        let predicate;
        if (historyNode.history === 'deep') predicate = (sn)=>$69ff85b27d828958$var$isAtomicStateNode(sn) && $69ff85b27d828958$var$isDescendant(sn, exitStateNode);
        else predicate = (sn)=>{
            return sn.parent === exitStateNode;
        };
        changedHistory ?? (changedHistory = {
            ...historyValue
        });
        changedHistory[historyNode.id] = Array.from(mutStateNodeSet).filter(predicate);
    }
    for (const s of statesToExit){
        nextSnapshot = $69ff85b27d828958$export$ffb5f4729a158638(nextSnapshot, event, actorScope, [
            ...s.exit,
            ...s.invoke.map((def)=>$69ff85b27d828958$export$db202ddc8be9136(def.id))
        ], internalQueue, undefined);
        mutStateNodeSet.delete(s);
    }
    return [
        nextSnapshot,
        changedHistory || historyValue
    ];
}
function $69ff85b27d828958$var$getAction(machine, actionType) {
    return machine.implementations.actions[actionType];
}
function $69ff85b27d828958$var$resolveAndExecuteActionsWithContext(currentSnapshot, event, actorScope, actions, extra, retries) {
    const { machine: machine } = currentSnapshot;
    let intermediateSnapshot = currentSnapshot;
    for (const action of actions){
        const isInline = typeof action === 'function';
        const resolvedAction = isInline ? action : // the existing type of `.actions` assumes non-nullable `TExpressionAction`
        // it's fine to cast this here to get a common type and lack of errors in the rest of the code
        // our logic below makes sure that we call those 2 "variants" correctly
        $69ff85b27d828958$var$getAction(machine, typeof action === 'string' ? action : action.type);
        const actionArgs = {
            context: intermediateSnapshot.context,
            event: event,
            self: actorScope.self,
            system: actorScope.system
        };
        const actionParams = isInline || typeof action === 'string' ? undefined : 'params' in action ? typeof action.params === 'function' ? action.params({
            context: intermediateSnapshot.context,
            event: event
        }) : action.params : undefined;
        if (!resolvedAction || !('resolve' in resolvedAction)) {
            actorScope.actionExecutor({
                type: typeof action === 'string' ? action : typeof action === 'object' ? action.type : action.name || '(anonymous)',
                info: actionArgs,
                params: actionParams,
                exec: resolvedAction
            });
            continue;
        }
        const builtinAction = resolvedAction;
        const [nextState, params, actions] = builtinAction.resolve(actorScope, intermediateSnapshot, actionArgs, actionParams, resolvedAction, // this holds all params
        extra);
        intermediateSnapshot = nextState;
        if ('retryResolve' in builtinAction) retries?.push([
            builtinAction,
            params
        ]);
        if ('execute' in builtinAction) actorScope.actionExecutor({
            type: builtinAction.type,
            info: actionArgs,
            params: params,
            exec: builtinAction.execute.bind(null, actorScope, params)
        });
        if (actions) intermediateSnapshot = $69ff85b27d828958$var$resolveAndExecuteActionsWithContext(intermediateSnapshot, event, actorScope, actions, extra, retries);
    }
    return intermediateSnapshot;
}
function $69ff85b27d828958$export$ffb5f4729a158638(currentSnapshot, event, actorScope, actions, internalQueue, deferredActorIds) {
    const retries = deferredActorIds ? [] : undefined;
    const nextState = $69ff85b27d828958$var$resolveAndExecuteActionsWithContext(currentSnapshot, event, actorScope, actions, {
        internalQueue: internalQueue,
        deferredActorIds: deferredActorIds
    }, retries);
    retries?.forEach(([builtinAction, params])=>{
        builtinAction.retryResolve(actorScope, nextState, params);
    });
    return nextState;
}
function $69ff85b27d828958$export$7ccc53e8f1e7dfc5(snapshot, event, actorScope, internalQueue) {
    let nextSnapshot = snapshot;
    const microstates = [];
    function addMicrostate(microstate, event, transitions) {
        actorScope.system._sendInspectionEvent({
            type: '@xstate.microstep',
            actorRef: actorScope.self,
            event: event,
            snapshot: microstate,
            _transitions: transitions
        });
        microstates.push(microstate);
    }
    // Handle stop event
    if (event.type === $69ff85b27d828958$export$78acf4525d8a74c4) {
        nextSnapshot = $69ff85b27d828958$export$3a6d5c9ae78a2c08($69ff85b27d828958$var$stopChildren(nextSnapshot, event, actorScope), {
            status: 'stopped'
        });
        addMicrostate(nextSnapshot, event, []);
        return {
            snapshot: nextSnapshot,
            microstates: microstates
        };
    }
    let nextEvent = event;
    // Assume the state is at rest (no raised events)
    // Determine the next state based on the next microstep
    if (nextEvent.type !== $69ff85b27d828958$var$XSTATE_INIT) {
        const currentEvent = nextEvent;
        const isErr = $69ff85b27d828958$var$isErrorActorEvent(currentEvent);
        const transitions = $69ff85b27d828958$var$selectTransitions(currentEvent, nextSnapshot);
        if (isErr && !transitions.length) {
            // TODO: we should likely only allow transitions selected by very explicit descriptors
            // `*` shouldn't be matched, likely `xstate.error.*` shouldnt be either
            // similarly `xstate.error.actor.*` and `xstate.error.actor.todo.*` have to be considered too
            nextSnapshot = $69ff85b27d828958$export$3a6d5c9ae78a2c08(snapshot, {
                status: 'error',
                error: currentEvent.error
            });
            addMicrostate(nextSnapshot, currentEvent, []);
            return {
                snapshot: nextSnapshot,
                microstates: microstates
            };
        }
        nextSnapshot = $69ff85b27d828958$export$2408f22a0fab9ae5(transitions, snapshot, actorScope, nextEvent, false, // isInitial
        internalQueue);
        addMicrostate(nextSnapshot, currentEvent, transitions);
    }
    let shouldSelectEventlessTransitions = true;
    while(nextSnapshot.status === 'active'){
        let enabledTransitions = shouldSelectEventlessTransitions ? $69ff85b27d828958$var$selectEventlessTransitions(nextSnapshot, nextEvent) : [];
        // eventless transitions should always be selected after selecting *regular* transitions
        // by assigning `undefined` to `previousState` we ensure that `shouldSelectEventlessTransitions` gets always computed to true in such a case
        const previousState = enabledTransitions.length ? nextSnapshot : undefined;
        if (!enabledTransitions.length) {
            if (!internalQueue.length) break;
            nextEvent = internalQueue.shift();
            enabledTransitions = $69ff85b27d828958$var$selectTransitions(nextEvent, nextSnapshot);
        }
        nextSnapshot = $69ff85b27d828958$export$2408f22a0fab9ae5(enabledTransitions, nextSnapshot, actorScope, nextEvent, false, internalQueue);
        shouldSelectEventlessTransitions = nextSnapshot !== previousState;
        addMicrostate(nextSnapshot, nextEvent, enabledTransitions);
    }
    if (nextSnapshot.status !== 'active') $69ff85b27d828958$var$stopChildren(nextSnapshot, nextEvent, actorScope);
    return {
        snapshot: nextSnapshot,
        microstates: microstates
    };
}
function $69ff85b27d828958$var$stopChildren(nextState, event, actorScope) {
    return $69ff85b27d828958$export$ffb5f4729a158638(nextState, event, actorScope, Object.values(nextState.children).map((child)=>$69ff85b27d828958$export$db202ddc8be9136(child)), [], undefined);
}
function $69ff85b27d828958$var$selectTransitions(event, nextState) {
    return nextState.machine.getTransitionData(nextState, event);
}
function $69ff85b27d828958$var$selectEventlessTransitions(nextState, event) {
    const enabledTransitionSet = new Set();
    const atomicStates = nextState._nodes.filter($69ff85b27d828958$var$isAtomicStateNode);
    for (const stateNode of atomicStates)loop: for (const s of [
        stateNode
    ].concat($69ff85b27d828958$var$getProperAncestors(stateNode, undefined))){
        if (!s.always) continue;
        for (const transition of s.always)if (transition.guard === undefined || $69ff85b27d828958$export$f1e1789686576879(transition.guard, nextState.context, event, nextState)) {
            enabledTransitionSet.add(transition);
            break loop;
        }
    }
    return $69ff85b27d828958$var$removeConflictingTransitions(Array.from(enabledTransitionSet), new Set(nextState._nodes), nextState.historyValue);
}
/**
 * Resolves a partial state value with its full representation in the state
 * node's machine.
 *
 * @param stateValue The partial state value to resolve.
 */ function $69ff85b27d828958$export$43caf9889c228507(rootNode, stateValue) {
    const allStateNodes = $69ff85b27d828958$export$23f2a1d2818174ef($69ff85b27d828958$export$35e795649ee09318(rootNode, stateValue));
    return $69ff85b27d828958$var$getStateValue(rootNode, [
        ...allStateNodes
    ]);
}
function $69ff85b27d828958$export$7f8ddf7c7c20b3cd(value) {
    return !!value && typeof value === 'object' && 'machine' in value && 'value' in value;
}
const $69ff85b27d828958$var$machineSnapshotMatches = function matches(testValue) {
    return $69ff85b27d828958$export$b4171a6734a65d42(testValue, this.value);
};
const $69ff85b27d828958$var$machineSnapshotHasTag = function hasTag(tag) {
    return this.tags.has(tag);
};
const $69ff85b27d828958$var$machineSnapshotCan = function can(event) {
    const transitionData = this.machine.getTransitionData(this, event);
    return !!transitionData?.length && // Check that at least one transition is not forbidden
    transitionData.some((t)=>t.target !== undefined || t.actions.length);
};
const $69ff85b27d828958$var$machineSnapshotToJSON = function toJSON() {
    const { _nodes: nodes, tags: tags, machine: machine, getMeta: getMeta, toJSON: toJSON, can: can, hasTag: hasTag, matches: matches, ...jsonValues } = this;
    return {
        ...jsonValues,
        tags: Array.from(tags)
    };
};
const $69ff85b27d828958$var$machineSnapshotGetMeta = function getMeta() {
    return this._nodes.reduce((acc, stateNode)=>{
        if (stateNode.meta !== undefined) acc[stateNode.id] = stateNode.meta;
        return acc;
    }, {});
};
function $69ff85b27d828958$export$342063e11d6c3cad(config, machine) {
    return {
        status: config.status,
        output: config.output,
        error: config.error,
        machine: machine,
        context: config.context,
        _nodes: config._nodes,
        value: $69ff85b27d828958$var$getStateValue(machine.root, config._nodes),
        tags: new Set(config._nodes.flatMap((sn)=>sn.tags)),
        children: config.children,
        historyValue: config.historyValue || {},
        matches: $69ff85b27d828958$var$machineSnapshotMatches,
        hasTag: $69ff85b27d828958$var$machineSnapshotHasTag,
        can: $69ff85b27d828958$var$machineSnapshotCan,
        getMeta: $69ff85b27d828958$var$machineSnapshotGetMeta,
        toJSON: $69ff85b27d828958$var$machineSnapshotToJSON
    };
}
function $69ff85b27d828958$export$3a6d5c9ae78a2c08(snapshot, config = {}) {
    return $69ff85b27d828958$export$342063e11d6c3cad({
        ...snapshot,
        ...config
    }, snapshot.machine);
}
function $69ff85b27d828958$export$4a5767248b18ef41(snapshot, options) {
    const { _nodes: nodes, tags: tags, machine: machine, children: children, context: context, can: can, hasTag: hasTag, matches: matches, getMeta: getMeta, toJSON: toJSON, ...jsonValues } = snapshot;
    const childrenJson = {};
    for(const id in children){
        const child = children[id];
        childrenJson[id] = {
            snapshot: child.getPersistedSnapshot(options),
            src: child.src,
            systemId: child._systemId,
            syncSnapshot: child._syncSnapshot
        };
    }
    const persisted = {
        ...jsonValues,
        context: $69ff85b27d828958$var$persistContext(context),
        children: childrenJson
    };
    return persisted;
}
function $69ff85b27d828958$var$persistContext(contextPart) {
    let copy;
    for(const key in contextPart){
        const value = contextPart[key];
        if (value && typeof value === 'object') {
            if ('sessionId' in value && 'send' in value && 'ref' in value) {
                copy ?? (copy = Array.isArray(contextPart) ? contextPart.slice() : {
                    ...contextPart
                });
                copy[key] = {
                    xstate$$type: $69ff85b27d828958$export$3d8c2f653ac9d0b9,
                    id: value.id
                };
            } else {
                const result = $69ff85b27d828958$var$persistContext(value);
                if (result !== value) {
                    copy ?? (copy = Array.isArray(contextPart) ? contextPart.slice() : {
                        ...contextPart
                    });
                    copy[key] = result;
                }
            }
        }
    }
    return copy ?? contextPart;
}
function $69ff85b27d828958$var$resolveRaise(_, snapshot, args, actionParams, { event: eventOrExpr, id: id, delay: delay }, { internalQueue: internalQueue }) {
    const delaysMap = snapshot.machine.implementations.delays;
    if (typeof eventOrExpr === 'string') throw new Error(// eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    `Only event objects may be used with raise; use raise({ type: "${eventOrExpr}" }) instead`);
    const resolvedEvent = typeof eventOrExpr === 'function' ? eventOrExpr(args, actionParams) : eventOrExpr;
    let resolvedDelay;
    if (typeof delay === 'string') {
        const configDelay = delaysMap && delaysMap[delay];
        resolvedDelay = typeof configDelay === 'function' ? configDelay(args, actionParams) : configDelay;
    } else resolvedDelay = typeof delay === 'function' ? delay(args, actionParams) : delay;
    if (typeof resolvedDelay !== 'number') internalQueue.push(resolvedEvent);
    return [
        snapshot,
        {
            event: resolvedEvent,
            id: id,
            delay: resolvedDelay
        },
        undefined
    ];
}
function $69ff85b27d828958$var$executeRaise(actorScope, params) {
    const { event: event, delay: delay, id: id } = params;
    if (typeof delay === 'number') {
        actorScope.defer(()=>{
            const self = actorScope.self;
            actorScope.system.scheduler.schedule(self, self, event, delay, id);
        });
        return;
    }
}
/**
 * Raises an event. This places the event in the internal event queue, so that
 * the event is immediately consumed by the machine in the current step.
 *
 * @param eventType The event to raise.
 */ function $69ff85b27d828958$export$c4ce752e73470fba(eventOrExpr, options) {
    function raise(_args, _params) {}
    raise.type = 'xstate.raise';
    raise.event = eventOrExpr;
    raise.id = options?.id;
    raise.delay = options?.delay;
    raise.resolve = $69ff85b27d828958$var$resolveRaise;
    raise.execute = $69ff85b27d828958$var$executeRaise;
    return raise;
}
module.exports["S"] = $69ff85b27d828958$export$25ce5a424b770e84;
module.exports["N"] = $69ff85b27d828958$export$a07804094c3ecf2d;
module.exports["V"] = $69ff85b27d828958$export$e7c866399fa523f5;
module.exports["X"] = $69ff85b27d828958$export$78acf4525d8a74c4;
module.exports["W"] = $69ff85b27d828958$export$71cec2538cb2c617;
module.exports["q"] = $69ff85b27d828958$export$9e5f44173e64f162;
module.exports["v"] = $69ff85b27d828958$export$90a7f3efeed30595;
module.exports["m"] = $69ff85b27d828958$export$953cecd6e717a553;
module.exports["t"] = $69ff85b27d828958$export$625550452a3fa3ec;
module.exports["a"] = $69ff85b27d828958$export$407448d2b89b1813;
module.exports["L"] = $69ff85b27d828958$export$61196ced6d74a310;
module.exports["c"] = $69ff85b27d828958$export$db3b6bfb95261072;
module.exports["z"] = $69ff85b27d828958$export$df995fae86a55f06;
module.exports["$"] = $69ff85b27d828958$export$3d8c2f653ac9d0b9;
module.exports["T"] = $69ff85b27d828958$export$971d5caa766a69d7;
module.exports["A"] = $69ff85b27d828958$export$ebd11618f299a286;
module.exports["M"] = $69ff85b27d828958$export$3a1a48c8f6ef640e;
module.exports["U"] = $69ff85b27d828958$export$3a6d5c9ae78a2c08;
module.exports["P"] = $69ff85b27d828958$export$56c0d5a1e737357d;
module.exports["R"] = $69ff85b27d828958$export$db202ddc8be9136;
module.exports["w"] = $69ff85b27d828958$export$efccba1c4a2ef57b;
module.exports["e"] = $69ff85b27d828958$export$f1e1789686576879;
module.exports["i"] = $69ff85b27d828958$export$23f2a1d2818174ef;
module.exports["l"] = $69ff85b27d828958$export$882b5998b3b9117c;
module.exports["h"] = $69ff85b27d828958$export$dda1d9f60106f0e9;
module.exports["g"] = $69ff85b27d828958$export$39b482c5e57630a8;
module.exports["O"] = $69ff85b27d828958$export$c4ce752e73470fba;
module.exports["b"] = $69ff85b27d828958$export$8b22cf2602fb60ce;
module.exports["f"] = $69ff85b27d828958$export$2d1720544b23b823;
module.exports["d"] = $69ff85b27d828958$export$4368d992c4eafac0;
module.exports["x"] = $69ff85b27d828958$export$d141bba7fdc215a3;
module.exports["u"] = $69ff85b27d828958$export$3b14a55fb2447963;
module.exports["j"] = $69ff85b27d828958$export$35e795649ee09318;
module.exports["o"] = $69ff85b27d828958$export$ae1af26003f05816;
module.exports["s"] = $69ff85b27d828958$export$2408f22a0fab9ae5;
module.exports["p"] = $69ff85b27d828958$export$ffb5f4729a158638;
module.exports["n"] = $69ff85b27d828958$export$7ccc53e8f1e7dfc5;
module.exports["r"] = $69ff85b27d828958$export$43caf9889c228507;
module.exports["k"] = $69ff85b27d828958$export$342063e11d6c3cad;
module.exports["y"] = $69ff85b27d828958$export$4a5767248b18ef41;

});

parcelRegister("e6Soq", function(module, exports) {
// From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis
function $a45bd1884ca79325$export$a4e55266d2135a7f() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
}
function $a45bd1884ca79325$var$getDevTools() {
    const w = $a45bd1884ca79325$export$a4e55266d2135a7f();
    if (w.__xstate__) return w.__xstate__;
    return undefined;
}
function $a45bd1884ca79325$export$4d7a7d14704ebc13(service) {
    if (typeof window === 'undefined') return;
    const devTools = $a45bd1884ca79325$var$getDevTools();
    if (devTools) devTools.register(service);
}
const $a45bd1884ca79325$export$3ee8010769463234 = (service)=>{
    if (typeof window === 'undefined') return;
    const devTools = $a45bd1884ca79325$var$getDevTools();
    if (devTools) devTools.register(service);
};
module.exports["devToolsAdapter"] = $a45bd1884ca79325$export$3ee8010769463234;

});

parcelRegister("kMkDS", function(module, exports) {
const $00de4dd959d7802e$export$f00236a854eaa848 = (content, suggestionContent)=>{
    const updatedContent = Array.isArray(content.content) ? content.content : [
        content.content
    ];
    // Append the new paragraph node
    updatedContent.push({
        type: 'paragraph',
        content: [
            {
                type: 'text',
                text: suggestionContent
            }
        ]
    });
    // Return the updated DocNode
    return {
        ...content,
        content: updatedContent
    };
};
module.exports["appendADFContent"] = $00de4dd959d7802e$export$f00236a854eaa848;

});


//# sourceMappingURL=FullPageEditorComponent.17a42cd4.js.map
